/*
 * AUTO-GENERATED by scripts/generate-chapter.ts.
 * Source: LearningHub / beginner-level2
 * Do not edit by hand — regenerate from extracted JSON + translations.
 */
import type { Chapter, Level } from "../types";

export const CHAPTER_ID = "beginner-level2";

export const CHAPTER: Chapter = {
    id: "beginner-level2",
    title: { zh: "钻石", en: "Diamond" },
    description: {
        zh: "眼位、真假眼与棋形要点",
        en: "Eyeshape, real vs false eyes, key shape points",
    },
};

const bl2SekiLevels: Level[] = [
    {
        id: "beginner-level2-bl2-seki-1",
        chapterId: "beginner-level2",
        order: 1,
        title: { zh: "双活 · 1/13", en: "Seki · 1/13" },
        instruction: { zh: "黑棋有两只眼和6目（5目领地加1个提子）。然而，白棋可以通过在A点落子形成双活来取消这些目数。黑棋无法吃掉角上的两颗白子：如果黑棋在B点应，会让自己的棋子陷入打吃。白先，形成双活。", en: "Black has two eyes and 6 points (5 territory and 1 prisoner). However, White can make seki and cancel these points by playing at A. Black can not capture the two white stones in the corner: Black will put his stones in atari by responding at B. White to play. Make seki." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoapaqbobqcpcqcrcs", white: "anarbncodndpdqdrds" },
            marks: { A: "bs", B: "br" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-2",
        chapterId: "beginner-level2",
        order: 2,
        title: { zh: "双活 · 2/13", en: "Seki · 2/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndocpepfpcqfqcrfrcsfs", white: "eofogodpgpdqgqdrgrgs" },
            marks: { triangle: "dpdqdr" },
            correct: ["ds"],
            wrong: ["erds", "esds", "eqds"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-3",
        chapterId: "beginner-level2",
        order: 3,
        title: { zh: "双活 · 3/13", en: "Seki · 3/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbndnencofogoepaqbqcqdqfq", white: "bmcmdmemfmfneoapbpcpdp" },
            marks: { triangle: "eoapbpcpdp" },
            correct: ["docnam"],
            wrong: ["amdo", "bodo", "aodo"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-4",
        chapterId: "beginner-level2",
        order: 4,
        title: { zh: "双活 · 4/13", en: "Seki · 4/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aoboapcpbqcqcrcs", white: "anbncncodpdqbrdrbsds" },
            marks: { triangle: "brbs" },
            correct: ["ar"],
            wrong: ["aqar", "asar"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-5",
        chapterId: "beginner-level2",
        order: 5,
        title: { zh: "双活 · 5/13", en: "Seki · 5/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbncndneoepbqcqdqarbs", white: "blclcmdmemencodoapbpcpaq" },
            marks: { triangle: "aqcpbpapdoco" },
            correct: ["ao"],
            wrong: ["alao", "bodp", "dpao"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-6",
        chapterId: "beginner-level2",
        order: 6,
        title: { zh: "双活 · 6/13", en: "Seki · 6/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqcrdrercses", white: "apbpcpdqeqfqfrbsfs" },
            marks: { triangle: "bs" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-7",
        chapterId: "beginner-level2",
        order: 7,
        title: { zh: "双活 · 7/13", en: "Seki · 7/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boapbpcpcqbrcrdrds", white: "anbncnaocodpaqdqfqareres" },
            marks: { triangle: "araq" },
            correct: ["bs"],
            wrong: ["asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-8",
        chapterId: "beginner-level2",
        order: 8,
        title: { zh: "双活 · 8/13", en: "Seki · 8/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpbqeqfqbrfrgrhrbsfshs", white: "epfpcqdqgqhqiqcrircsdsis" },
            marks: { triangle: "cqdqcrcsds" },
            correct: ["er"],
            wrong: ["eser", "drer"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-9",
        chapterId: "beginner-level2",
        order: 9,
        title: { zh: "双活 · 9/13", en: "Seki · 9/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepaqbqcqeqcrdrerds", white: "cndoeofoapbpcpfpfqbrfrbsesfs" },
            marks: { triangle: "brbs" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-10",
        chapterId: "beginner-level2",
        order: 10,
        title: { zh: "双活 · 10/13", en: "Seki · 10/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stone." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fncodoeogodpdqarbrcrerfrgrhrbsfshs", white: "bnboapcpaqbqcqeqfqgqhqiqkqdriris" },
            marks: { triangle: "dr" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-11",
        chapterId: "beginner-level2",
        order: 11,
        title: { zh: "双活 · 11/13", en: "Seki · 11/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndndoapbpdpfpbqeqarbrfrfs", white: "aobococpcqdqcrerbsds" },
            marks: { triangle: "aobococpcqdqcrerbsds" },
            correct: ["es"],
            wrong: ["ascsbses", "cses"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-12",
        chapterId: "beginner-level2",
        order: 12,
        title: { zh: "双活 · 12/13", en: "Seki · 12/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnaobocodoepeqarbrcrdrer", white: "clbmcndneneodpaqbqcqdq" },
            marks: { triangle: "dpaqbqcqdq" },
            correct: ["amcpan"],
            wrong: ["cpbp", "bpap", "apbp", "anamcpbp", "anambpap", "anamapbp", "anamalcp"],
        },
    },
    {
        id: "beginner-level2-bl2-seki-13",
        chapterId: "beginner-level2",
        order: 13,
        title: { zh: "双活 · 13/13", en: "Seki · 13/13" },
        instruction: { zh: "白先。形成双活并救出标记的棋子。", en: "White to play. Make seki and rescue the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmcndodpaqbqdqbrdrbsds", white: "anbnaocobpcpcqcrcs" },
            marks: { triangle: "anbnaocobpcpcqcrcs" },
            correct: ["as", "ar"],
            wrong: ["apbo"],
        },
    },
];

const bl2AtariLevels: Level[] = [
    {
        id: "beginner-level2-bl2-atari-1",
        chapterId: "beginner-level2",
        order: 14,
        title: { zh: "打吃 · 1/12", en: "Atari · 1/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcncoapbpbq", white: "bnbocpcqeqarbr" },
            marks: { triangle: "apbpbq" },
            correct: ["aq"],
            wrong: ["aoan"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-2",
        chapterId: "beginner-level2",
        order: 15,
        title: { zh: "打吃 · 2/12", en: "Atari · 2/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它。", en: "White to play. Put the marked stone in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndpbqcqdrer", white: "bpcpfpdqeqfr" },
            marks: { triangle: "dp" },
            correct: ["do"],
            wrong: ["epdo"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-3",
        chapterId: "beginner-level2",
        order: 16,
        title: { zh: "打吃 · 3/12", en: "Atari · 3/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnenaocobpcqcr", white: "cpdpbqdqhqdr" },
            marks: { triangle: "cqcr" },
            correct: ["br"],
            wrong: ["csbr"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-4",
        chapterId: "beginner-level2",
        order: 17,
        title: { zh: "打吃 · 4/12", en: "Atari · 4/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它。", en: "White to play. Put the marked stone in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgpeqgqgr", white: "dpepcqfqfr" },
            marks: { triangle: "eq" },
            correct: ["er"],
            wrong: ["dqer"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-5",
        chapterId: "beginner-level2",
        order: 18,
        title: { zh: "打吃 · 5/12", en: "Atari · 5/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbododpbqcq", white: "cpdqeqbrcr" },
            marks: { triangle: "bqcq" },
            correct: ["bp"],
            wrong: ["aqbp"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-6",
        chapterId: "beginner-level2",
        order: 19,
        title: { zh: "打吃 · 6/12", en: "Atari · 6/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnbobpcqdqeq", white: "coapcpbqarcrdr" },
            marks: { triangle: "bobp" },
            correct: ["bn"],
            wrong: ["aobn"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-7",
        chapterId: "beginner-level2",
        order: 20,
        title: { zh: "打吃 · 7/12", en: "Atari · 7/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpaqcqeqfqardrbsds", white: "dodpepdqbrcrer" },
            marks: { triangle: "drds" },
            correct: ["es"],
            wrong: ["csbq"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-8",
        chapterId: "beginner-level2",
        order: 21,
        title: { zh: "打吃 · 8/12", en: "Atari · 8/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfndobpdpcqeqfqcr", white: "dmcnencocpdqdrer" },
            marks: { triangle: "dndodp" },
            correct: ["ep"],
            wrong: ["eoep"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-9",
        chapterId: "beginner-level2",
        order: 22,
        title: { zh: "打吃 · 9/12", en: "Atari · 9/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcnaodoeoapcpbqdq", white: "clembndnbocobp" },
            marks: { triangle: "cmcn" },
            correct: ["bm"],
            wrong: ["dmbm"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-10",
        chapterId: "beginner-level2",
        order: 23,
        title: { zh: "打吃 · 10/12", en: "Atari · 10/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndoeocpepcqfqgqbrcr", white: "embocofobpdpfpbqdqeq" },
            marks: { triangle: "doeoep" },
            correct: ["dn"],
            wrong: ["endn"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-11",
        chapterId: "beginner-level2",
        order: 24,
        title: { zh: "打吃 · 11/12", en: "Atari · 11/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldlbmdmdndobpcp", white: "cmcncodpepbqcq" },
            marks: { triangle: "bpcp" },
            correct: ["bo"],
            wrong: ["apbo"],
        },
    },
    {
        id: "beginner-level2-bl2-atari-12",
        chapterId: "beginner-level2",
        order: 25,
        title: { zh: "打吃 · 12/12", en: "Atari · 12/12" },
        instruction: { zh: "白先。在正确的一侧打吃标记的棋子并吃掉它们。", en: "White to play. Put the marked stones in atari at the correct side and capture them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqgqerfr", white: "codoepcqfqdr" },
            marks: { triangle: "dpdq" },
            correct: ["eq"],
            wrong: ["cpeq"],
        },
    },
];

const bl2ChaseDownLevels: Level[] = [
    {
        id: "beginner-level2-bl2-chase-down-1",
        chapterId: "beginner-level2",
        order: 26,
        title: { zh: "追杀 · 1/12", en: "Chase Down · 1/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofocpdpgpcqhqgr", white: "codobpepfpdqfqgqer" },
            marks: { triangle: "gqfqfpep" },
            correct: ["freqdr", "freqes"],
            wrong: ["freqcrhp", "drfreqhr"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-2",
        chapterId: "beginner-level2",
        order: 27,
        title: { zh: "追杀 · 2/12", en: "Chase Down · 2/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnenfocpdpepfpaqbq", white: "clcmfmbnfnaocodoeoapbp" },
            marks: { triangle: "codoeo" },
            correct: ["cnbobm"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-3",
        chapterId: "beginner-level2",
        order: 28,
        title: { zh: "追杀 · 3/12", en: "Chase Down · 3/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeogobpepfpbqfqbrdrfrbs", white: "bncndnbocpdpgpcqgqcrergrdsfsgs" },
            marks: { triangle: "cpdpcqcr" },
            correct: ["csdqeq"],
            wrong: ["dqeq", "eqcs"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-4",
        chapterId: "beginner-level2",
        order: 29,
        title: { zh: "追杀 · 4/12", en: "Chase Down · 4/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlambmcncocpbqcq", white: "bnaobobpfpaqdqbrcrer" },
            marks: { triangle: "bnaobobp" },
            correct: ["an"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-5",
        chapterId: "beginner-level2",
        order: 30,
        title: { zh: "追杀 · 5/12", en: "Chase Down · 5/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqeqfqgqhqdrhrhs", white: "bocpcqcrerfrgrds" },
            marks: { triangle: "erfrgr" },
            correct: ["esfsgs"],
            wrong: ["cses", "gses", "fses"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-6",
        chapterId: "beginner-level2",
        order: 31,
        title: { zh: "追杀 · 6/12", en: "Chase Down · 6/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodoeoepdqcrdr", white: "bpcpdpfpaqcqeqgqbrer" },
            marks: { triangle: "bpcpdpcq" },
            correct: ["apbqbs"],
            wrong: ["apbqcsbs", "bsds"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-7",
        chapterId: "beginner-level2",
        order: 32,
        title: { zh: "追杀 · 7/12", en: "Chase Down · 7/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnendofocpcqgqcrdr", white: "cncoeobpdpbqdqfqbrer" },
            marks: { triangle: "eodpdq" },
            correct: ["eqepfpeqfr", "eqepfpeqes"],
            wrong: ["eqepescs", "epeq", "fpeq"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-8",
        chapterId: "beginner-level2",
        order: 33,
        title: { zh: "追杀 · 8/12", en: "Chase Down · 8/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmandneocpdpaq", white: "bncnaocobpcqdqeqbr" },
            marks: { triangle: "bncnco" },
            correct: ["dobobq", "bqardo"],
            wrong: ["doboapbq", "apbobqar", "apbodobq"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-9",
        chapterId: "beginner-level2",
        order: 34,
        title: { zh: "追杀 · 9/12", en: "Chase Down · 9/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpepbqcqeqhqdrcsds", white: "clbncnbobpaqbrcras" },
            marks: { triangle: "brcras" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-10",
        chapterId: "beginner-level2",
        order: 35,
        title: { zh: "追杀 · 10/12", en: "Chase Down · 10/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmdnboeocpepbqcqdqeqbrdr", white: "enfnfoapbpfpaqfqarcrerfrbscsds" },
            marks: { triangle: "apbpaqar" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-11",
        chapterId: "beginner-level2",
        order: 36,
        title: { zh: "追杀 · 11/12", en: "Chase Down · 11/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcldlelflbmcndndobpcpdp", white: "cmdmemanbnenbocoapfpbqcqdqfq" },
            marks: { triangle: "anbnboco" },
            correct: ["am"],
        },
    },
    {
        id: "beginner-level2-bl2-chase-down-12",
        chapterId: "beginner-level2",
        order: 37,
        title: { zh: "追杀 · 12/12", en: "Chase Down · 12/12" },
        instruction: { zh: "黑先。追击标记的棋子。", en: "Black to play. Chase down the marked stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnaoboapdpbqcrdr", white: "bmcmbncodobpcpdq" },
            marks: { triangle: "codobpcp" },
            correct: ["eoepcqdpfpeqfq", "eoepcqdpfpeqerfqgq"],
            wrong: ["eoepcqdpfpeqerfqfrgq", "eoepcqdpeqfp", "eoepfpen", "cqeo", "epeofoen"],
        },
    },
];

const bl2SnapbackLevels: Level[] = [
    {
        id: "beginner-level2-bl2-snapback-1",
        chapterId: "beginner-level2",
        order: 38,
        title: { zh: "倒扑 · 1/24", en: "Snapback · 1/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndneodpepbqcqfq", white: "cmdmbnfnbodocp" },
            correct: ["en"],
            wrong: ["coen"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-2",
        chapterId: "beginner-level2",
        order: 39,
        title: { zh: "倒扑 · 2/24", en: "Snapback · 2/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bndnboapcpcq", white: "codpaqdqbrcr" },
            correct: ["bp"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-3",
        chapterId: "beginner-level2",
        order: 40,
        title: { zh: "倒扑 · 3/24", en: "Snapback · 3/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmdmanbobpaqbqcrdr", white: "bncncocpcqeqfqarbr" },
            correct: ["ao"],
            wrong: ["apao"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-4",
        chapterId: "beginner-level2",
        order: 41,
        title: { zh: "倒扑 · 4/24", en: "Snapback · 4/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmanenaoeobpepbqcrdr", white: "bnbodocpcqarbrbs" },
            correct: ["ap"],
            wrong: ["aqap"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-5",
        chapterId: "beginner-level2",
        order: 42,
        title: { zh: "倒扑 · 5/24", en: "Snapback · 5/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqdqfqcrergrds", white: "bocoapdpepaqeqbr" },
            correct: ["cq"],
            wrong: ["cpcq"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-6",
        chapterId: "beginner-level2",
        order: 43,
        title: { zh: "倒扑 · 6/24", en: "Snapback · 6/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpdqfqardrgrasbscsds", white: "aobocodpepcqbr" },
            correct: ["aq"],
            wrong: ["bqaq"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-7",
        chapterId: "beginner-level2",
        order: 44,
        title: { zh: "倒扑 · 7/24", en: "Snapback · 7/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcqdqfqgqbrdrer", white: "aobocpdpepeqarfr" },
            correct: ["bq"],
            wrong: ["aqbq"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-8",
        chapterId: "beginner-level2",
        order: 45,
        title: { zh: "倒扑 · 8/24", en: "Snapback · 8/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "emdnfndogodpeqfq", white: "dldmcncofocpepcqdq" },
            correct: ["en"],
            wrong: ["eoen"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-9",
        chapterId: "beginner-level2",
        order: 46,
        title: { zh: "倒扑 · 9/24", en: "Snapback · 9/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfpaqdqgqarbrdrcsds", white: "codoapcpbqcqcr" },
            correct: ["bs"],
            wrong: ["asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-10",
        chapterId: "beginner-level2",
        order: 47,
        title: { zh: "倒扑 · 10/24", en: "Snapback · 10/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fndofohodpepeqhqergrfs", white: "dnencoeocpfpcqdqgqdrdses" },
            correct: ["fr"],
            wrong: ["fqfr"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-11",
        chapterId: "beginner-level2",
        order: 48,
        title: { zh: "倒扑 · 11/24", en: "Snapback · 11/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dngncobpgpbqgqcrdrergrfsgs", white: "docqdqeqfqarbrfrcs" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-12",
        chapterId: "beginner-level2",
        order: 49,
        title: { zh: "倒扑 · 12/24", en: "Snapback · 12/24" },
        instruction: { zh: "白先。用倒扑尽可能多地吃子。", en: "White to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnendofogobpdpgpcqgqbrdr", white: "dmemcnfncocpfpdqeq" },
            correct: ["eo"],
            wrong: ["epeo"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-13",
        chapterId: "beginner-level2",
        order: 50,
        title: { zh: "倒扑 · 13/24", en: "Snapback · 13/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "elembncnendobpcpdpgpdqfqerfr", white: "dkekfkbmcmdmdnfneogoepbqcqeqbrdrcs" },
            correct: ["fo"],
            wrong: ["fpfo", "fmfo"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-14",
        chapterId: "beginner-level2",
        order: 51,
        title: { zh: "倒扑 · 14/24", en: "Snapback · 14/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodoeoepdqarcrdr", white: "apbpcpdpcqeqbrerbs" },
            correct: ["bq"],
            wrong: ["aqbq", "esds"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-15",
        chapterId: "beginner-level2",
        order: 52,
        title: { zh: "倒扑 · 15/24", en: "Snapback · 15/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dkdmemcnfnbocofobpfpeqer", white: "bmcmfmgmbndnengneocpephpbqdqfqgqdr" },
            correct: ["dp"],
            wrong: ["dodp"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-16",
        chapterId: "beginner-level2",
        order: 53,
        title: { zh: "倒扑 · 16/24", en: "Snapback · 16/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncpepbqeqcrdr", white: "dmemcoeobpdpdq" },
            correct: ["do"],
            wrong: ["cqdo", "bodo"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-17",
        chapterId: "beginner-level2",
        order: 54,
        title: { zh: "倒扑 · 17/24", en: "Snapback · 17/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpepfpbqcqdqgqcrerds", white: "bncodoeoapbpdpaqbrbscs" },
            correct: ["ar"],
            wrong: ["asar"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-18",
        chapterId: "beginner-level2",
        order: 55,
        title: { zh: "倒扑 · 18/24", en: "Snapback · 18/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnencoeoepeqarbrcrdr", white: "cldmbncndodpaqbqcqdq" },
            correct: ["bpboap"],
            wrong: ["bpbocpap", "cpbo", "apbpaobo", "apbpboao", "boaobpan"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-19",
        chapterId: "beginner-level2",
        order: 56,
        title: { zh: "倒扑 · 19/24", en: "Snapback · 19/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmemcnenbobpdpcqbr", white: "clbmbndncodoepdqfqcrerbs" },
            correct: ["eo"],
            wrong: ["cpeo"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-20",
        chapterId: "beginner-level2",
        order: 57,
        title: { zh: "倒扑 · 20/24", en: "Snapback · 20/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmdmeneobpepbqcqdq", white: "aobododpeqfqbrcrdr" },
            correct: ["cocndn", "cocncpdnbn"],
            wrong: ["cocncpdncmbn", "dnco", "cnco", "cpco"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-21",
        chapterId: "beginner-level2",
        order: 58,
        title: { zh: "倒扑 · 21/24", en: "Snapback · 21/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emenfocpfpcqeqdrer", white: "elfldmdngncoeoepdqfqgq" },
            correct: ["do"],
            wrong: ["dpdo"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-22",
        chapterId: "beginner-level2",
        order: 59,
        title: { zh: "倒扑 · 22/24", en: "Snapback · 22/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndnenfngncogocpcqdrerfr", white: "doeofohodpgphpbqdqeqarcrhrbs" },
            correct: ["fpfqgq"],
            wrong: ["fqfp", "epfp"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-23",
        chapterId: "beginner-level2",
        order: 60,
        title: { zh: "倒扑 · 23/24", en: "Snapback · 23/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "docpbqdqeqfqbrfrcs", white: "dnboeobpgpcqgqcrdrergrfsgs" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level2-bl2-snapback-24",
        chapterId: "beginner-level2",
        order: 61,
        title: { zh: "倒扑 · 24/24", en: "Snapback · 24/24" },
        instruction: { zh: "黑先。用倒扑尽可能多地吃子。", en: "Black to play. Capture as many stones as possible with a snapback." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcmbndnbobpgpbqeqfqgqcrdr", white: "dmemcnfncogocpepfpcqdq" },
            correct: ["eofodp"],
            wrong: ["eofododp", "dpdo", "dodpeofo", "dodpfoeo", "foeo"],
        },
    },
];

const bl2NetLevels: Level[] = [
    {
        id: "beginner-level2-bl2-net-1",
        chapterId: "beginner-level2",
        order: 62,
        title: { zh: "罩 · 1/12", en: "Net · 1/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elgmdnbodocpfphpcqcr", white: "cmcncoeodpdqdr" },
            correct: ["em"],
            wrong: ["dmenemfn", "dmenfnem", "dmenfmem", "endm"],
        },
    },
    {
        id: "beginner-level2-bl2-net-2",
        chapterId: "beginner-level2",
        order: 63,
        title: { zh: "罩 · 2/12", en: "Net · 2/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcmfmboeobpcpepdqbrcrdr", white: "dncododpfpbqcqeqer" },
            correct: ["fn"],
            wrong: ["bnen", "enfo", "foen"],
        },
    },
    {
        id: "beginner-level2-bl2-net-3",
        chapterId: "beginner-level2",
        order: 64,
        title: { zh: "罩 · 3/12", en: "Net · 3/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clelfmbodoapcpcqcr", white: "bncncodpdqfq" },
            correct: ["eneofo"],
            wrong: ["eodnemen", "eodndmen", "dneo", "fnen"],
        },
    },
    {
        id: "beginner-level2-bl2-net-4",
        chapterId: "beginner-level2",
        order: 65,
        title: { zh: "罩 · 4/12", en: "Net · 4/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gnbpephpbqcqdqhqdr", white: "cnbocpdpeqfq" },
            correct: ["foeoendoco"],
            wrong: ["foeoendodnco", "foeofpen", "eofpfogp", "eofpgpfo", "eofpgogp", "fpeofnfogoen", "enfo"],
        },
    },
    {
        id: "beginner-level2-bl2-net-5",
        chapterId: "beginner-level2",
        order: 66,
        title: { zh: "罩 · 5/12", en: "Net · 5/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmboeohoapcpepbqdqhqdr", white: "dmbncododpfpeqer" },
            correct: ["fn"],
            wrong: ["foenemfn", "foenfnem", "enfogofn", "enfofngo", "enfogngo"],
        },
    },
    {
        id: "beginner-level2-bl2-net-6",
        chapterId: "beginner-level2",
        order: 67,
        title: { zh: "罩 · 6/12", en: "Net · 6/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbncnbohocpdpepdqhqerfrgr", white: "dncodoapbpcqeqfqgqbrdr" },
            correct: ["fo"],
            wrong: ["gogp", "eofpgpfofngo", "eofpgpfogofn", "eofpfogp", "fpeoenfo"],
        },
    },
    {
        id: "beginner-level2-bl2-net-7",
        chapterId: "beginner-level2",
        order: 68,
        title: { zh: "罩 · 7/12", en: "Net · 7/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clelgldoeocpepcqbrdr", white: "cncofodpdqeqfq" },
            correct: ["en"],
            wrong: ["dnenemfm", "fpen", "emfnenfp", "emfnfpen", "fmemendn"],
        },
    },
    {
        id: "beginner-level2-bl2-net-8",
        chapterId: "beginner-level2",
        order: 69,
        title: { zh: "罩 · 8/12", en: "Net · 8/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlelbmcmdmcpdpeqfqhqcrdr", white: "emfmdneogoepbqcqdq" },
            correct: ["bo"],
            wrong: ["bpcocnbobnan", "cobpbobr", "cobpbrbobnan", "dobocobpbnan", "dobobpco"],
        },
    },
    {
        id: "beginner-level2-bl2-net-9",
        chapterId: "beginner-level2",
        order: 70,
        title: { zh: "罩 · 9/12", en: "Net · 9/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hobpepbqcqdqhqcrerds", white: "cnbocpdpeqfqfr" },
            correct: ["foeoendoco"],
            wrong: ["foeoendodnco", "eofpgpfofngo", "eofpgpfogofn", "fpeo"],
        },
    },
    {
        id: "beginner-level2-bl2-net-10",
        chapterId: "beginner-level2",
        order: 71,
        title: { zh: "罩 · 10/12", en: "Net · 10/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elglcmgnbodoepfpgpfr", white: "eneobpcpdpcqbrdrcs" },
            correct: ["cncobn"],
            wrong: ["cncodnbn", "codnbnem", "dncocnbn", "bndncnem"],
        },
    },
    {
        id: "beginner-level2-bl2-net-11",
        chapterId: "beginner-level2",
        order: 72,
        title: { zh: "罩 · 11/12", en: "Net · 11/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bldlfmfnaodofoapfpbqcqdqeq", white: "gngobpcpgpaqfqgqarbrcrdrer" },
            correct: ["bn"],
            wrong: ["cnam", "cobn", "boanbmam", "boanambnbmcn", "boanambncnbm", "anbobnco", "anbocnco", "anbocobn"],
        },
    },
    {
        id: "beginner-level2-bl2-net-12",
        chapterId: "beginner-level2",
        order: 73,
        title: { zh: "罩 · 12/12", en: "Net · 12/12" },
        instruction: { zh: "白先。用罩尽可能多地吃子。", en: "White to play. Capture as many stones as possible in a net." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpepfpdqfqcrdr", white: "cndodpcqeqgqerfrgr" },
            correct: ["go"],
            wrong: ["fogphohpipgognhniofn", "gpfo", "eogo"],
        },
    },
];

const bl2Capture1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capture-1-1",
        chapterId: "beginner-level2",
        order: 74,
        title: { zh: "提子 1 · 1/24", en: "Capture 1 · 1/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbncnencodpdqfqer", white: "bodoeobpcpcqcrdr" },
            correct: ["fo"],
            wrong: ["dnfo", "epfo", "fnfpgpeq", "fnfpfoep", "fnfpeqgp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-2",
        chapterId: "beginner-level2",
        order: 75,
        title: { zh: "提子 1 · 2/24", en: "Capture 1 · 2/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmemfneo", white: "cldlelfmgmdnenhngo" },
            correct: ["cndodp"],
            wrong: ["docn", "cocn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-3",
        chapterId: "beginner-level2",
        order: 76,
        title: { zh: "提子 1 · 3/24", en: "Capture 1 · 3/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfocpfpcqeqdr", white: "dncoeoepdq" },
            correct: ["do"],
            wrong: ["dpdo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-4",
        chapterId: "beginner-level2",
        order: 77,
        title: { zh: "提子 1 · 4/24", en: "Capture 1 · 4/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eocpfp", white: "dmfnfoephp" },
            correct: ["eqdpdodqdr"],
            wrong: ["eqdpdodqcqdr", "eqdpdqdo", "dofq", "fqdo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-5",
        chapterId: "beginner-level2",
        order: 78,
        title: { zh: "提子 1 · 5/24", en: "Capture 1 · 5/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeocpbqbrerbscs", white: "dpgpcqeqgqcrdrds" },
            correct: ["esdqfq"],
            wrong: ["epfr", "fqfrepes"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-6",
        chapterId: "beginner-level2",
        order: 79,
        title: { zh: "提子 1 · 6/24", en: "Capture 1 · 6/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmdnbocoeobpepeqdr", white: "enfndofocpdpfpbqfqarcrfrbs" },
            correct: ["cq"],
            wrong: ["dqcq"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-7",
        chapterId: "beginner-level2",
        order: 80,
        title: { zh: "提子 1 · 7/24", en: "Capture 1 · 7/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpfpcqdqeq", white: "bncobpdpep" },
            correct: ["do"],
            wrong: ["bqao", "cndo", "apao"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-8",
        chapterId: "beginner-level2",
        order: 81,
        title: { zh: "提子 1 · 8/24", en: "Capture 1 · 8/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcododpfpeqfqhq", white: "flgmboeohobpcpepdqbrdr" },
            correct: ["fnenem"],
            wrong: ["fnenfoem", "fnendnem", "enfogofn", "enfofngo", "foenemfn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-9",
        chapterId: "beginner-level2",
        order: 82,
        title: { zh: "提子 1 · 9/24", en: "Capture 1 · 9/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnencocpcq", white: "dlelcmfmcndodpgqfr" },
            correct: ["eqdqdrepfp"],
            wrong: ["epdqeqdreres", "epdqeqdrcrer", "epdqdreq", "eoeq", "dqepfpeq", "dqepeqfp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-10",
        chapterId: "beginner-level2",
        order: 83,
        title: { zh: "提子 1 · 10/24", en: "Capture 1 · 10/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmemfnfoeper", white: "fmgmdneneofpgp" },
            correct: ["cndodpcobo"],
            wrong: ["cndocodp", "docn", "dpgo", "cogo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-11",
        chapterId: "beginner-level2",
        order: 84,
        title: { zh: "提子 1 · 11/24", en: "Capture 1 · 11/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmemfnfodpep", white: "elfmgmdnendoeofpfqdr" },
            correct: ["cncobocpcq"],
            wrong: ["cncobocpbpcq", "cncocpbo", "cocnbncmcldl", "cocnbncmdlgo", "cocncmbn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-12",
        chapterId: "beginner-level2",
        order: 85,
        title: { zh: "提子 1 · 12/24", en: "Capture 1 · 12/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocoapcpdpbqeqfqarfrfs", white: "anbncndneoepcqdqbrcreres" },
            correct: ["dsdrbs"],
            wrong: ["drdsbsdo", "bscsdsasdraq", "bscsasaqardo", "csbsdsdrcsdo", "csbsdsdrdsdo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-13",
        chapterId: "beginner-level2",
        order: 86,
        title: { zh: "提子 1 · 13/24", en: "Capture 1 · 13/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncobpbqeqdr", white: "ambmcmdndoapcp" },
            correct: ["bo"],
            wrong: ["cqaqaobobrcr", "cqaqaobocrbrbsdscsdp", "cqaqaobocrbrcsbs", "cqaqbrao", "cqaqboao", "aobocqaqbrcr", "aobocqaqcrbrbsdscsdp", "aoboaqcq"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-14",
        chapterId: "beginner-level2",
        order: 87,
        title: { zh: "提子 1 · 14/24", en: "Capture 1 · 14/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpephpbqcqfqgqcrhr", white: "bpcpfpgpdqeq" },
            correct: ["eododncobocncm"],
            wrong: ["eododncobocnbncm", "eododncocnbo", "eodocodn", "doeoenfogofnfmgnhoer", "doeoenfofngo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-15",
        chapterId: "beginner-level2",
        order: 88,
        title: { zh: "提子 1 · 15/24", en: "Capture 1 · 15/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cserdrbrgqbqapcoboao", white: "crdqcqaqdpdocnbnan" },
            correct: ["bparcpaqbs"],
            wrong: ["cpbp", "aras"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-16",
        chapterId: "beginner-level2",
        order: 89,
        title: { zh: "提子 1 · 16/24", en: "Capture 1 · 16/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcmdnaobodocpdpaqbq", white: "anbncncocqeqarbrcr" },
            correct: ["bp"],
            wrong: ["apbp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-17",
        chapterId: "beginner-level2",
        order: 90,
        title: { zh: "提子 1 · 17/24", en: "Capture 1 · 17/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bodoeohoapcpgpcqfqcrdr", white: "fmbncndncodpdqeqer" },
            correct: ["foenem"],
            wrong: ["enfo", "fpfo", "frfo", "bqbr", "fnfo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-18",
        chapterId: "beginner-level2",
        order: 91,
        title: { zh: "提子 1 · 18/24", en: "Capture 1 · 18/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gndodpfpeqer", white: "dneocpdq" },
            correct: ["epcobocncm"],
            wrong: ["coep"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-19",
        chapterId: "beginner-level2",
        order: 92,
        title: { zh: "提子 1 · 19/24", en: "Capture 1 · 19/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnfncodobpbqcqdqfr", white: "cmbnbocpdpep" },
            correct: ["eneofo"],
            wrong: ["eodndmen", "eodnendmdlemelfm", "eodnendmdlemfmelekfl", "dneo", "dmeo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-20",
        chapterId: "beginner-level2",
        order: 93,
        title: { zh: "提子 1 · 20/24", en: "Capture 1 · 20/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enfncodoeqcrdr", white: "cndneodp" },
            correct: ["bocpcqbpbq"],
            wrong: ["bocpcqbpapbq", "cpbobnep", "cpbobpep", "bpep"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-21",
        chapterId: "beginner-level2",
        order: 94,
        title: { zh: "提子 1 · 21/24", en: "Capture 1 · 21/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmephpfqgq", white: "fpcqdqeq" },
            correct: ["eodpdocpbpcocnbobn"],
            wrong: ["eodpdocpbpcocnboaobn", "eodpdocpbpcobocn", "eodpdocpcobpbofo", "eodpdocpcobpbqfo", "eodpcpdodncobocn", "eodpcpdodncocnbobnfo", "eodpcpdodncocnbobpfo", "dpeo", "doeoenfo", "doeofoen", "doeodpen"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-22",
        chapterId: "beginner-level2",
        order: 95,
        title: { zh: "提子 1 · 22/24", en: "Capture 1 · 22/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpepfpcqeqgqhqbrdr", white: "doeofogodpgpdqcr" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-23",
        chapterId: "beginner-level2",
        order: 96,
        title: { zh: "提子 1 · 23/24", en: "Capture 1 · 23/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnboeodpepbqcq", white: "bmcmdmbnaodobpcp" },
            correct: ["en"],
            wrong: ["coen"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-1-24",
        chapterId: "beginner-level2",
        order: 97,
        title: { zh: "提子 1 · 24/24", en: "Capture 1 · 24/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docpephpeqfrgr", white: "eobpfpfqbrdrer" },
            correct: ["dpdqcqdpdncocn", "dpdqcqdpdncobocncm"],
            wrong: ["dpdqcqdpdncobocnbncm", "dpdqcqdpcodn", "dpdqdnfo", "dqdp", "cqdp"],
        },
    },
];

const bl2Capture2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capture-2-1",
        chapterId: "beginner-level2",
        order: 98,
        title: { zh: "提子 2 · 1/24", en: "Capture 2 · 1/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeocpaqcqeqbrcrcsdses", white: "bndncobpdpepbqdqerfs" },
            correct: ["fpfqdreqgq", "apbofpfqdreqgq"],
            wrong: ["fpfqgqfo", "fqfpfrgq", "apboenfq", "frfq"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-2",
        chapterId: "beginner-level2",
        order: 99,
        title: { zh: "提子 2 · 2/24", en: "Capture 2 · 2/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqfqdrer", white: "bmcmdmdqeqfrgr" },
            correct: ["epdpdocpbpcocnbobn", "gqhqepdpdocpbpcocnbobn"],
            wrong: ["epdpdocpbpcocnboaobn", "epdpdocpbpcobocn", "epdpdocpcobp", "epdpcpdo", "dpepeofp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-3",
        chapterId: "beginner-level2",
        order: 100,
        title: { zh: "提子 2 · 3/24", en: "Capture 2 · 3/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cododpdqgqerfr", white: "gocpepcqeqfqcrdrhr" },
            correct: ["foeoen"],
            wrong: ["fpeoenfo", "fpeofoen", "eofp", "gpfo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-4",
        chapterId: "beginner-level2",
        order: 101,
        title: { zh: "提子 2 · 4/24", en: "Capture 2 · 4/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emfnfodpep", white: "fmgmendoeofpfqdr" },
            correct: ["codndmcnbncmcl"],
            wrong: ["codndmcnbncmbmcl", "codndmcncmbn", "codncndm", "dnco", "cngo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-5",
        chapterId: "beginner-level2",
        order: 102,
        title: { zh: "提子 2 · 5/24", en: "Capture 2 · 5/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeoepbqeqbrdrcs", white: "cmcobpdpdqcr" },
            correct: ["cp"],
            wrong: ["cqcp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-6",
        chapterId: "beginner-level2",
        order: 103,
        title: { zh: "提子 2 · 6/24", en: "Capture 2 · 6/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmanbncncocqeqarbr", white: "clcmdnaobodoapcpdpaq" },
            correct: ["bp"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-7",
        chapterId: "beginner-level2",
        order: 104,
        title: { zh: "提子 2 · 7/24", en: "Capture 2 · 7/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmenboeocpepdqdr", white: "bncndndobpdpcqeqbrer" },
            correct: ["an"],
            wrong: ["coao", "crco", "apco", "aocoancpapcr", "aocoancpcrcs"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-8",
        chapterId: "beginner-level2",
        order: 105,
        title: { zh: "提子 2 · 8/24", en: "Capture 2 · 8/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clcmcnfndodpepeqgqfr", white: "ckdkekfldnencocpcqdqerds" },
            correct: ["emdmdl"],
            wrong: ["dmem", "eoem", "elem"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-9",
        chapterId: "beginner-level2",
        order: 106,
        title: { zh: "提子 2 · 9/24", en: "Capture 2 · 9/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndobpdpaqcqdq", white: "bldmdnaobococpbqbr" },
            correct: ["an"],
            wrong: ["apar", "crar"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-10",
        chapterId: "beginner-level2",
        order: 107,
        title: { zh: "提子 2 · 10/24", en: "Capture 2 · 10/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofocpdpgp", white: "codobpepfphr" },
            correct: ["fqeqerdqcqdrcr"],
            wrong: ["fqeqerdqcqdrdscr", "fqeqerdqdrcq", "fqeqdqer", "eqfqfrgq", "eqfqgqfr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-11",
        chapterId: "beginner-level2",
        order: 108,
        title: { zh: "提子 2 · 11/24", en: "Capture 2 · 11/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmemcnfn", white: "elfmgmdneneq" },
            correct: ["eododpcobocpcq"],
            wrong: ["doeofoep", "doeoepfo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-12",
        chapterId: "beginner-level2",
        order: 109,
        title: { zh: "提子 2 · 12/24", en: "Capture 2 · 12/24" },
        instruction: { zh: "黑先。尽可能多地吃子。", en: "Black to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpbqeqfqcrfrfs", white: "bocodoepcqdqbrdrer" },
            correct: ["dscsescrar", "escsdscrar"],
            wrong: ["dscsares", "csaq", "arcsesap", "eoaqfpap", "escsarap"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-13",
        chapterId: "beginner-level2",
        order: 110,
        title: { zh: "提子 2 · 13/24", en: "Capture 2 · 13/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqdqeqcrfrbs", white: "cpdpepfpcqfqbr" },
            correct: ["dr", "araqdr"],
            wrong: ["erdr", "bpar"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-14",
        chapterId: "beginner-level2",
        order: 111,
        title: { zh: "提子 2 · 14/24", en: "Capture 2 · 14/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmepdqeqgqfrgr", white: "fpcqfqdrer" },
            correct: ["eodpdocpbpcocnbobn"],
            wrong: ["eodpdocpbpcocnboaobn", "eodpdocpbpcobocn", "eodpdocpcobp", "eodpcpdocodn", "eodpcpdodncobocn", "eodpcpdodncocnbo", "dpeo", "doeoenfo"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-15",
        chapterId: "beginner-level2",
        order: 112,
        title: { zh: "提子 2 · 15/24", en: "Capture 2 · 15/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncodobpepfpbqfqbrer", white: "eneogocpdpgpcqgqcrfr" },
            correct: ["eqdqfoeqes", "eqdqfoeqdr"],
            wrong: ["eqdqdrgreqfs", "foeqgrdscsbs", "foeqesgr", "drgr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-16",
        chapterId: "beginner-level2",
        order: 113,
        title: { zh: "提子 2 · 16/24", en: "Capture 2 · 16/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmcnhneobpepcqdq", white: "emdodpfpeqgqer" },
            correct: ["fn"],
            wrong: ["enfogofn", "enfofngo", "enfognfngofm", "enfognfnfmgo", "foendnfn", "foenfndn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-17",
        chapterId: "beginner-level2",
        order: 114,
        title: { zh: "提子 2 · 17/24", en: "Capture 2 · 17/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elfmgmdneneocrdr", white: "dmemcnfnfo" },
            correct: ["epdodpcobocpcqbpbq"],
            wrong: ["epdodpcobocpcqbpapbq", "epdodpcobocpbpcq", "epdodpcocpbo", "epdocodpcpdq", "epdocodpdqcpbpcq", "epdocodpdqcpcqbp", "doep", "dpepeqfpgpgo", "coep"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-18",
        chapterId: "beginner-level2",
        order: 115,
        title: { zh: "提子 2 · 18/24", en: "Capture 2 · 18/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fldoeocpfpcqfq", white: "hncofogodpep" },
            correct: ["dnenemfnfm"],
            wrong: ["dnenemfngnfm", "dnenfnem", "endncndm", "endndmcn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-19",
        chapterId: "beginner-level2",
        order: 116,
        title: { zh: "提子 2 · 19/24", en: "Capture 2 · 19/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codqeqdrfrfs", white: "fqgqergrds" },
            correct: ["gs"],
            wrong: ["escs"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-20",
        chapterId: "beginner-level2",
        order: 117,
        title: { zh: "提子 2 · 20/24", en: "Capture 2 · 20/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbmbndnenfnbocofobpdpepbq", white: "cmdmemfmcngndogocpcqdqeqfq" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-21",
        chapterId: "beginner-level2",
        order: 118,
        title: { zh: "提子 2 · 21/24", en: "Capture 2 · 21/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpgphpeqfqhqbrdrfrfs", white: "epfpdqgqgrgs" },
            correct: ["esercrdscs"],
            wrong: ["eserdscs", "eres", "crhr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-22",
        chapterId: "beginner-level2",
        order: 119,
        title: { zh: "提子 2 · 22/24", en: "Capture 2 · 22/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofocpdpgpbqcrgr", white: "codoepcqeqbrer" },
            correct: ["bpdqdrcqcs", "bpdqdrcqaq"],
            wrong: ["dqbp", "aqdqbpdr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-23",
        chapterId: "beginner-level2",
        order: 120,
        title: { zh: "提子 2 · 23/24", en: "Capture 2 · 23/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elgmdoeocpcqfqdrgr", white: "dnbocogodpep" },
            correct: ["fn"],
            wrong: ["enfofpfn", "enfofnfp", "foenfnem", "foenemfn", "fpfn"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-2-24",
        chapterId: "beginner-level2",
        order: 121,
        title: { zh: "提子 2 · 24/24", en: "Capture 2 · 24/24" },
        instruction: { zh: "白先。尽可能多地吃子。", en: "White to play. Capture as many stones as possible." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alcldlelemcndnbpcqbrdrcs", white: "bmcmdmenfndodpdqfqer" },
            correct: ["bococp", "cobnbo"],
            wrong: ["bocobncp", "bnco", "cobnanbo"],
        },
    },
];

const bl2ThrowIn1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-throw-in-1-1",
        chapterId: "beginner-level2",
        order: 122,
        title: { zh: "扑 1 · 1/13", en: "Throw In 1 · 1/13" },
        instruction: { zh: "三颗标记的棋子有三口气，因此黑棋无法打吃它们。如果黑棋试图在A点落子吃掉它们，白棋将在B点连接自己的棋子。但如果黑棋在B点牺牲一子（扑），白棋吃掉这颗子后会少一气。接下来，黑棋可以打吃并吃掉这些棋子。黑先。用扑吃子。", en: "The three marked stones have three liberties, so Black can not put them in atari. If Black tries to capture them by playing at A, White will connect his stones at B. But if Black sacrifices a stone at B (thrown in), White loses a liberty by capturing this stone. Next, Black can put the stones in atari and capture them. Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblbpcmcncocpdl", white: "apbmbnbobqcqdqeqfp" },
            marks: { triangle: "bmbnbo", A: "am", B: "ao" },
            correct: ["aoanamaoaq"],
            wrong: ["amao"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-2",
        chapterId: "beginner-level2",
        order: 123,
        title: { zh: "扑 1 · 2/13", en: "Throw In 1 · 2/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmemdngncogofpeqfq", white: "dofobpcpepgpdqgqgr" },
            correct: ["eoenfn"],
            wrong: ["fneo"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-3",
        chapterId: "beginner-level2",
        order: 124,
        title: { zh: "扑 1 · 3/13", en: "Throw In 1 · 3/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofogodpgpdqhqdr", white: "cnendocpepfpcqgqcrfr" },
            correct: ["fqeqerfqgr", "fqeqerfqfs"],
            wrong: ["eqfq", "grer"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-4",
        chapterId: "beginner-level2",
        order: 125,
        title: { zh: "扑 1 · 4/13", en: "Throw In 1 · 4/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cngocpgpcqfqdrerfr", white: "eofphpbqdqeqgqbrcrgrds" },
            correct: ["epdpdoepen"],
            wrong: ["dpep", "foep"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-5",
        chapterId: "beginner-level2",
        order: 126,
        title: { zh: "扑 1 · 5/13", en: "Throw In 1 · 5/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emcnendocpgpcqhqcrerhrds", white: "flfmfnineodpfpdqdr" },
            correct: ["epeqfq"],
            wrong: ["eqep"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-6",
        chapterId: "beginner-level2",
        order: 127,
        title: { zh: "扑 1 · 6/13", en: "Throw In 1 · 6/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fnfohodpephpdqhqdrgr", white: "cmdoeocpfpgpcqgqcrfr" },
            correct: ["fqeqgofqfs", "fqeqgofqer"],
            wrong: ["gofq"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-7",
        chapterId: "beginner-level2",
        order: 128,
        title: { zh: "扑 1 · 7/13", en: "Throw In 1 · 7/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eofogocpdpgpcqhqgr", white: "bncodobpepfpdqgqbrer" },
            correct: ["eqfqfreqesdrcr", "eqfqfreqdr"],
            wrong: ["fqeq", "dreq"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-8",
        chapterId: "beginner-level2",
        order: 129,
        title: { zh: "扑 1 · 8/13", en: "Throw In 1 · 8/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnfnboeobpfpcqcrdr", white: "cocpepbqdqfqgqhqbrer" },
            correct: ["dpdocn"],
            wrong: ["cncs", "docs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-9",
        chapterId: "beginner-level2",
        order: 130,
        title: { zh: "扑 1 · 9/13", en: "Throw In 1 · 9/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "emencodobpgpbqfqbrdrerfr", white: "eogohocpfpcqdqeqgqhq" },
            correct: ["epdpcr"],
            wrong: ["dpep", "crep"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-10",
        chapterId: "beginner-level2",
        order: 131,
        title: { zh: "扑 1 · 10/13", en: "Throw In 1 · 10/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "enfnhneogodpdqhqdrer", white: "dmdndofocpepcqeqgqcrfr" },
            correct: ["fqfpgpfqgr", "fqfpgpfqfs"],
            wrong: ["fpfq", "gpes"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-11",
        chapterId: "beginner-level2",
        order: 132,
        title: { zh: "扑 1 · 11/13", en: "Throw In 1 · 11/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofocpgpcqgqiqcrdr", white: "cmcncobpdpepbqdqbrer" },
            correct: ["eqfqfpeqfr", "eqfqfpeqes"],
            wrong: ["fpeq"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-12",
        chapterId: "beginner-level2",
        order: 133,
        title: { zh: "扑 1 · 12/13", en: "Throw In 1 · 12/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eneodpfpcqfqcrcsds", white: "dlcmhncodoepeqgqhqiqdrfr" },
            correct: ["eresdqergr"],
            wrong: ["dqer"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-1-13",
        chapterId: "beginner-level2",
        order: 134,
        title: { zh: "扑 1 · 13/13", en: "Throw In 1 · 13/13" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "elenfncodocpgpbqfqerfrds", white: "bncndneodpepfpcqarbrdr" },
            correct: ["dqeqfo", "dqcrfo"],
            wrong: ["crdq", "fobp", "eqdq"],
        },
    },
];

const bl2ThrowIn2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-throw-in-2-1",
        chapterId: "beginner-level2",
        order: 135,
        title: { zh: "扑 2 · 1/24", en: "Throw In 2 · 1/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bsdrcrdqbqaqepfodocoeo", white: "bpcpdpfpgpcqeqerdses" },
            correct: ["brarcsbrap"],
            wrong: ["csbr", "apbo"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-2",
        chapterId: "beginner-level2",
        order: 136,
        title: { zh: "扑 2 · 2/24", en: "Throw In 2 · 2/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmbncnenfnaodoapbpcpepeqer", white: "flambmcmdmemandndpbqcqdq" },
            correct: ["coboaq"],
            wrong: ["boco", "aqco"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-3",
        chapterId: "beginner-level2",
        order: 137,
        title: { zh: "扑 2 · 3/24", en: "Throw In 2 · 3/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbphpcqdqeqgqarbrfrgrcs", white: "cnenaobocpepfpfqcrdrerbs" },
            correct: ["bqaqdp"],
            wrong: ["dpbq", "aqbq"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-4",
        chapterId: "beginner-level2",
        order: 138,
        title: { zh: "扑 2 · 4/24", en: "Throw In 2 · 4/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqdqbrdrfrcs", white: "cmapbpcpaqcqcr" },
            correct: ["bsasar"],
            wrong: ["dsbs", "arbs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-5",
        chapterId: "beginner-level2",
        order: 139,
        title: { zh: "扑 2 · 5/24", en: "Throw In 2 · 5/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpgpcqdqfqbrerfr", white: "dnaobocpepeqcrdr" },
            correct: ["bqaqdpbqbs"],
            wrong: ["dpbq", "aqbq", "arbq"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-6",
        chapterId: "beginner-level2",
        order: 140,
        title: { zh: "扑 2 · 6/24", en: "Throw In 2 · 6/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fngndoeogodpgpcqeqgqcreres", white: "fmcndnenbofocpepfpbqfqbrfrfs" },
            correct: ["dqdrcodqcs", "dqdrcodqdscsbs"],
            wrong: ["codq", "drds", "csgr"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-7",
        chapterId: "beginner-level2",
        order: 141,
        title: { zh: "扑 2 · 7/24", en: "Throw In 2 · 7/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gmgnindoeofofpeqhqcrdrfrgr", white: "cmdnenfncogocpgpcqfqgqbr" },
            correct: ["epdpdq"],
            wrong: ["dpep", "erho", "dqho"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-8",
        chapterId: "beginner-level2",
        order: 142,
        title: { zh: "扑 2 · 8/24", en: "Throw In 2 · 8/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeogohodpfpdqgq", white: "cmdnenfncofocpcqbrdrerfr" },
            correct: ["epeqfq"],
            wrong: ["eqep", "fqep"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-9",
        chapterId: "beginner-level2",
        order: 143,
        title: { zh: "扑 2 · 9/24", en: "Throw In 2 · 9/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hrgrfqeqdqdphoeohngnfndncniq", white: "frerdrbrgqcqgpgofodocobobn" },
            correct: ["epfpcp"],
            wrong: ["cphp"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-10",
        chapterId: "beginner-level2",
        order: 144,
        title: { zh: "扑 2 · 10/24", en: "Throw In 2 · 10/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmfmcnboapdpbqeqerfr", white: "anbnaodoeoepcqdqfqgq" },
            correct: ["bpcpcobpbr", "bpcocp"],
            wrong: ["cobp", "cpbm"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-11",
        chapterId: "beginner-level2",
        order: 145,
        title: { zh: "扑 2 · 11/24", en: "Throw In 2 · 11/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndoeocpfpcqfqcrfrcseshs", white: "fohodpepgpgqdrergrhriris" },
            correct: ["fsgseq"],
            wrong: ["dseq", "dqds", "eqfs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-12",
        chapterId: "beginner-level2",
        order: 146,
        title: { zh: "扑 2 · 12/24", en: "Throw In 2 · 12/24" },
        instruction: { zh: "白先。用扑吃子。", en: "White to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndneoepfpcqeqdrfrfs", white: "enfndodpgpdqfqgqgrgs" },
            correct: ["eresfoercr"],
            wrong: ["eser", "foer", "dser"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-13",
        chapterId: "beginner-level2",
        order: 147,
        title: { zh: "扑 2 · 13/24", en: "Throw In 2 · 13/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqeqgqcrfrfs", white: "bocpdpepbqbrdrcs" },
            correct: ["dseser"],
            wrong: ["bsds", "erds"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-14",
        chapterId: "beginner-level2",
        order: 148,
        title: { zh: "扑 2 · 14/24", en: "Throw In 2 · 14/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbqcqdqdr", white: "epeqarbrcrerasds" },
            correct: ["csbsaq"],
            wrong: ["bscs", "aqcs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-15",
        chapterId: "beginner-level2",
        order: 149,
        title: { zh: "扑 2 · 15/24", en: "Throw In 2 · 15/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fngnfpdqeqcrcs", white: "cnhocpcqhqdrhrdsfshs" },
            correct: ["eserfr"],
            wrong: ["eres", "fres"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-16",
        chapterId: "beginner-level2",
        order: 150,
        title: { zh: "扑 2 · 16/24", en: "Throw In 2 · 16/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbqcqdqeqbrfr", white: "fpfqarcrdrergrasbs" },
            correct: ["csdsaq"],
            wrong: ["aqcs", "esfs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-17",
        chapterId: "beginner-level2",
        order: 151,
        title: { zh: "扑 2 · 17/24", en: "Throw In 2 · 17/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gneocqdqeqfqcrgrgs", white: "cnbpbqgqhqbrdrerfrcs" },
            correct: ["dsesfs"],
            wrong: ["fsds", "esds", "bsds"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-18",
        chapterId: "beginner-level2",
        order: 152,
        title: { zh: "扑 2 · 18/24", en: "Throw In 2 · 18/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "encocpbqdqeqfqgqbrdr", white: "gndpephpcqhqcrerfrgrcsds" },
            correct: ["esfsbseshr"],
            wrong: ["bses"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-19",
        chapterId: "beginner-level2",
        order: 153,
        title: { zh: "扑 2 · 19/24", en: "Throw In 2 · 19/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gnhpcqdqeqfqgqbrfrhrir", white: "cmcobpbqcrdrergrbsfsgshs" },
            correct: ["esdsis"],
            wrong: ["csar", "ises"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-20",
        chapterId: "beginner-level2",
        order: 154,
        title: { zh: "扑 2 · 20/24", en: "Throw In 2 · 20/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncpdqeqfqgqcrgrcs", white: "gnhphqdrerfrhrgs" },
            correct: ["fsesds"],
            wrong: ["dsfs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-21",
        chapterId: "beginner-level2",
        order: 155,
        title: { zh: "扑 2 · 21/24", en: "Throw In 2 · 21/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmdndocpepcqeqiqcrerirhs", white: "fmeofodpdqdrfrdses" },
            correct: ["fsgscsfsfq"],
            wrong: ["fsgscsfsgrfq", "fsgsgrfq", "fsgsfqgq", "csfs"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-22",
        chapterId: "beginner-level2",
        order: 156,
        title: { zh: "扑 2 · 22/24", en: "Throw In 2 · 22/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmanbncocpbqcqdrercs", white: "fnboapbpaqdqeqfqbrcrfres" },
            correct: ["arasao"],
            wrong: ["aoar", "bsar"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-23",
        chapterId: "beginner-level2",
        order: 157,
        title: { zh: "扑 2 · 23/24", en: "Throw In 2 · 23/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpaqbqcqeqfqarcrfr", white: "dmgncocpgpdqgqbrdrergrbscsfs" },
            correct: ["esdsas"],
            wrong: ["dses", "ases"],
        },
    },
    {
        id: "beginner-level2-bl2-throw-in-2-24",
        chapterId: "beginner-level2",
        order: 158,
        title: { zh: "扑 2 · 24/24", en: "Throw In 2 · 24/24" },
        instruction: { zh: "黑先。用扑吃子。", en: "Black to play. Capture stones by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncpdpbqdqfqbrbs", white: "cmcnbogobpaqcqgqcrgrcsesgs" },
            correct: ["dsdrer"],
            wrong: ["drds", "erds"],
        },
    },
];

const bl2Capture3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capture-3-1",
        chapterId: "beginner-level2",
        order: 159,
        title: { zh: "提子 3 · 1/9", en: "Capture 3 · 1/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "endodpfpcqfqfr", white: "cncocpdqeq" },
            correct: ["crbqbr"],
            wrong: ["bqcr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-2",
        chapterId: "beginner-level2",
        order: 160,
        title: { zh: "提子 3 · 2/9", en: "Capture 3 · 2/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmbpcpdpbqeqhqer", white: "fnepfpcqdqfqbr" },
            correct: ["dr"],
            wrong: ["frcr", "crfr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-3",
        chapterId: "beginner-level2",
        order: 161,
        title: { zh: "提子 3 · 3/9", en: "Capture 3 · 3/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdmeneogocpdpfpcqfq", white: "bocodoepdqeq" },
            correct: ["cr"],
            wrong: ["bpdr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-4",
        chapterId: "beginner-level2",
        order: 162,
        title: { zh: "提子 3 · 4/9", en: "Capture 3 · 4/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmeofofpgpeqhqer", white: "cpdpepdqfq" },
            correct: ["fr"],
            wrong: ["drfr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-5",
        chapterId: "beginner-level2",
        order: 163,
        title: { zh: "提子 3 · 5/9", en: "Capture 3 · 5/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocoeodpcqdqbr", white: "bpcpbqgqcrdrer" },
            correct: ["ar"],
            wrong: ["bsar"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-6",
        chapterId: "beginner-level2",
        order: 164,
        title: { zh: "提子 3 · 6/9", en: "Capture 3 · 6/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncpdpcqeqfqgqcr", white: "epfpgpipdqhqdr" },
            correct: ["er"],
            wrong: ["grer"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-7",
        chapterId: "beginner-level2",
        order: 165,
        title: { zh: "提子 3 · 7/9", en: "Capture 3 · 7/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepfpcqgqcrgr", white: "fogphpdqeqfqhq" },
            correct: ["fr"],
            wrong: ["hrfr"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-8",
        chapterId: "beginner-level2",
        order: 166,
        title: { zh: "提子 3 · 8/9", en: "Capture 3 · 8/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbobqdqeqbrcr", white: "focpepcqgqdr" },
            correct: ["er"],
            wrong: ["fqer", "dper"],
        },
    },
    {
        id: "beginner-level2-bl2-capture-3-9",
        chapterId: "beginner-level2",
        order: 167,
        title: { zh: "提子 3 · 9/9", en: "Capture 3 · 9/9" },
        instruction: { zh: "白先。在救助自己薄弱棋块的同时吃子。", en: "White to play. Capture stones while helping your weak group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmdodpeqhqer", white: "eobpepgpcqdqfq" },
            correct: ["fr"],
            wrong: ["drfrgrgq"],
        },
    },
];

const bl2ConnectLevels: Level[] = [
    {
        id: "beginner-level2-bl2-connect-1",
        chapterId: "beginner-level2",
        order: 168,
        title: { zh: "连接 · 1/11", en: "Connect · 1/11" },
        instruction: { zh: "确保连接的一种漂亮棋形是竹节。图中的三颗白棋可以被切断。白棋在A点实接会导致愚形（空三角）。白棋也可以在B点连接。形成的棋形称为竹节。这个竹节比A点的实接提供更多可能性。白先。连接白棋。选择最佳连接方式。", en: "A beautiful shape to ensure connection is the bamboo joint. The three white stones in this diagram can be cut. The solid connection by White at A results in an ugly shape (empty triangle). White can also connect by playing at B. The resulting shape is called the bamboo joint. This bamboo joint offers more possibilities than a solid connection at A. White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqgpgq", white: "eoeqfq" },
            marks: { A: "ep", B: "fo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-2",
        chapterId: "beginner-level2",
        order: 169,
        title: { zh: "连接 · 2/11", en: "Connect · 2/11" },
        instruction: { zh: "另一种确保连接的漂亮棋形是小飞连接。黑棋在A点仍有一个切断点。通过在B点走小飞，黑棋可以防止这个切断。如果白棋仍试图在A点切断，黑棋可以用征子吃掉切断的棋子。黑先。连接黑棋。选择最佳连接方式。", en: "Another beautiful shape to ensure connection is the keima (knight's move) connection. The black stones still have a cutting-point at A. By playing a keima at B, Black can cover this cut. If White still tries to cut at A, Black can capture the cutting stones in a ladder. Black to play. Connect the black stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpepfqfr", white: "bqcqdqeqer" },
            marks: { A: "fp", B: "go" },
            correct: ["gofpfogphp", "gofpgpfofn"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-3",
        chapterId: "beginner-level2",
        order: 170,
        title: { zh: "连接 · 3/11", en: "Connect · 3/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncqdqfq", white: "dnbododp" },
            correct: ["bp"],
            wrong: ["cobp", "cpbq"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-4",
        chapterId: "beginner-level2",
        order: 171,
        title: { zh: "连接 · 4/11", en: "Connect · 4/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmbndncobpaqeqdr", white: "endoeocpbqbr" },
            correct: ["dq"],
            wrong: ["dpcq", "cqdp"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-5",
        chapterId: "beginner-level2",
        order: 172,
        title: { zh: "连接 · 5/11", en: "Connect · 5/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcnboco", white: "anbnbpcpdpeq" },
            correct: ["ao"],
            wrong: ["apao"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-6",
        chapterId: "beginner-level2",
        order: 173,
        title: { zh: "连接 · 6/11", en: "Connect · 6/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldlfmfncodofodpdqfqer", white: "cndnencpcqcrdr" },
            correct: ["bo"],
            wrong: ["bnbo", "bpbo"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-7",
        chapterId: "beginner-level2",
        order: 174,
        title: { zh: "连接 · 7/11", en: "Connect · 7/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldlcododp", white: "bpcpfpeq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-8",
        chapterId: "beginner-level2",
        order: 175,
        title: { zh: "连接 · 8/11", en: "Connect · 8/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldlhobpcpcqdqeqhqer", white: "cndnenbobqbrcrdr" },
            correct: ["ap"],
            wrong: ["aoap", "aqap", "coap", "bnap"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-9",
        chapterId: "beginner-level2",
        order: 176,
        title: { zh: "连接 · 9/11", en: "Connect · 9/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnfndogpdqgqcrdrgr", white: "cmcncoepbqcqfqfr" },
            correct: ["dp"],
            wrong: ["cpdp", "fpdp", "eqdp"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-10",
        chapterId: "beginner-level2",
        order: 177,
        title: { zh: "连接 · 10/11", en: "Connect · 10/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmcncoeqgqcrdr", white: "eofogobpcqbr" },
            correct: ["dpdqcp"],
            wrong: ["dpdqepcp", "dpdqdocp", "dqdp", "cpdp", "bqdp"],
        },
    },
    {
        id: "beginner-level2-bl2-connect-11",
        chapterId: "beginner-level2",
        order: 178,
        title: { zh: "连接 · 11/11", en: "Connect · 11/11" },
        instruction: { zh: "白先。连接白棋。选择最佳连接方式。", en: "White to play. Connect the white stones. Choose the best connection." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enfndocpdqeqer", white: "dlemcndncqcrdr" },
            correct: ["bpbocodpbq", "bpbocodpaq", "bpbocodpap", "bpbocodpbr"],
            wrong: ["bpbocodpbnbqaobr", "cobp", "bobp", "bqbp"],
        },
    },
];

const bl2Cut1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-cut-1-1",
        chapterId: "beginner-level2",
        order: 179,
        title: { zh: "切断 1 · 1/9", en: "Cut 1 · 1/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmcncogpfqdrer", white: "dnengncpdpcr" },
            correct: ["doeoep"],
            wrong: ["cqep", "eodo", "epdo"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-2",
        chapterId: "beginner-level2",
        order: 180,
        title: { zh: "切断 1 · 2/9", en: "Cut 1 · 2/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dlelemencododpeqer", white: "bmcmdmcncpbqcqdr" },
            correct: ["bo"],
            wrong: ["dqbo"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-3",
        chapterId: "beginner-level2",
        order: 181,
        title: { zh: "切断 1 · 3/9", en: "Cut 1 · 3/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldlflcnfpbqcqfqdrer", white: "enfohobpcpepdqeqhq" },
            correct: ["doeodp"],
            wrong: ["gogn"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-4",
        chapterId: "beginner-level2",
        order: 182,
        title: { zh: "切断 1 · 4/9", en: "Cut 1 · 4/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "encpepdqfqer", white: "clcncocqcrdr" },
            correct: ["bp"],
            wrong: ["bobpdpbq", "bqbpdpbr"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-5",
        chapterId: "beginner-level2",
        order: 183,
        title: { zh: "切断 1 · 5/9", en: "Cut 1 · 5/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bndndodpfpeq", white: "clelcmcnbocqdq" },
            correct: ["bpcpco"],
            wrong: ["cobp", "cpbp"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-6",
        chapterId: "beginner-level2",
        order: 184,
        title: { zh: "切断 1 · 6/9", en: "Cut 1 · 6/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmdpbqcqdqeq", white: "fmencocpepfpfq" },
            correct: ["dodncn"],
            wrong: ["dndo", "cndo", "eodo"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-7",
        chapterId: "beginner-level2",
        order: 185,
        title: { zh: "切断 1 · 7/9", en: "Cut 1 · 7/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodpdqfqerds", white: "cmcncqbrcrdr" },
            correct: ["bpcpcobobn"],
            wrong: ["bococpbp", "cpbpboco", "coaobpapbqaq", "coaoboanapbp", "coaoboanbpapaqbq", "coaoapbpboan", "coaoanbobpapaqbncpbq", "coaoanbobpapaqbnbqcp"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-8",
        chapterId: "beginner-level2",
        order: 186,
        title: { zh: "切断 1 · 8/9", en: "Cut 1 · 8/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "elflcmemdnbqdqeqfq", white: "fmfnbocoepfpgpgq" },
            correct: ["dodpcp"],
            wrong: ["dpdoeoen", "fodo"],
        },
    },
    {
        id: "beginner-level2-bl2-cut-1-9",
        chapterId: "beginner-level2",
        order: 187,
        title: { zh: "切断 1 · 9/9", en: "Cut 1 · 9/9" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmcndngncqdqfqgqhqbrcr", white: "bnbocofogohocpepbqar" },
            correct: ["eodoenfpdp"],
            wrong: ["eododpen", "eodofpen", "dodp", "dpdo"],
        },
    },
];

const bl2Cut2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-cut-2-1",
        chapterId: "beginner-level2",
        order: 188,
        title: { zh: "切断 2 · 1/12", en: "Cut 2 · 1/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeocpep", white: "cncodpcqdq" },
            marks: { triangle: "do" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doeocpep", white: "cncodpcqdq" },
                marks: { triangle: "do" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-2",
        chapterId: "beginner-level2",
        order: 189,
        title: { zh: "切断 2 · 2/12", en: "Cut 2 · 2/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcncodpdqfqcrer", white: "bnbobqcqdrds" },
            marks: { triangle: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmcncodpdqfqcrer", white: "bnbobqcqdrds" },
                marks: { triangle: "cr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-3",
        chapterId: "beginner-level2",
        order: 190,
        title: { zh: "切断 2 · 3/12", en: "Cut 2 · 3/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndneoepdq", white: "enfndo" },
            marks: { triangle: "eo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cndneoepdq", white: "enfndo" },
                marks: { triangle: "eo" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-4",
        chapterId: "beginner-level2",
        order: 191,
        title: { zh: "切断 2 · 4/12", en: "Cut 2 · 4/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eodqeqcreres", white: "cobqcqdrds" },
            marks: { triangle: "cr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eodqeqcreres", white: "cobqcqdrds" },
                marks: { triangle: "cr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-5",
        chapterId: "beginner-level2",
        order: 192,
        title: { zh: "切断 2 · 5/12", en: "Cut 2 · 5/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnco", white: "cndoeocpdq" },
            marks: { triangle: "dn" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dnco", white: "cndoeocpdq" },
                marks: { triangle: "dn" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-6",
        chapterId: "beginner-level2",
        order: 193,
        title: { zh: "切断 2 · 6/12", en: "Cut 2 · 6/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpdqdrfrcs", white: "bocqcrds" },
            marks: { triangle: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dpdqdrfrcs", white: "bocqcrds" },
                marks: { triangle: "dr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-7",
        chapterId: "beginner-level2",
        order: 194,
        title: { zh: "切断 2 · 7/12", en: "Cut 2 · 7/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eneodp", white: "codoepgpeq" },
            marks: { triangle: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneodp", white: "codoepgpeq" },
                marks: { triangle: "dp" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-8",
        chapterId: "beginner-level2",
        order: 195,
        title: { zh: "切断 2 · 8/12", en: "Cut 2 · 8/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocqfqcrfrhrdses", white: "dndpepdrerfs" },
            marks: { triangle: "fr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocqfqcrfrhrdses", white: "dndpepdrerfs" },
                marks: { triangle: "fr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-9",
        chapterId: "beginner-level2",
        order: 196,
        title: { zh: "切断 2 · 9/12", en: "Cut 2 · 9/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codpepfp", white: "cmdndocpcqdqeq" },
            marks: { triangle: "co" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codpepfp", white: "cmdndocpcqdqeq" },
                marks: { triangle: "co" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-10",
        chapterId: "beginner-level2",
        order: 197,
        title: { zh: "切断 2 · 10/12", en: "Cut 2 · 10/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobphpcqfqarcrfrhrbsdses", white: "cpdpepdrerfs" },
            marks: { triangle: "fr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "not cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bobphpcqfqarcrfrhrbsdses", white: "cpdpepdrerfs" },
                marks: { triangle: "fr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-11",
        chapterId: "beginner-level2",
        order: 198,
        title: { zh: "切断 2 · 11/12", en: "Cut 2 · 11/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncocpdqeqcr", white: "dodpcq" },
            marks: { triangle: "cp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cncocpdqeqcr", white: "dodpcq" },
                marks: { triangle: "cp" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-cut-2-12",
        chapterId: "beginner-level2",
        order: 199,
        title: { zh: "切断 2 · 12/12", en: "Cut 2 · 12/12" },
        instruction: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpaqcqcrfrgrcsdses", white: "cnbocpdpepdrerfs" },
            marks: { triangle: "fr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。黑棋试图用标记的棋子切断白棋。白棋真的被切断了吗，还是白棋能够将它们连接起来？", en: "White to play. Black attempts to cut the white stones with the marked stone. Have the white stones really been cut, or is white able to connect them?" },
            options: [{ value: "cut", label: { zh: "切断", en: "cut" } }, { value: "not cut", label: { zh: "未切断", en: "not cut" } }],
            correctValue: "cut",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bpaqcqcrfrgrcsdses", white: "cnbocpdpepdrerfs" },
                marks: { triangle: "fr" },
            },
        },
    },
];

const bl2OpeningLevels: Level[] = [
    {
        id: "beginner-level2-bl2-opening-1",
        chapterId: "beginner-level2",
        order: 200,
        title: { zh: "布局 · 1/7", en: "Opening · 1/7" },
        instruction: { zh: "围棋的主要目标是围地。在角上围地最容易，因为只需防守两个方向。这就是为什么开局的第一手往往落在角上。接着是边，最后才是中腹。白先。选择最佳后续手段，A、B或C。", en: "The main target in the game of go is to make territory. Making territory is easiest in the corners, because you need to defend a corner only from two sides. That is why the first moves of the opening are often in the corners. Next, the sides follow and the centre comes last. White to play. Choose the best continuation, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "pdpq", white: "dp" },
            marks: { 1: "pd", 2: "dp", 3: "pq", C: "dd", B: "jj", A: "jp" },
            correct: ["dd"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-2",
        chapterId: "beginner-level2",
        order: 201,
        title: { zh: "布局 · 2/7", en: "Opening · 2/7" },
        instruction: { zh: "当你在角上的第一手走在三四路上时，可以用一手棋封住角。这样的角部封锁在日语中称为“缔角”。你可以通过在A或B点落子来完成。黑先。用缔角封住角部。", en: "When your first move in a corner is at the 3-4 point, you can close the corner with one move. Such a corner enclosure is called shimari in Japanese. You can do this by playing at A or B. Black to play. Close the corner with a shimari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cp", white: "" },
            marks: { A: "ep", B: "eq" },
            correct: ["ep", "eq"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-3",
        chapterId: "beginner-level2",
        order: 202,
        title: { zh: "布局 · 3/7", en: "Opening · 3/7" },
        instruction: { zh: "如果对手没有封住角，你可以用角部挂角来攻击。这在日语中称为“挂角”。在此图中，白棋在四四路上有一子。黑棋可以通过在A或B点落子来攻击这个角。黑先。用挂角攻击角部。", en: "If your opponent has not enclosed the corner, you can attack it with a corner approach. This is called kakari in Japanese. In this diagram White has a stone at the 4-4 point. Black can attack this corner by playing at A or B. Black to play. Attack the corner with a kakari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dp" },
            marks: { A: "fp", B: "fq" },
            correct: ["fp", "fq", "cn", "dn"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-4",
        chapterId: "beginner-level2",
        order: 203,
        title: { zh: "布局 · 4/7", en: "Opening · 4/7" },
        instruction: { zh: "当你角上的棋子被挂角攻击时，你可能需要防守。如果你不防守，对手可能会从另一侧再次挂角攻击你的棋子。对挂角的通常应对是小飞或单关跳。在此例中，黑棋可以对白棋的挂角1在A或B点应。黑先。应对挂角。", en: "When your stone in the corner is attacked with a kakari, you may want to defend it. If you do not defend, your opponent might attack your stone again with a kakari from the other side. The usual way to react on a kakari is a knight's move or a 1-point jump. In this example Black can react on White's kakari 1 with a move at A or B. Black to play. Defend against the kakari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", A: "cn", B: "dn" },
            correct: ["cn", "dn"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-5",
        chapterId: "beginner-level2",
        order: 204,
        title: { zh: "布局 · 5/7", en: "Opening · 5/7" },
        instruction: { zh: "黑先。选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qdpq", white: "dddp" },
            marks: { 1: "qd", 2: "dp", 3: "pq", 4: "dd", C: "oc", B: "nj", A: "kr" },
            correct: ["oc"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-6",
        chapterId: "beginner-level2",
        order: 205,
        title: { zh: "布局 · 6/7", en: "Opening · 6/7" },
        instruction: { zh: "黑先。选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "pdpq", white: "dddp" },
            marks: { 1: "pd", 2: "dp", 3: "pq", 4: "dd", C: "jl", B: "fn", A: "fq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level2-bl2-opening-7",
        chapterId: "beginner-level2",
        order: 206,
        title: { zh: "布局 · 7/7", en: "Opening · 7/7" },
        instruction: { zh: "黑先。选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "qcpq", white: "dccp" },
            marks: { 1: "qc", 2: "cp", 3: "pq", 4: "dc", C: "oe", B: "fj", A: "po" },
            correct: ["po"],
        },
    },
];

const bl2Corner1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-corner-1-1",
        chapterId: "beginner-level2",
        order: 207,
        title: { zh: "角部 1 · 1/12", en: "Corner 1 · 1/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cp", white: "" },
            marks: { A: "cq", B: "dq", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-2",
        chapterId: "beginner-level2",
        order: 208,
        title: { zh: "角部 1 · 2/12", en: "Corner 1 · 2/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cp", white: "" },
            marks: { C: "en", B: "eo", A: "ep" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-3",
        chapterId: "beginner-level2",
        order: 209,
        title: { zh: "角部 1 · 3/12", en: "Corner 1 · 3/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dq", white: "" },
            marks: { A: "cn", B: "en", C: "gn" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-4",
        chapterId: "beginner-level2",
        order: 210,
        title: { zh: "角部 1 · 4/12", en: "Corner 1 · 4/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "" },
            marks: { A: "cn", B: "en", C: "gn" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-5",
        chapterId: "beginner-level2",
        order: 211,
        title: { zh: "角部 1 · 5/12", en: "Corner 1 · 5/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "" },
            marks: { A: "ep", B: "fp", C: "er" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-6",
        chapterId: "beginner-level2",
        order: 212,
        title: { zh: "角部 1 · 6/12", en: "Corner 1 · 6/12" },
        instruction: { zh: "黑先。选择最佳角部封锁（缔角），A、B或C。", en: "Black to play. Choose the best corner enclosure (shimari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "" },
            marks: { A: "dm", B: "bp", C: "ep" },
            correct: ["dm"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-7",
        chapterId: "beginner-level2",
        order: 213,
        title: { zh: "角部 1 · 7/12", en: "Corner 1 · 7/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dp" },
            marks: { A: "cn", B: "do", C: "cp" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-8",
        chapterId: "beginner-level2",
        order: 214,
        title: { zh: "角部 1 · 8/12", en: "Corner 1 · 8/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dp" },
            marks: { A: "dn", B: "do", C: "ep" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-9",
        chapterId: "beginner-level2",
        order: 215,
        title: { zh: "角部 1 · 9/12", en: "Corner 1 · 9/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dp" },
            marks: { A: "fn", B: "cq", C: "br" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-10",
        chapterId: "beginner-level2",
        order: 216,
        title: { zh: "角部 1 · 10/12", en: "Corner 1 · 10/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "cp" },
            marks: { A: "do", B: "dp", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-11",
        chapterId: "beginner-level2",
        order: 217,
        title: { zh: "角部 1 · 11/12", en: "Corner 1 · 11/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "dq" },
            marks: { A: "do", B: "cp", C: "eq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-1-12",
        chapterId: "beginner-level2",
        order: 218,
        title: { zh: "角部 1 · 12/12", en: "Corner 1 · 12/12" },
        instruction: { zh: "黑先。选择最佳角部挂角（挂角），A、B或C。", en: "Black to play. Choose the best corner approach (kakari), A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "", white: "cp" },
            marks: { A: "bq", B: "cq", C: "fq" },
            correct: ["fq"],
        },
    },
];

const bl2Corner2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-corner-2-1",
        chapterId: "beginner-level2",
        order: 219,
        title: { zh: "角部 2 · 1/12", en: "Corner 2 · 1/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", A: "dn", B: "do", C: "cp" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-2",
        chapterId: "beginner-level2",
        order: 220,
        title: { zh: "角部 2 · 2/12", en: "Corner 2 · 2/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "dn" },
            marks: { 1: "dn", A: "ep", B: "fp", C: "dq" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-3",
        chapterId: "beginner-level2",
        order: 221,
        title: { zh: "角部 2 · 3/12", en: "Corner 2 · 3/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "fq" },
            marks: { 1: "fq", A: "dn", B: "do", C: "dq" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-4",
        chapterId: "beginner-level2",
        order: 222,
        title: { zh: "角部 2 · 4/12", en: "Corner 2 · 4/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "dm" },
            marks: { 1: "dm", A: "ep", B: "fp", C: "cq" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-5",
        chapterId: "beginner-level2",
        order: 223,
        title: { zh: "角部 2 · 5/12", en: "Corner 2 · 5/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "cm" },
            marks: { 1: "cm", A: "dq", B: "eq", C: "gq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-6",
        chapterId: "beginner-level2",
        order: 224,
        title: { zh: "角部 2 · 6/12", en: "Corner 2 · 6/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "eq" },
            marks: { 1: "eq", A: "dn", B: "do", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-7",
        chapterId: "beginner-level2",
        order: 225,
        title: { zh: "角部 2 · 7/12", en: "Corner 2 · 7/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "cq" },
            marks: { 1: "cq", A: "dn", B: "do", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-8",
        chapterId: "beginner-level2",
        order: 226,
        title: { zh: "角部 2 · 8/12", en: "Corner 2 · 8/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "cp" },
            marks: { 1: "cp", A: "dn", C: "bp", B: "cq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-9",
        chapterId: "beginner-level2",
        order: 227,
        title: { zh: "角部 2 · 9/12", en: "Corner 2 · 9/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dp", white: "do" },
            marks: { 1: "do", A: "dn", B: "ep", C: "fp" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-10",
        chapterId: "beginner-level2",
        order: 228,
        title: { zh: "角部 2 · 10/12", en: "Corner 2 · 10/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpep", white: "dqeq" },
            marks: { 1: "eq", A: "co", B: "cq", C: "dr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-11",
        chapterId: "beginner-level2",
        order: 229,
        title: { zh: "角部 2 · 11/12", en: "Corner 2 · 11/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpep", white: "doeo" },
            marks: { 1: "eo", A: "cn", B: "co", C: "cq" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-corner-2-12",
        chapterId: "beginner-level2",
        order: 230,
        title: { zh: "角部 2 · 12/12", en: "Corner 2 · 12/12" },
        instruction: { zh: "黑先。对白棋的1选择最佳后续手段，A、B或C。", en: "Black to play. Choose the best continuation after white's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdq", white: "cpcq" },
            marks: { 1: "cp", A: "cn", B: "co", C: "dr" },
            correct: ["co"],
        },
    },
];

const bl2Defense1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-defense-1-1",
        chapterId: "beginner-level2",
        order: 231,
        title: { zh: "防守 1 · 1/12", en: "Defense 1 · 1/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dobpcpdpfq", white: "cmdnbocoap" },
            marks: { triangle: "ap" },
            correct: ["aq"],
            wrong: ["bqaq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-2",
        chapterId: "beginner-level2",
        order: 232,
        title: { zh: "防守 1 · 2/12", en: "Defense 1 · 2/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndncobpcqcr", white: "bodofocpdpdqdr" },
            marks: { triangle: "bo" },
            correct: ["bqbnbm"],
            wrong: ["bnbqaobr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-3",
        chapterId: "beginner-level2",
        order: 233,
        title: { zh: "防守 1 · 3/12", en: "Defense 1 · 3/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocqdq", white: "dmcpdpep" },
            marks: { triangle: "cp" },
            correct: ["bp"],
            wrong: ["bqbp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-4",
        chapterId: "beginner-level2",
        order: 234,
        title: { zh: "防守 1 · 4/12", en: "Defense 1 · 4/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndpeq", white: "fpfqer" },
            marks: { triangle: "er" },
            correct: ["dr"],
            wrong: ["dqdr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-5",
        chapterId: "beginner-level2",
        order: 235,
        title: { zh: "防守 1 · 5/12", en: "Defense 1 · 5/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocpdpfq", white: "ckbncodoeo" },
            marks: { triangle: "bn" },
            correct: ["bp"],
            wrong: ["apbqbpdr", "aoan"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-6",
        chapterId: "beginner-level2",
        order: 236,
        title: { zh: "防守 1 · 6/12", en: "Defense 1 · 6/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcncpbqdq", white: "dndodpeq" },
            marks: { triangle: "eq" },
            correct: ["dr"],
            wrong: ["erdrcqfr", "crdr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-7",
        chapterId: "beginner-level2",
        order: 237,
        title: { zh: "防守 1 · 7/12", en: "Defense 1 · 7/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdnbpcpdpcrdrdses", white: "epcqdqeqergrfs" },
            marks: { triangle: "cq" },
            correct: ["brbqaq"],
            wrong: ["brbqaraq", "bqbr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-8",
        chapterId: "beginner-level2",
        order: 238,
        title: { zh: "防守 1 · 8/12", en: "Defense 1 · 8/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnbocpcqeq", white: "clbmancnco" },
            marks: { triangle: "an" },
            correct: ["ap"],
            wrong: ["aobpamap", "bpao"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-9",
        chapterId: "beginner-level2",
        order: 239,
        title: { zh: "防守 1 · 9/12", en: "Defense 1 · 9/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fodpepbqcqeqer", white: "cndobpcpdqcrdr" },
            marks: { triangle: "cr" },
            correct: ["br"],
            wrong: ["aqbr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-10",
        chapterId: "beginner-level2",
        order: 240,
        title: { zh: "防守 1 · 10/12", en: "Defense 1 · 10/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcqeqfqdrfr", white: "cnaobocpdpdqer" },
            marks: { triangle: "dp" },
            correct: ["br"],
            wrong: ["crbq", "bqcresbr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-11",
        chapterId: "beginner-level2",
        order: 241,
        title: { zh: "防守 1 · 11/12", en: "Defense 1 · 11/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dobpcpdpaqfq", white: "cmdnaobocoap" },
            marks: { triangle: "ao" },
            correct: ["bq", "br"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-1-12",
        chapterId: "beginner-level2",
        order: 242,
        title: { zh: "防守 1 · 12/12", en: "Defense 1 · 12/12" },
        instruction: { zh: "黑先。对白棋标记的一手做出良好防守。", en: "Black to play. Play a good defense in reply of White's marked move." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmcnco", white: "bmcmdnencpdp" },
            marks: { triangle: "bm" },
            correct: ["blbnbo"],
            wrong: ["bnblckbkcjbp", "bnblckbkbjcj", "bnblbkdl"],
        },
    },
];

const bl2Defense2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-defense-2-1",
        chapterId: "beginner-level2",
        order: 243,
        title: { zh: "防守 2 · 1/12", en: "Defense 2 · 1/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcmbnbobp", white: "cpdpgq" },
            marks: { 1: "bp" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-2",
        chapterId: "beginner-level2",
        order: 244,
        title: { zh: "防守 2 · 2/12", en: "Defense 2 · 2/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dp", white: "cpeq" },
            marks: { 1: "dp" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-3",
        chapterId: "beginner-level2",
        order: 245,
        title: { zh: "防守 2 · 3/12", en: "Defense 2 · 3/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnhohqgr", white: "bpdpfq" },
            marks: { 1: "gr" },
            correct: ["fr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-4",
        chapterId: "beginner-level2",
        order: 246,
        title: { zh: "防守 2 · 4/12", en: "Defense 2 · 4/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fnbocodohqfr", white: "bpcpdpep" },
            marks: { 1: "fr" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-5",
        chapterId: "beginner-level2",
        order: 247,
        title: { zh: "防守 2 · 5/12", en: "Defense 2 · 5/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnep", white: "cpdpgq" },
            marks: { 1: "ep" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-6",
        chapterId: "beginner-level2",
        order: 248,
        title: { zh: "防守 2 · 6/12", en: "Defense 2 · 6/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnboep", white: "bpcpgq" },
            marks: { 1: "ep" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-7",
        chapterId: "beginner-level2",
        order: 249,
        title: { zh: "防守 2 · 7/12", en: "Defense 2 · 7/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dldnbocoipfqhq", white: "bpcpdp" },
            marks: { 1: "fq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-8",
        chapterId: "beginner-level2",
        order: 250,
        title: { zh: "防守 2 · 8/12", en: "Defense 2 · 8/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckclembo", white: "dpfqhq" },
            marks: { 1: "bo" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-9",
        chapterId: "beginner-level2",
        order: 251,
        title: { zh: "防守 2 · 9/12", en: "Defense 2 · 9/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncodogoep", white: "boapcpgpcqgqhr" },
            marks: { 1: "ep" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-10",
        chapterId: "beginner-level2",
        order: 252,
        title: { zh: "防守 2 · 10/12", en: "Defense 2 · 10/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnenhpfq", white: "bpcpep" },
            marks: { 1: "fq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-11",
        chapterId: "beginner-level2",
        order: 253,
        title: { zh: "防守 2 · 11/12", en: "Defense 2 · 11/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "elenbocodogqiqer", white: "bpcpdpep" },
            marks: { 1: "er" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-2-12",
        chapterId: "beginner-level2",
        order: 254,
        title: { zh: "防守 2 · 12/12", en: "Defense 2 · 12/12" },
        instruction: { zh: "白先。黑棋走了1。防守白棋的领地。", en: "White to play. Black has played 1. Defend White's territory." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dkcn", white: "epgqiq" },
            marks: { 1: "cn" },
            correct: ["cp"],
        },
    },
];

const bl2Defense3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-defense-3-1",
        chapterId: "beginner-level2",
        order: 255,
        title: { zh: "防守 3 · 1/12", en: "Defense 3 · 1/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofq", white: "cndp" },
            marks: { 1: "do", A: "co", B: "eo", C: "cp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-2",
        chapterId: "beginner-level2",
        order: 256,
        title: { zh: "防守 3 · 2/12", en: "Defense 3 · 2/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doepdqfq", white: "cncodpcq" },
            marks: { 1: "ep", A: "dn", B: "cp", C: "dr" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-3",
        chapterId: "beginner-level2",
        order: 257,
        title: { zh: "防守 3 · 3/12", en: "Defense 3 · 3/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpfqhq", white: "clcncodqeq" },
            marks: { 1: "dp", A: "cp", B: "bq", C: "cq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-4",
        chapterId: "beginner-level2",
        order: 258,
        title: { zh: "防守 3 · 4/12", en: "Defense 3 · 4/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodqfq", white: "cncodp" },
            marks: { 1: "dq", A: "cp", B: "cq", C: "eq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-5",
        chapterId: "beginner-level2",
        order: 259,
        title: { zh: "防守 3 · 5/12", en: "Defense 3 · 5/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlbmcnbo", white: "cpdpfq" },
            marks: { 1: "bo", A: "co", B: "bp", C: "bq" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-6",
        chapterId: "beginner-level2",
        order: 260,
        title: { zh: "防守 3 · 6/12", en: "Defense 3 · 6/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fodpepbqcqfqgq", white: "clcncocpdqeqcr" },
            marks: { 1: "bq", A: "bp", B: "aq", C: "br" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-7",
        chapterId: "beginner-level2",
        order: 261,
        title: { zh: "防守 3 · 7/12", en: "Defense 3 · 7/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cofq", white: "dndp" },
            marks: { 1: "co", A: "dl", B: "do", C: "cp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-8",
        chapterId: "beginner-level2",
        order: 262,
        title: { zh: "防守 3 · 8/12", en: "Defense 3 · 8/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepeqhqer", white: "cldncodqdr" },
            marks: { 1: "dp", A: "cp", B: "bq", C: "cq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-9",
        chapterId: "beginner-level2",
        order: 263,
        title: { zh: "防守 3 · 9/12", en: "Defense 3 · 9/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcndocp", white: "epdqhq" },
            marks: { 1: "cp", A: "bq", B: "cq", C: "cr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-10",
        chapterId: "beginner-level2",
        order: 264,
        title: { zh: "防守 3 · 10/12", en: "Defense 3 · 10/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cofq", white: "cndp" },
            marks: { 1: "co", A: "cm", B: "do", C: "cp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-11",
        chapterId: "beginner-level2",
        order: 265,
        title: { zh: "防守 3 · 11/12", en: "Defense 3 · 11/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcndnbo", white: "codpfqhq" },
            marks: { 1: "bo", A: "bn", B: "bp", C: "cp" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level2-bl2-defense-3-12",
        chapterId: "beginner-level2",
        order: 266,
        title: { zh: "防守 3 · 12/12", en: "Defense 3 · 12/12" },
        instruction: { zh: "白先。对黑棋的1选择最佳防守，A、B或C。", en: "White to play. Choose the best defense in reply of Black's 1, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfpcqeqhqer", white: "cldncocpdqdr" },
            marks: { 1: "cq", A: "bq", B: "br", C: "cr" },
            correct: ["cr"],
        },
    },
];

const bl2MiaiLevels: Level[] = [
    {
        id: "beginner-level2-bl2-miai-1",
        chapterId: "beginner-level2",
        order: 267,
        title: { zh: "见合 · 1/7", en: "Miai · 1/7" },
        instruction: { zh: "本例中黑棋的棋子形成了竹节连接。如果白棋试图在A处切断，黑棋可以在B处应对；如果白棋下在B，黑棋则在A处连接。我们称之为'见合'。如果白棋下在A，黑棋应该下在哪里？", en: "The black stones in this example form a bamboo connection. If White tries to cut at A, Black can respond by playing at B and if White plays at B, Black connects at A. We call this 'miai'. Where should Black play, if White plays at A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnendpep", white: "cncocpfnfofp" },
            marks: { A: "do", B: "eo" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-2",
        chapterId: "beginner-level2",
        order: 268,
        title: { zh: "见合 · 2/7", en: "Miai · 2/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcodoeobpaqbrcrdrer", white: "hodpfpbqcqdqfqhq" },
            marks: { A: "eq" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-3",
        chapterId: "beginner-level2",
        order: 269,
        title: { zh: "见合 · 3/7", en: "Miai · 3/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bococpcqdqgqer", white: "bpbqarbrcrbsds" },
            marks: { A: "ap" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-4",
        chapterId: "beginner-level2",
        order: 270,
        title: { zh: "见合 · 4/7", en: "Miai · 4/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcodoeohobpfpbqgqgr", white: "cpdpcqeqcrdrerbsdsfs" },
            marks: { A: "br" },
            correct: ["fr"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-5",
        chapterId: "beginner-level2",
        order: 271,
        title: { zh: "见合 · 5/7", en: "Miai · 5/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpepdqgqdrds", white: "bqcqarcrbs" },
            marks: { A: "aq" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-6",
        chapterId: "beginner-level2",
        order: 272,
        title: { zh: "见合 · 6/7", en: "Miai · 6/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clambmcncodpgpdqcr", white: "bnboapbpbqarbr" },
            marks: { A: "an" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-miai-7",
        chapterId: "beginner-level2",
        order: 273,
        title: { zh: "见合 · 7/7", en: "Miai · 7/7" },
        instruction: { zh: "这是一个见合局面。如果黑棋下在A，白棋应该下在哪里？", en: "This is a miai position. Where should White play if Black plays A?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmaqbqcqdqeqgqfrfs", white: "arbrcrdreres" },
            marks: { A: "bs" },
            correct: ["cs"],
        },
    },
];

const bl2Eye1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-eye1-1",
        chapterId: "beginner-level2",
        order: 274,
        title: { zh: "眼1 · 1/13", en: "Eye 1 · 1/13" },
        instruction: { zh: "有时你可以通过扑入迫使对手填补眼位，使对手留下假眼。白先。通过扑入制造假眼。", en: "Sometimes you can force your opponent to fill eye space by throwing in, leaving your opponent with a false eye. White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrbses", white: "aqbqcqdqeqerfr" },
            correct: ["ds"],
            wrong: ["fsds", "csds"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-2",
        chapterId: "beginner-level2",
        order: 275,
        title: { zh: "眼1 · 2/13", en: "Eye 1 · 2/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrbsesfs", white: "bqcqdqfqergrgs" },
            correct: ["ds"],
            wrong: ["frds"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-3",
        chapterId: "beginner-level2",
        order: 276,
        title: { zh: "眼1 · 3/13", en: "Eye 1 · 3/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqarbrdrbsds", white: "coeobpbqdqeqgqer" },
            correct: ["cr"],
            wrong: ["cpcr"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-4",
        chapterId: "beginner-level2",
        order: 277,
        title: { zh: "眼1 · 4/13", en: "Eye 1 · 4/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epeqarbrcrdrfrdsfs", white: "dneogodpbqcqdqfqgqiqgrbs" },
            correct: ["er"],
            wrong: ["fper"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-5",
        chapterId: "beginner-level2",
        order: 278,
        title: { zh: "眼1 · 5/13", en: "Eye 1 · 5/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docpepcqeqcrdrercses", white: "dmcnencoeofobpfpbqfqbrfr" },
            correct: ["dp"],
            wrong: ["dndp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-6",
        chapterId: "beginner-level2",
        order: 279,
        title: { zh: "眼1 · 6/13", en: "Eye 1 · 6/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anaobpbqarbrcrcs", white: "dlambmenbococpcqeqdr" },
            correct: ["ap"],
            wrong: ["bnap"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-7",
        chapterId: "beginner-level2",
        order: 280,
        title: { zh: "眼1 · 7/13", en: "Eye 1 · 7/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eqfqarbrdrfrcses", white: "doepfpgpbqcqdqgqcrgr" },
            correct: ["bs"],
            wrong: ["aqbs"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-8",
        chapterId: "beginner-level2",
        order: 281,
        title: { zh: "眼1 · 8/13", en: "Eye 1 · 8/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqcqdqbrdrbsds", white: "bpcpdpepbqeqer" },
            correct: ["ar"],
            wrong: ["apar"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-9",
        chapterId: "beginner-level2",
        order: 282,
        title: { zh: "眼1 · 9/13", en: "Eye 1 · 9/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqbrdrerfrbscsfs", white: "bpcpcqdqeqfqgqcrgr" },
            correct: ["ds"],
            wrong: ["gsds"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-10",
        chapterId: "beginner-level2",
        order: 283,
        title: { zh: "眼1 · 10/13", en: "Eye 1 · 10/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnbodobpdpcqbrcrdrbsds", white: "ckambmcmemanenaoeoapepaqbqdqeqarer" },
            correct: ["cp"],
            wrong: ["dmcp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-11",
        chapterId: "beginner-level2",
        order: 284,
        title: { zh: "眼1 · 11/13", en: "Eye 1 · 11/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnbodocpdpcqbrdrbsds", white: "ambmcmemanenaoeoapepaqbqdqeqarfr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-12",
        chapterId: "beginner-level2",
        order: 285,
        title: { zh: "眼1 · 12/13", en: "Eye 1 · 12/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fqgqbrcrdrfrhrbsesfshs", white: "eohofpgpbqcqdqeqhqiqarerir" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level2-bl2-eye1-13",
        chapterId: "beginner-level2",
        order: 286,
        title: { zh: "眼1 · 13/13", en: "Eye 1 · 13/13" },
        instruction: { zh: "白先。通过扑入制造假眼。", en: "White to play. Make an eye false by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbnbocoapbqarbrcrdrds", white: "ckblcmcndndofobpcpcqeqergrbs" },
            correct: ["ao"],
        },
    },
];

const bl2Eye2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-eye2-1",
        chapterId: "beginner-level2",
        order: 287,
        title: { zh: "眼2 · 1/12", en: "Eye 2 · 1/12" },
        instruction: { zh: "白棋似乎有两只眼，但其中一只眼还不安全。黑先。使白棋的一只眼变成假眼。", en: "White seems to have two eyes, but one of the eyes is not safe yet. Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncnenaocpdpdqdr", white: "bobpaqcqbrcrbs" },
            correct: ["ap"],
            wrong: ["coap", "asap"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-2",
        chapterId: "beginner-level2",
        order: 288,
        title: { zh: "眼2 · 2/12", en: "Eye 2 · 2/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "boapcpdpeqercsds", white: "bpbqarcrbs" },
            correct: ["cq"],
            wrong: ["drcq"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-3",
        chapterId: "beginner-level2",
        order: 289,
        title: { zh: "眼2 · 3/12", en: "Eye 2 · 3/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndnbododpfqfrdsesfs", white: "cocpcqbrdrercs" },
            correct: ["dq"],
            wrong: ["eqdq"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-4",
        chapterId: "beginner-level2",
        order: 290,
        title: { zh: "眼2 · 4/12", en: "Eye 2 · 4/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnenbobpcpfpfqfr", white: "cododpbqcqeqbrdrer" },
            correct: ["ep"],
            wrong: ["eoep"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-5",
        chapterId: "beginner-level2",
        order: 291,
        title: { zh: "眼2 · 5/12", en: "Eye 2 · 5/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmembncnfngngofpgpcqdqeq", white: "aobodoeofoapcpdpbqarcr" },
            correct: ["co"],
            wrong: ["csdr"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-6",
        chapterId: "beginner-level2",
        order: 292,
        title: { zh: "眼2 · 6/12", en: "Eye 2 · 6/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdmemanbneneodpcqdqdr", white: "dnbocodoapcpbqarcrbs" },
            correct: ["ao"],
            wrong: ["dscs", "csds"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-7",
        chapterId: "beginner-level2",
        order: 293,
        title: { zh: "眼2 · 7/12", en: "Eye 2 · 7/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcnfnbocofobpfpfqfr", white: "doeocpepbqdqcrerds" },
            correct: ["eq"],
            wrong: ["aqar", "esfs"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-8",
        chapterId: "beginner-level2",
        order: 294,
        title: { zh: "眼2 · 8/12", en: "Eye 2 · 8/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmemcnenbpcpfpfqhq", white: "dndodpcqeqbrdrfr" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-9",
        chapterId: "beginner-level2",
        order: 295,
        title: { zh: "眼2 · 9/12", en: "Eye 2 · 9/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blbmcmcncoeocpcq", white: "amanbnboapaqbqeqarcrbs" },
            correct: ["bp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-10",
        chapterId: "beginner-level2",
        order: 296,
        title: { zh: "眼2 · 10/12", en: "Eye 2 · 10/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnbocpcqeqdr", white: "aobpbqarcrbs" },
            correct: ["ap"],
            wrong: ["anap"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-11",
        chapterId: "beginner-level2",
        order: 297,
        title: { zh: "眼2 · 11/12", en: "Eye 2 · 11/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcnbococpcqeqfqfr", white: "anbnaobpbqarbrcrdrer" },
            correct: ["ap"],
            wrong: ["amap", "esap"],
        },
    },
    {
        id: "beginner-level2-bl2-eye2-12",
        chapterId: "beginner-level2",
        order: 298,
        title: { zh: "眼2 · 12/12", en: "Eye 2 · 12/12" },
        instruction: { zh: "黑先。使白棋的一只眼变成假眼。", en: "Black to play. Make a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndndofodqeqfqhq", white: "bocoapdpepbqcqdr" },
            correct: ["cp"],
            wrong: ["eocp"],
        },
    },
];

const bl2Eye3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-eye3-1",
        chapterId: "beginner-level2",
        order: 299,
        title: { zh: "眼3 · 1/12", en: "Eye 3 · 1/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbmcndneneodpepeqerdses", white: "anbnaocodobpcqdqbrdrcs" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-2",
        chapterId: "beginner-level2",
        order: 300,
        title: { zh: "眼3 · 2/12", en: "Eye 3 · 2/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfpcqdqhqcrer", white: "cmdneobpcpdpaqbqarbs" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-3",
        chapterId: "beginner-level2",
        order: 301,
        title: { zh: "眼3 · 3/12", en: "Eye 3 · 3/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdmemfmcngnfpgpeqcrdr", white: "bndnencoeobpdpbqcqbr" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-4",
        chapterId: "beginner-level2",
        order: 302,
        title: { zh: "眼3 · 4/12", en: "Eye 3 · 4/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckcmdmemfnfocpfpcqeqcr", white: "bndnenaocodobpdpbq" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-5",
        chapterId: "beginner-level2",
        order: 303,
        title: { zh: "眼3 · 5/12", en: "Eye 3 · 5/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblamcmcndoeoepeqcrdr", white: "bnaocobpdpbqcqdqbr" },
            correct: ["an"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-6",
        chapterId: "beginner-level2",
        order: 304,
        title: { zh: "眼3 · 6/12", en: "Eye 3 · 6/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bkelambmdmeneocpdpepeqer", white: "bndnaocodobpcqdqcr" },
            correct: ["an"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-7",
        chapterId: "beginner-level2",
        order: 305,
        title: { zh: "眼3 · 7/12", en: "Eye 3 · 7/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bkcldlelbmdneneoepeqer", white: "cmcnbodocpdpbqdqdr" },
            correct: ["bn"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-8",
        chapterId: "beginner-level2",
        order: 306,
        title: { zh: "眼3 · 8/12", en: "Eye 3 · 8/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckblcmbncncocpdqeqer", white: "ambmanbobpaqbqcqcrdr" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-9",
        chapterId: "beginner-level2",
        order: 307,
        title: { zh: "眼3 · 9/12", en: "Eye 3 · 9/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcndneneocpdpepcqfqfrfs", white: "bocodobpbqdqarcrercsdses" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-10",
        chapterId: "beginner-level2",
        order: 308,
        title: { zh: "眼3 · 10/12", en: "Eye 3 · 10/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldlbmembnbodoeoepfqer", white: "cmcncobpdpbqdqcrdr" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-11",
        chapterId: "beginner-level2",
        order: 309,
        title: { zh: "眼3 · 11/12", en: "Eye 3 · 11/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmembnfngnhogpcqdqeqfqcrcs", white: "cndnenaobodofobpcpepbqbrbs" },
            correct: ["dp"],
            wrong: ["fpdp"],
        },
    },
    {
        id: "beginner-level2-bl2-eye3-12",
        chapterId: "beginner-level2",
        order: 310,
        title: { zh: "眼3 · 12/12", en: "Eye 3 · 12/12" },
        instruction: { zh: "白先。阻止黑棋使白棋的眼变成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckbldlelglcmendoeocpbqcqdqcreres", white: "bmdmbndnbocoapbpaqbrdrbscs" },
            correct: ["ar"],
        },
    },
];

const bl2Endgame1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-endgame1-1",
        chapterId: "beginner-level2",
        order: 311,
        title: { zh: "收官1 · 1/13", en: "Endgame 1 · 1/13" },
        instruction: { zh: "在收官阶段，领地的边界会确定下来。白棋通过第1手棋确定了黑白领地的边界。但现在黑棋必须小心，因为白棋可以通过下在A处吃掉标记出的两颗黑棋。黑棋可以通过自己下在A来避免这种情况。这样黑棋就抵御了对其领地的一次小侵入。黑先。防守黑棋的弱点。", en: "In the endgame the exact borders of the territories get laid down. With move 1 white has established the border between the white and black territories. But now Black must take care, because White can catch the two marked black stones by playing at A. Black can avoid that by playing at A himself. In this way black defends against a small intrusion in his territory. Black to play. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbnbrcocpcqdrds", white: "ambmckclcndndodpdqeres" },
            marks: { 1: "am", triangle: "anbn", A: "bo" },
            correct: ["bo"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-2",
        chapterId: "beginner-level2",
        order: 312,
        title: { zh: "收官1 · 2/13", en: "Endgame 1 · 2/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdnbododpcqeqeres", white: "alblcldmemeneoepfpdqfqdrfr" },
            marks: { 1: "ep" },
            correct: ["cr", "ds", "cs"],
            wrong: ["fsgs", "cpcr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-3",
        chapterId: "beginner-level2",
        order: 313,
        title: { zh: "收官1 · 3/13", en: "Endgame 1 · 3/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmdnbodoeocpepcqeqcreres", white: "dkalblcldmemcnenfodpfpdqfqdrfrfs" },
            marks: { 1: "al" },
            correct: ["bn", "co", "an"],
            wrong: ["dsbn"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-4",
        chapterId: "beginner-level2",
        order: 314,
        title: { zh: "收官1 · 4/13", en: "Endgame 1 · 4/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmandndocpdpbqdqcr", white: "dkalblclamdmemeneoepeqdrer" },
            marks: { 1: "dm" },
            correct: ["cn", "bn", "bo", "ao"],
            wrong: ["dsbn", "csbn"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-5",
        chapterId: "beginner-level2",
        order: 315,
        title: { zh: "收官1 · 5/13", en: "Endgame 1 · 5/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocododpcqdreres", white: "anbncndneoepdqeqfqfrfs" },
            marks: { 1: "dq" },
            correct: ["cr", "cs", "br"],
            wrong: ["cpcr", "bscr", "bqcr", "dscr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-6",
        chapterId: "beginner-level2",
        order: 316,
        title: { zh: "收官1 · 6/13", en: "Endgame 1 · 6/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcnbocpcqarcrbs", white: "blcldmdncododpbqdqdrcsds" },
            marks: { 1: "cs" },
            correct: ["bp", "br", "aq"],
            wrong: ["apbr", "asbp", "albr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-7",
        chapterId: "beginner-level2",
        order: 317,
        title: { zh: "收官1 · 7/13", en: "Endgame 1 · 7/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncndnaododpcqeqdrerds", white: "elambmcmdmaneneoepfqfresfs" },
            marks: { 1: "am" },
            correct: ["bp", "ap", "bq", "bo", "br", "aq"],
            wrong: ["dqbo", "cpbo"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-8",
        chapterId: "beginner-level2",
        order: 318,
        title: { zh: "收官1 · 8/13", en: "Endgame 1 · 8/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcnbocpbqcqcrcs", white: "alblcldmdncodobpdpdqdrds" },
            marks: { 1: "co" },
            correct: ["ap", "ao", "an", "bn"],
            wrong: ["aqan"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-9",
        chapterId: "beginner-level2",
        order: 319,
        title: { zh: "收官1 · 9/13", en: "Endgame 1 · 9/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmcncocpdqcrdrcs", white: "alblcldmdndodpcqeqerdses" },
            marks: { 1: "ds" },
            correct: ["bq", "bp", "br", "ar"],
            wrong: ["apbqbrar"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-10",
        chapterId: "beginner-level2",
        order: 320,
        title: { zh: "收官1 · 10/13", en: "Endgame 1 · 10/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblcldmcndnbobpdpcqdqdrds", white: "akbkckdkdlemencodoeocpepeqeres" },
            marks: { 1: "do" },
            correct: ["bn", "bm", "cm", "an"],
            wrong: ["ambncman", "bqbn", "brbn", "aqbn"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-11",
        chapterId: "beginner-level2",
        order: 321,
        title: { zh: "收官1 · 11/13", en: "Endgame 1 · 11/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcpdqcrerfrdsfs", white: "aobocoeodpgpaqeqfqbrgrhr" },
            marks: { 1: "ao" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-12",
        chapterId: "beginner-level2",
        order: 322,
        title: { zh: "收官1 · 12/13", en: "Endgame 1 · 12/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcpdqeqgqhqdrfrhrgshs", white: "aobocodoiodpepfpgphpfqiqeriris" },
            marks: { 1: "fq" },
            correct: ["cq", "cr", "br", "cs", "es", "dscqbqcrbr"],
            wrong: ["bscqbqcr", "bscqcrbq", "dscqbqcrcsbr", "dscqcrbq"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame1-13",
        chapterId: "beginner-level2",
        order: 323,
        title: { zh: "收官1 · 13/13", en: "Endgame 1 · 13/13" },
        instruction: { zh: "黑先。白棋已下第1手。防守黑棋的弱点。", en: "Black to play. White has played stone 1. Defend Black's weak spot." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocoapdpepbqfqgqergrfs", white: "anbncnfnaodoeofpgpiphqbrhr" },
            marks: { 1: "ao" },
            correct: ["cp", "cq", "bp", "crcpbp"],
            wrong: ["hscp", "eqcp", "drcp"],
        },
    },
];

const bl2Endgame2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-endgame2-1",
        chapterId: "beginner-level2",
        order: 324,
        title: { zh: "收官2 · 1/13", en: "Endgame 2 · 1/13" },
        instruction: { zh: "在收官阶段，你可以通过比较白棋下在某处后的目数与黑棋下在该处后的目数来计算一手棋的价值。黑棋下在那里与白棋下在那里的差值就是这手棋的价值。在本图中下在A点，白棋会得到一个被提的棋子和一目领地，因此白棋获得2目。如果黑棋下在A点，黑棋会得到两个被提的棋子和2目领地，所以黑棋获得4目。黑棋和白棋下在A点的差值是6目。下在A点的价值是多少？", en: "You can calculate the value of a move in the endgame by comparing the number of points if White plays at a position with the number of points if Black plays there. The difference between Black playing there and White playing there is the value of the move. Playing at A in this diagram yields White a captured stone and a point of territory. So, that is 2 points for White. If Black plays at A, Black gets 2 captured stones and 2 points of territory, so 4 points for Black. The difference between Black and White playing at A is 6 points. What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bqbrbscncocpcqdr", white: "crcsdndodpdqeqeres" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "在收官阶段，你可以通过比较白棋下在某处后的目数与黑棋下在该处后的目数来计算一手棋的价值。黑棋下在那里与白棋下在那里的差值就是这手棋的价值。在本图中下在A点，白棋会得到一个被提的棋子和一目领地，因此白棋获得2目。如果黑棋下在A点，黑棋会得到两个被提的棋子和2目领地，所以黑棋获得4目。黑棋和白棋下在A点的差值是6目。下在A点的价值是多少？", en: "You can calculate the value of a move in the endgame by comparing the number of points if White plays at a position with the number of points if Black plays there. The difference between Black playing there and White playing there is the value of the move. Playing at A in this diagram yields White a captured stone and a point of territory. So, that is 2 points for White. If Black plays at A, Black gets 2 captured stones and 2 points of territory, so 4 points for Black. The difference between Black and White playing at A is 6 points. What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bqbrbscncocpcqdr", white: "crcsdndodpdqeqeres" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-2",
        chapterId: "beginner-level2",
        order: 325,
        title: { zh: "收官2 · 2/13", en: "Endgame 2 · 2/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmdncocpdqbrcrdrbs", white: "endofodpeqgqeres" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmdncocpdqbrcrdrbs", white: "endofodpeqgqeres" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-3",
        chapterId: "beginner-level2",
        order: 326,
        title: { zh: "收官2 · 3/13", en: "Endgame 2 · 3/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dldmdndobpdpcqarbrcr", white: "elemeneoepdqfqgqdrascsds" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dldmdndobpdpcqarbrcr", white: "elemeneoepdqfqgqdrascsds" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-4",
        chapterId: "beginner-level2",
        order: 327,
        title: { zh: "收官2 · 4/13", en: "Endgame 2 · 4/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmdncodobpcqdqbrdrcs", white: "eneogofpeqgqerdses" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "1",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmdncodobpcqdqbrdrcs", white: "eneogofpeqgqerdses" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-5",
        chapterId: "beginner-level2",
        order: 328,
        title: { zh: "收官2 · 5/13", en: "Endgame 2 · 5/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dldmdnbododpaqbqcqcr", white: "elemeneoepfpdqdrfrcsds" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dldmdnbododpaqbqcqcr", white: "elemeneoepfpdqdrfrcsds" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-6",
        chapterId: "beginner-level2",
        order: 329,
        title: { zh: "收官2 · 6/13", en: "Endgame 2 · 6/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmcnencoeobpdpcqdqbrbsds", white: "fnfoepfpeqergrfs" },
            marks: { A: "dr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmcnencoeobpdpcqdqbrbsds", white: "fnfoepfpeqergrfs" },
                marks: { A: "dr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-7",
        chapterId: "beginner-level2",
        order: 330,
        title: { zh: "收官2 · 7/13", en: "Endgame 2 · 7/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dldmanbndnbodobpcpbq", white: "elemeneoapdpepcqfqarbrcr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dldmanbndnbodobpcpbq", white: "elemeneoapdpepcqfqarbrcr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-8",
        chapterId: "beginner-level2",
        order: 331,
        title: { zh: "收官2 · 8/13", en: "Endgame 2 · 8/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dndodpbqdqeqcrerbs", white: "fmeofoepfqfresfs" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dndodpbqdqeqcrerbs", white: "fmeofoepfqfresfs" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-9",
        chapterId: "beginner-level2",
        order: 332,
        title: { zh: "收官2 · 9/13", en: "Endgame 2 · 9/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "elemeneodpepcqcrercs", white: "dldmcndndobpcpaqbqbr" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "elemeneodpepcqcrercs", white: "dldmcndndobpcpaqbqbr" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-10",
        chapterId: "beginner-level2",
        order: 333,
        title: { zh: "收官2 · 10/13", en: "Endgame 2 · 10/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmemencodobpdpcqdqbrbsds", white: "fneogoepeqcrdreres" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmemencodobpdpcqdqbrbsds", white: "fneogoepeqcrdreres" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-11",
        chapterId: "beginner-level2",
        order: 334,
        title: { zh: "收官2 · 11/13", en: "Endgame 2 · 11/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dldmdnaobocodocpbqcq", white: "elemeneoapbpepdqeqarbrcr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dldmdnaobocodocpbqcq", white: "elemeneoapbpepdqeqarbrcr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-12",
        chapterId: "beginner-level2",
        order: 335,
        title: { zh: "收官2 · 12/13", en: "Endgame 2 · 12/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "enfndocpdpbqeqfqarcr", white: "blelcmemanbndnbocobpepaq" },
            marks: { A: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "enfndocpdpbqeqfqarcr", white: "blelcmemanbndnbocobpepaq" },
                marks: { A: "ap" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame2-13",
        chapterId: "beginner-level2",
        order: 336,
        title: { zh: "收官2 · 13/13", en: "Endgame 2 · 13/13" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dldmanbndncodocpbqcq", white: "elemeneoapepdqeqarbrcr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dldmanbndncodocpbqcq", white: "elemeneoapepdqeqarbrcr" },
                marks: { A: "aq" },
            },
        },
    },
];

const bl2Endgame3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-endgame3-1",
        chapterId: "beginner-level2",
        order: 337,
        title: { zh: "收官3 · 1/24", en: "Endgame 3 · 1/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dndocpdpfpdqerfrfs", white: "cmcncobpcqbrcrdrbses" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dndocpdpfpdqerfrfs", white: "cmcncobpcqbrcrdrbses" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-2",
        chapterId: "beginner-level2",
        order: 338,
        title: { zh: "收官3 · 2/24", en: "Endgame 3 · 2/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "elemanenaoboeoepdqeqarbrcr", white: "dlambmdmcndncocpbqcq" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "6", label: { zh: "6", en: "6" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "9",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "elemanenaoboeoepdqeqarbrcr", white: "dlambmdmcndncocpbqcq" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-3",
        chapterId: "beginner-level2",
        order: 339,
        title: { zh: "收官3 · 3/24", en: "Endgame 3 · 3/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "endoeogofpcqdqeqfqcrfrfs", white: "dmdncocpdpepbqbrbscs" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "endoeogofpcqdqeqfqcrfrfs", white: "dmdncocpdpepbqbrbscs" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-4",
        chapterId: "beginner-level2",
        order: 340,
        title: { zh: "收官3 · 4/24", en: "Endgame 3 · 4/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "flfmfnfofpfqbrfrbsesfs", white: "dldmdndoepaqbqcqdqeqer" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "9",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "flfmfnfofpfqbrfrbsesfs", white: "dldmdndoepaqbqcqdqeqer" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-5",
        chapterId: "beginner-level2",
        order: 341,
        title: { zh: "收官3 · 5/24", en: "Endgame 3 · 5/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "doeofofphpcqeqgqcrdrfrds", white: "dmbndncocpbqdqbrbscs" },
            marks: { A: "dp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doeofofphpcqeqgqcrdrfrds", white: "dmbndncocpbqdqbrbscs" },
                marks: { A: "dp" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-6",
        chapterId: "beginner-level2",
        order: 342,
        title: { zh: "收官3 · 6/24", en: "Endgame 3 · 6/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "glgmgndofogofpaqbqcqdqeqer", white: "hmhnhogphpfqbrcrdrfrhrcsdses" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "glgmgndofogofpaqbqcqdqeqer", white: "hmhnhogphpfqbrcrdrfrhrcsdses" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-7",
        chapterId: "beginner-level2",
        order: 343,
        title: { zh: "收官3 · 7/24", en: "Endgame 3 · 7/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "enfofpeqerfrgrcsdsgs", white: "cmdoeocpepbqdqarcrdrbs" },
            marks: { A: "es" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "enfofpeqerfrgrcsdsgs", white: "cmdoeocpepbqdqarcrdrbs" },
                marks: { A: "es" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-8",
        chapterId: "beginner-level2",
        order: 344,
        title: { zh: "收官3 · 8/24", en: "Endgame 3 · 8/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "glgmanbncngncoeofogohocpdpfpbqcq", white: "apgphpdqeqfqarbrcrhr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "glgmanbncngncoeofogohocpdpfpbqcq", white: "apgphpdqeqfqarbrcrhr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-9",
        chapterId: "beginner-level2",
        order: 345,
        title: { zh: "收官3 · 9/24", en: "Endgame 3 · 9/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dofobpcpdpcqeqcrerds", white: "dlcmdnaobocoapbqbrcs" },
            marks: { A: "bs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dofobpcpdpcqeqcrerds", white: "dlcmdnaobocoapbqbrcs" },
                marks: { A: "bs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-10",
        chapterId: "beginner-level2",
        order: 346,
        title: { zh: "收官3 · 10/24", en: "Endgame 3 · 10/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "glgmanbncngncofogohocpdpepfpbqcq", white: "aoboapgphpdqeqfqarbrcrhr" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "7",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "glgmanbncngncofogohocpdpepfpbqcq", white: "aoboapgphpdqeqfqarbrcrhr" },
                marks: { A: "aq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-11",
        chapterId: "beginner-level2",
        order: 347,
        title: { zh: "收官3 · 11/24", en: "Endgame 3 · 11/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eohodpepgpfqdrfresfs", white: "dmcnendocpcqdqeqbrerbsds" },
            marks: { A: "cs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eohodpepgpfqdrfresfs", white: "dmcnendocpcqdqeqbrerbsds" },
                marks: { A: "cs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-12",
        chapterId: "beginner-level2",
        order: 348,
        title: { zh: "收官3 · 12/24", en: "Endgame 3 · 12/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "glgmgndofogofpaqbqcqdqeqer", white: "hmhnhogphpfqbrfrhresfs" },
            marks: { A: "ds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "8",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "glgmgndofogofpaqbqcqdqeqer", white: "hmhnhogphpfqbrfrhresfs" },
                marks: { A: "ds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-13",
        chapterId: "beginner-level2",
        order: 349,
        title: { zh: "收官3 · 13/24", en: "Endgame 3 · 13/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dkalblclamdmbndnbododpdqdrds", white: "bmcmcncoapbpcpcqarcrcs" },
            marks: { A: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dkalblclamdmbndnbododpdqdrds", white: "bmcmcncoapbpcpcqarcrcs" },
                marks: { A: "an" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-14",
        chapterId: "beginner-level2",
        order: 350,
        title: { zh: "收官3 · 14/24", en: "Endgame 3 · 14/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmdocpdpaqbqcqcr", white: "epfpdqeqhqbrdrbscs" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmdocpdpaqbqcqcr", white: "epfpdqeqhqbrdrbscs" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-15",
        chapterId: "beginner-level2",
        order: 351,
        title: { zh: "收官3 · 15/24", en: "Endgame 3 · 15/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bmcmdmdncodoapbpcpcqarcrcs", white: "alblcldlflamembncnenboeodpepdqdrds" },
            marks: { A: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "0", label: { zh: "0", en: "0" } }, { value: "5", label: { zh: "5", en: "5" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "7",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmdmdncodoapbpcpcqarcrcs", white: "alblcldlflamembncnenboeodpepdqdrds" },
                marks: { A: "an" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-16",
        chapterId: "beginner-level2",
        order: 352,
        title: { zh: "收官3 · 16/24", en: "Endgame 3 · 16/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmeoepaqbqcqdqeqcreras", white: "fnfoiofpfqiqbrfrbscsdses" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmeoepaqbqcqdqeqcreras", white: "fnfoiofpfqiqbrfrbscsdses" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-17",
        chapterId: "beginner-level2",
        order: 353,
        title: { zh: "收官3 · 17/24", en: "Endgame 3 · 17/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bmcmcncoapbpcpcqarcrcs", white: "dkalblclamdmdnbododpdqdrds" },
            marks: { A: "an" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmcmcncoapbpcpcqarcrcs", white: "dkalblclamdmdnbododpdqdrds" },
                marks: { A: "an" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-18",
        chapterId: "beginner-level2",
        order: 354,
        title: { zh: "收官3 · 18/24", en: "Endgame 3 · 18/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "fobpfpbqfqbrdrerhrbscsds", white: "emenaobocoeocpaqcqdqeqarcr" },
            marks: { A: "ap" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fobpfpbqfqbrdrerhrbscsds", white: "emenaobocoeocpaqcqdqeqarcr" },
                marks: { A: "ap" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-19",
        chapterId: "beginner-level2",
        order: 355,
        title: { zh: "收官3 · 19/24", en: "Endgame 3 · 19/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "enfogoiodpephpaqbqcqdqhqdrhrhs", white: "fpgpeqgqbrcrerfrgrdsesgs" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "enfogoiodpephpaqbqcqdqhqdrhrhs", white: "fpgpeqgqbrcrerfrgrdsesgs" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-20",
        chapterId: "beginner-level2",
        order: 356,
        title: { zh: "收官3 · 20/24", en: "Endgame 3 · 20/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "foephpeqbrcrerbsdses", white: "dlcmdodpaqbqcqdqdr" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "foephpeqbrcrerbsdses", white: "dlcmdodpaqbqcqdqdr" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-21",
        chapterId: "beginner-level2",
        order: 357,
        title: { zh: "收官3 · 21/24", en: "Endgame 3 · 21/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "gnaobocodoeofocpgpgqergresgs", white: "apbpdpepfpcqdqfqbrdrfrds" },
            marks: { A: "fs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "5",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "gnaobocodoeofocpgpgqergresgs", white: "apbpdpepfpcqdqfqbrdrfrds" },
                marks: { A: "fs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-22",
        chapterId: "beginner-level2",
        order: 358,
        title: { zh: "收官3 · 22/24", en: "Endgame 3 · 22/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dodpcqeqarcrcs", white: "cmdncobpcpaqbqasbs" },
            marks: { A: "br" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "6",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dodpcqeqarcrcs", white: "cmdncobpcpaqbqasbs" },
                marks: { A: "br" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-23",
        chapterId: "beginner-level2",
        order: 359,
        title: { zh: "收官3 · 23/24", en: "Endgame 3 · 23/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "coeoepaqbqcqdqdr", white: "fpeqgqbrcrercsds" },
            marks: { A: "ar" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "coeoepaqbqcqdqdr", white: "fpeqgqbrcrercsds" },
                marks: { A: "ar" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame3-24",
        chapterId: "beginner-level2",
        order: 360,
        title: { zh: "收官3 · 24/24", en: "Endgame 3 · 24/24" },
        instruction: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dpepbqcqcrercs", white: "cndoapbpcparbrbs" },
            marks: { A: "aq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "下在A点的价值是多少？", en: "What is the value of playing at A?" },
            options: [{ value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "8",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dpepbqcqcrercs", white: "cndoapbpcparbrbs" },
                marks: { A: "aq" },
            },
        },
    },
];

const bl2Endgame4Levels: Level[] = [
    {
        id: "beginner-level2-bl2-endgame4-1",
        chapterId: "beginner-level2",
        order: 361,
        title: { zh: "收官4 · 1/6", en: "Endgame 4 · 1/6" },
        instruction: { zh: "在对局结束时，棋盘上经常会在白棋和黑棋的领地之间留下一些单独的空交叉点。这样的交叉点不属于任何一方的领地，称为单官（日语为'dame'）。这局棋已经结束了。你数出多少个单官？", en: "At the end of the game often some single empty intersections on the board are left between white and black territories. Such an intersection is not a point of territory for any of the players. It is called a neutral point (in Japanese 'dame'). This game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dafaiacbdbebfbibbcdcddaebecedebfdfahbhchdhbidi", white: "gagbecfcgchcicedgdeegeefagbgcgdgegfgggfhhhfigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "在对局结束时，棋盘上经常会在白棋和黑棋的领地之间留下一些单独的空交叉点。这样的交叉点不属于任何一方的领地，称为单官（日语为'dame'）。这局棋已经结束了。你数出多少个单官？", en: "At the end of the game often some single empty intersections on the board are left between white and black territories. Such an intersection is not a point of territory for any of the players. It is called a neutral point (in Japanese 'dame'). This game has finished. How many neutral points do you count?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }],
            correctValue: "4",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dafaiacbdbebfbibbcdcddaebecedebfdfahbhchdhbidi", white: "gagbecfcgchcicedgdeegeefagbgcgdgegfgggfhhhfigi" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame4-2",
        chapterId: "beginner-level2",
        order: 362,
        title: { zh: "收官4 · 2/6", en: "Endgame 4 · 2/6" },
        instruction: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gaiaabbbcbdbgbhbdchcicbdddedceeeefagbgcgdgdhehfhei", white: "bacadaeaebfbfcgcgdhdfegeieffhffghgahbhchghihcigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
            options: [{ value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "7",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gaiaabbbcbdbgbhbdchcicbdddedceeeefagbgcgdgdhehfhei", white: "bacadaeaebfbfcgcgdhdfegeieffhffghgahbhchghihcigi" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame4-3",
        chapterId: "beginner-level2",
        order: 363,
        title: { zh: "收官4 · 3/6", en: "Endgame 4 · 3/6" },
        instruction: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dabbdbdcadbdcdddedaedefegeheieefeghgehfhghhhih", white: "fafbhbfchcfdgdhdidafbfcfdfdgahchdhbidieifigihi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "6",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dabbdbdcadbdcdddedaedefegeheieefeghgehfhghhhih", white: "fafbhbfchcfdgdhdidafbfcfdfdgahchdhbidieifigihi" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame4-4",
        chapterId: "beginner-level2",
        order: 364,
        title: { zh: "收官4 · 4/6", en: "Endgame 4 · 4/6" },
        instruction: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cahacbhbccdcgcbdddgddefegeheafbfdfhfcghgigchhhci", white: "eagaebfbgbecedeeefffgfdgegggahbhdhfhghbidigihi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "6",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cahacbhbccdcgcbdddgddefegeheafbfdfhfcghgigchhhci", white: "eagaebfbgbecedeeefffgfdgegggahbhdhfhghbidigihi" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame4-5",
        chapterId: "beginner-level2",
        order: 365,
        title: { zh: "收官4 · 5/6", en: "Endgame 4 · 5/6" },
        instruction: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ebccfcadbdhdidbecedeeefegehe", white: "bfcfdfefffgfhfagbgggigdhhh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "4",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ebccfcadbdhdidbecedeeefegehe", white: "bfcfdfefffgfhfagbgggigdhhh" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-endgame4-6",
        chapterId: "beginner-level2",
        order: 366,
        title: { zh: "收官4 · 6/6", en: "Endgame 4 · 6/6" },
        instruction: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gabbgbacccdcecfcgchcicbdcdidbeieifbgigahbhihbi", white: "hahbddedfdgdaedegeheafbfcfdfgfcgeggghgchhhcihi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "对局已经结束。你数出多少个单官？", en: "The game has finished. How many neutral points do you count?" },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "5",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gabbgbacccdcecfcgchcicbdcdidbeieifbgigahbhihbi", white: "hahbddedfdgdaedegeheafbfcfdfgfcgeggghgchhhcihi" },
            },
        },
    },
];

const bl2Endgame5Levels: Level[] = [
    {
        id: "beginner-level2-bl2-endgame5-1",
        chapterId: "beginner-level2",
        order: 367,
        title: { zh: "收官5 · 1/12", en: "Endgame 5 · 1/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dkblcldmdnfneofpfqerfrds", white: "bmcmcncodoepcqeqdr" },
            marks: { 1: "ds" },
            correct: ["cs"],
            wrong: ["crcs"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-2",
        chapterId: "beginner-level2",
        order: 368,
        title: { zh: "收官5 · 2/12", en: "Endgame 5 · 2/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblclcmcndnfneofpfqerfrcsds", white: "ambmbnbocodoepcqeqdres" },
            marks: { 1: "cs" },
            correct: ["bs"],
            wrong: ["crbs", "brbs"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-3",
        chapterId: "beginner-level2",
        order: 369,
        title: { zh: "收官5 · 3/12", en: "Endgame 5 · 3/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bkckcleldmdneoepeqdr", white: "blamcmcnbododpdq" },
            marks: { 1: "dr" },
            correct: ["cr"],
            wrong: ["cqcr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-4",
        chapterId: "beginner-level2",
        order: 370,
        title: { zh: "收官5 · 4/12", en: "Endgame 5 · 4/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldmemenfofpeqfqdrcs", white: "bmcmdnbodoeoepcqdqcr" },
            marks: { 1: "cs" },
            correct: ["er"],
            wrong: ["bses", "brds"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-5",
        chapterId: "beginner-level2",
        order: 371,
        title: { zh: "收官5 · 5/12", en: "Endgame 5 · 5/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcndnfneoepeqcrergrds", white: "anbnaocodobpdpdqdrcs" },
            marks: { 1: "cr" },
            correct: ["es"],
            wrong: ["bses", "brbs", "cqbs"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-6",
        chapterId: "beginner-level2",
        order: 372,
        title: { zh: "收官5 · 6/12", en: "Endgame 5 · 6/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcleldmenfngogpcqfqgqdrer", white: "bmcmandnbocoeofpdqeqcrfr" },
            marks: { 1: "cq" },
            correct: ["ds", "es"],
            wrong: ["bqcs", "grbr", "brgr", "csgr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-7",
        chapterId: "beginner-level2",
        order: 373,
        title: { zh: "收官5 · 7/12", en: "Endgame 5 · 7/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckblglcmdmemfmgngogpfqhqerfr", white: "bmancndnenfnbofofpcqeq" },
            marks: { 1: "er" },
            correct: ["dr"],
            wrong: ["dqdr", "crdr", "epdr", "dpdr"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-8",
        chapterId: "beginner-level2",
        order: 374,
        title: { zh: "收官5 · 8/12", en: "Endgame 5 · 8/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcndoeofogpgqfrhresfs", white: "bnaocobpcpdpepfpfqer" },
            marks: { 1: "es" },
            correct: ["dr"],
            wrong: ["dsdr", "crdr", "csdr", "eqds"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-9",
        chapterId: "beginner-level2",
        order: 375,
        title: { zh: "收官5 · 9/12", en: "Endgame 5 · 9/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldmemfnfofpfqfresfs", white: "bmcmancndnboeoepeqer" },
            marks: { 1: "es" },
            correct: ["crcsbsdsbr", "crcsbsdsbq"],
            wrong: ["crcsbsdsardrdqcq", "crcsbrbs", "dsdr", "drds"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-10",
        chapterId: "beginner-level2",
        order: 376,
        title: { zh: "收官5 · 10/12", en: "Endgame 5 · 10/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmenfngogphphqhrfsgs", white: "bncndnaodobpcpepfqgqgr" },
            marks: { 1: "fs" },
            correct: ["erescrcsbsdsbr", "erescrcsbsdsar", "erescrcsbsdsbq"],
            wrong: ["erescrcsbsdsdrbr", "erescrcsdsdr", "erescrcsbrbs", "eresdrds", "frer", "eser"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-11",
        chapterId: "beginner-level2",
        order: 377,
        title: { zh: "收官5 · 11/12", en: "Endgame 5 · 11/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldmemfnfofpeqfqdrer", white: "bmcmbndncoeoepdq" },
            marks: { 1: "dr" },
            correct: ["cqcrbrbqbp"],
            wrong: ["cqcrbrbqaqbp", "cqcrbqbr", "crcq", "bqcrcqbr", "bqcrbrcq"],
        },
    },
    {
        id: "beginner-level2-bl2-endgame5-12",
        chapterId: "beginner-level2",
        order: 378,
        title: { zh: "收官5 · 12/12", en: "Endgame 5 · 12/12" },
        instruction: { zh: "白先。在黑棋下第1手后防守白棋的领地。", en: "White to play. Defend White's territory after Black's move 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmenfngohogqiqgrdsesfs", white: "bncndnaodoeobpcpfpfqerfr" },
            marks: { 1: "ds" },
            correct: ["cr"],
            wrong: ["drcr", "cscr"],
        },
    },
];

const bl2LifeDeath1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-1-1",
        chapterId: "beginner-level2",
        order: 379,
        title: { zh: "死活 · 1/13", en: "Life&Death · 1/13" },
        instruction: { zh: "如果一个棋块还没有两只眼，你应该确保总是能做出两只眼。如果你需要一手棋做一只眼，那么以正确的顺序下这两手棋可能很重要。在本例中，白棋可以通过在A和B处落子做出两只眼。白棋必须在A和B中选择先下哪一点。如果白棋选择错误，他就没有机会做出第二只眼。按正确的顺序做出两只眼。", en: "If a group does not have two eyes yet, you should ensure that you always can make two eyes. If you need one move for each eye, it can be important to play those two moves in the correct order. In this example White can make two eyes by playing at A and B. White has to choose between A and B as the first move. If White chooses the wrong one, he gets no chance to make the second. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcqdodqeqer", white: "bqbrbsdrds" },
            marks: { A: "aq", B: "cr" },
            correct: ["craqar"],
            wrong: ["aqcr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-2",
        chapterId: "beginner-level2",
        order: 380,
        title: { zh: "死活 · 2/13", en: "Life&Death · 2/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbpcpdpfpeqerdses", white: "bqcqdqbrdrbs" },
            correct: ["csaqar"],
            wrong: ["aqcs", "arcs", "apcs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-3",
        chapterId: "beginner-level2",
        order: 381,
        title: { zh: "死活 · 3/13", en: "Life&Death · 3/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocoeodpdqdrcs", white: "apbpcparbrcr" },
            correct: ["bscqbq"],
            wrong: ["cqbs", "bqbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-4",
        chapterId: "beginner-level2",
        order: 382,
        title: { zh: "死活 · 4/13", en: "Life&Death · 4/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocoeocpdqdrds", white: "bpbqcqarcras" },
            correct: ["apcsbs"],
            wrong: ["csap", "bsap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-5",
        chapterId: "beginner-level2",
        order: 383,
        title: { zh: "死活 · 5/13", en: "Life&Death · 5/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eoapbpcpdqeqeres", white: "bqcqbrdrbs" },
            correct: ["dsaqar"],
            wrong: ["aqds", "csds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-6",
        chapterId: "beginner-level2",
        order: 384,
        title: { zh: "死活 · 6/13", en: "Life&Death · 6/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpaqbqcqdqeqfqgrhr", white: "brcrdrerfrcs" },
            correct: ["arfses"],
            wrong: ["asar", "fsar", "esar", "gsar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-7",
        chapterId: "beginner-level2",
        order: 385,
        title: { zh: "死活 · 7/13", en: "Life&Death · 7/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cneofohocpdpgpbqgqbrgrbsgs", white: "epfpcqdqcrerfres" },
            correct: ["fqcsds"],
            wrong: ["csfq", "dsfq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-8",
        chapterId: "beginner-level2",
        order: 386,
        title: { zh: "死活 · 8/13", en: "Life&Death · 8/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdpepfpgphpcqhqbrhrbshs", white: "eqgqcrergrcsesgs" },
            correct: ["dqfqfr"],
            wrong: ["drfqfrdq", "fqdr", "frdr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-9",
        chapterId: "beginner-level2",
        order: 387,
        title: { zh: "死活 · 9/13", en: "Life&Death · 9/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndnfneoepaqeqcrdrerbs", white: "bocodobpcqdqarbr" },
            correct: ["dpaoap"],
            wrong: ["aodp", "apdp", "bqdp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-10",
        chapterId: "beginner-level2",
        order: 388,
        title: { zh: "死活 · 10/13", en: "Life&Death · 10/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnenfnbogobpgpbqfqgqbrfr", white: "codoeofocpcqdqeqcrcs" },
            correct: ["eresdsfpep"],
            wrong: ["fper", "dser", "eser", "eper"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-11",
        chapterId: "beginner-level2",
        order: 389,
        title: { zh: "死活 · 11/13", en: "Life&Death · 11/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bodoeofogocpgpbqcqgqbrgrir", white: "dpfpdqfqcrdrerfrcs" },
            correct: ["epfses"],
            wrong: ["fsep", "esep", "gsep"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-12",
        chapterId: "beginner-level2",
        order: 390,
        title: { zh: "死活 · 12/13", en: "Life&Death · 12/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bodoeofogoiocphpbqhqbrgrhrcsfsgs", white: "dpepfpgpcqdqcrerfres" },
            correct: ["dsgqfq"],
            wrong: ["gqds", "fqds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-1-13",
        chapterId: "beginner-level2",
        order: 391,
        title: { zh: "死活 · 13/13", en: "Life&Death · 13/13" },
        instruction: { zh: "白先。按正确的顺序做出两只眼。", en: "White to play. Make two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codoeofogohobpbqgqhqbrcrhrcshs", white: "cpepfpcqfqdrergres" },
            correct: ["gsdpdq"],
            wrong: ["dpgs", "fsgs", "dqgs"],
        },
    },
];

const bl2LifeDeath2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-2-1",
        chapterId: "beginner-level2",
        order: 392,
        title: { zh: "死活 · 1/12", en: "Life&Death · 1/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnenfncodofofpcqdqeqfqfrgrhrfs", white: "bmdmemfmcngnbogobpgpipbqgqhqcrdreriris" },
            correct: ["hscpep"],
            wrong: ["cphs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-2",
        chapterId: "beginner-level2",
        order: 393,
        title: { zh: "死活 · 2/12", en: "Life&Death · 2/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enfncodoeocpgpcqdqeqfqgqdrfrfs", white: "bmemfmhmcndngnbogobphpbqhqbrcrhrds" },
            correct: ["esfoep"],
            wrong: ["fpes", "foes", "epes"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-3",
        chapterId: "beginner-level2",
        order: 394,
        title: { zh: "死活 · 3/12", en: "Life&Death · 3/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqbrdrbsds", white: "bococpepcqdqer" },
            correct: ["crapar"],
            wrong: ["apcr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-4",
        chapterId: "beginner-level2",
        order: 395,
        title: { zh: "死活 · 4/12", en: "Life&Death · 4/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocodoeofogoapcpcqdqeqfq", white: "bncndnenfngnhnhohpgqbrcrdrerfrgr" },
            correct: ["bqgpep"],
            wrong: ["gpbq", "fpbq", "aqbq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-5",
        chapterId: "beginner-level2",
        order: 396,
        title: { zh: "死活 · 5/12", en: "Life&Death · 5/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeofocpdpcqeqcreres", white: "bndnenfncogobpgpbqbrfrgrbs" },
            correct: ["fpcsdr"],
            wrong: ["csfp", "dsfp", "fqfp", "drfp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-6",
        chapterId: "beginner-level2",
        order: 397,
        title: { zh: "死活 · 6/12", en: "Life&Death · 6/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpdqcrdrerfrgrgs", white: "codoeofohocpgpcqgqhqbrhrbs" },
            correct: ["fqcses"],
            wrong: ["csfq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-7",
        chapterId: "beginner-level2",
        order: 398,
        title: { zh: "死活 · 7/12", en: "Life&Death · 7/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeocpcqdqeqfqcrfrcsds", white: "bndnengncofobpfpbqgqbrgrbs" },
            correct: ["epfser"],
            wrong: ["fsep", "esep"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-8",
        chapterId: "beginner-level2",
        order: 399,
        title: { zh: "死活 · 8/12", en: "Life&Death · 8/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hqgqfqeqbrcrdrfrhresfs", white: "cqdqiqarirasbshsisdoepfpgphpipaqbq" },
            correct: ["csgsds"],
            wrong: ["gscs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-9",
        chapterId: "beginner-level2",
        order: 400,
        title: { zh: "死活 · 9/12", en: "Life&Death · 9/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndnenfnaodocpdpepfpbqcq", white: "ambmcmdmemfmgngogpaqdqeqfqarbrcrgr" },
            correct: ["foapbo"],
            wrong: ["apfo", "bpfo"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-10",
        chapterId: "beginner-level2",
        order: 401,
        title: { zh: "死活 · 10/12", en: "Life&Death · 10/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofodpfpcqdqeqfqcrfres", white: "bndnenfnhncogocpgpbqgqbrgrirbs" },
            correct: ["eocsdr"],
            wrong: ["cseo", "dseo", "dreo"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-11",
        chapterId: "beginner-level2",
        order: 402,
        title: { zh: "死活 · 11/12", en: "Life&Death · 11/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndncoeofogocpdpeqfqgqcrdr", white: "blglcmdmbnenfngnbohobpgphpbqhqbrfrgr" },
            correct: ["fpcqep"],
            wrong: ["cqfp", "erfp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-2-12",
        chapterId: "beginner-level2",
        order: 403,
        title: { zh: "死活 · 12/12", en: "Life&Death · 12/12" },
        instruction: { zh: "白先。按正确的顺序阻止对手做出两只眼。", en: "White to play. Prevent two eyes in the correct order." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epgpcqdqeqgqcrerfrcs", white: "hnboeofogocpdphpbqhqbrgrhr" },
            correct: ["fpfsds"],
            wrong: ["fsfp", "dsfp", "esfp"],
        },
    },
];

const bl2LifeDeath3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-3-1",
        chapterId: "beginner-level2",
        order: 404,
        title: { zh: "死活 · 1/19", en: "Life&Death · 1/19" },
        instruction: { zh: "如果你的棋块眼位只有3个点，你应该立即做出两只眼。否则对手下在3点眼位的中心，你的棋块就死了。在本例中，白棋可以通过在A处落子迫使黑棋形成一个3点的眼位。黑棋吃掉3颗棋子后，白棋可以吃掉黑棋的棋块。白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "If your group has an eye-space of only 3 points, you should make two eyes right away. Otherwise your opponent plays at the centre of the 3-points eye-space and your group is dead. In this example White can force Black to create a 3-points eye space by playing at A. After Black has captured the 3 stones, White can capture the black group. White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpcqcrbrbs", white: "arbobqcodndpdqdr" },
            marks: { A: "aq" },
            correct: ["aqasaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-2",
        chapterId: "beginner-level2",
        order: 405,
        title: { zh: "死活 · 2/19", en: "Life&Death · 2/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqarbrdrds", white: "bpcpdpfpeqcrercs" },
            correct: ["bsascs"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-3",
        chapterId: "beginner-level2",
        order: 406,
        title: { zh: "死活 · 3/19", en: "Life&Death · 3/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbrcrdrerfs", white: "bqcqdqeqfqfrgrcsds" },
            correct: ["bs"],
            wrong: ["esbs", "gsbsesfs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-4",
        chapterId: "beginner-level2",
        order: 407,
        title: { zh: "死活 · 4/19", en: "Life&Death · 4/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepcqfqcrdrfrdsfs", white: "codoeogobpfpbqdqgqbrergr" },
            correct: ["eqeseq"],
            wrong: ["gseq", "eseq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-5",
        chapterId: "beginner-level2",
        order: 408,
        title: { zh: "死活 · 5/19", en: "Life&Death · 5/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codobpdpbqdqbrdrbsds", white: "embncndnboeoapcpepaqfqarcrfr" },
            correct: ["cqcscq"],
            wrong: ["cscq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-6",
        chapterId: "beginner-level2",
        order: 409,
        title: { zh: "死活 · 6/19", en: "Life&Death · 6/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqeqfqbrcrgrbsesfsgs", white: "bohocpdpepfpaqbqgqhqarhrdshs" },
            correct: ["erfrdrcsdr"],
            wrong: ["drer", "frer", "csdr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-7",
        chapterId: "beginner-level2",
        order: 410,
        title: { zh: "死活 · 7/19", en: "Life&Death · 7/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqcqdqarbrdr", white: "apbpcpdpfpaqeqcreres" },
            correct: ["csdsbsascs"],
            wrong: ["bscs", "dscs", "ascs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-8",
        chapterId: "beginner-level2",
        order: 411,
        title: { zh: "死活 · 8/19", en: "Life&Death · 8/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqeqfqgqcrgrcsesfs", white: "bpcpdpepfpgpipbqhqbrfrhrbs" },
            correct: ["drdqerdser"],
            wrong: ["erdr", "dqdr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-9",
        chapterId: "beginner-level2",
        order: 412,
        title: { zh: "死活 · 9/19", en: "Life&Death · 9/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeocpfpcqdqfqdrfrdsfs", white: "gmbndnencofogobpgpbqeqgqbrcrgr" },
            correct: ["epdpereseq"],
            wrong: ["erep", "eser", "dpep"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-10",
        chapterId: "beginner-level2",
        order: 413,
        title: { zh: "死活 · 10/19", en: "Life&Death · 10/19" },
        instruction: { zh: "白先。通过迫使形成3点眼位来吃掉黑棋的棋块。", en: "White to play. Capture the black group by forcing a 3-points eye space." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofocpfpcqeqfqcrdrer", white: "cndnenfnhnbogobpepgpbqdqgqbrgr" },
            correct: ["dpdodp"],
            wrong: ["dodp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-11",
        chapterId: "beginner-level2",
        order: 414,
        title: { zh: "死活 · 11/19", en: "Life&Death · 11/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocoapdpepaqeqcreres", white: "bpbqdqarbrdr" },
            correct: ["cscpcq"],
            wrong: ["cqcsdsbs", "cpcs", "dscscqbs", "bscq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-12",
        chapterId: "beginner-level2",
        order: 415,
        title: { zh: "死活 · 12/19", en: "Life&Death · 12/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpaqbqcqdqeqfrgrhrcsds", white: "arbrcrdrerfs" },
            correct: ["bs"],
            wrong: ["esbs", "gsbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-13",
        chapterId: "beginner-level2",
        order: 416,
        title: { zh: "死活 · 13/19", en: "Life&Death · 13/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocoapcpfpaqcqdqerfr", white: "bpbqarcrdrds" },
            correct: ["bsbrbq"],
            wrong: ["brbs", "esbr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-14",
        chapterId: "beginner-level2",
        order: 417,
        title: { zh: "死活 · 14/19", en: "Life&Death · 14/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bneobpcpdpeqcrergrcs", white: "bqcqdqarbrdr" },
            correct: ["bs"],
            wrong: ["dsbs", "esbs", "apbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-15",
        chapterId: "beginner-level2",
        order: 418,
        title: { zh: "死活 · 15/19", en: "Life&Death · 15/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aqbqcqdqeqfqgqgrirbsdsfs", white: "arbrcrdrerfr" },
            correct: ["cs"],
            wrong: ["escs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-16",
        chapterId: "beginner-level2",
        order: 419,
        title: { zh: "死活 · 16/19", en: "Life&Death · 16/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eohofpbqcqdqfqgqhqbrhr", white: "crdrfrgrcsgs" },
            correct: ["es"],
            wrong: ["eres", "eqes"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-17",
        chapterId: "beginner-level2",
        order: 420,
        title: { zh: "死活 · 17/19", en: "Life&Death · 17/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fodpepbqcqfqgqiqbrhrcs", white: "dqeqcrdrfrgrgs" },
            correct: ["es"],
            wrong: ["dses"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-18",
        chapterId: "beginner-level2",
        order: 421,
        title: { zh: "死活 · 18/19", en: "Life&Death · 18/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncoapcpepbqdqeres", white: "bpcqarcrdrds" },
            correct: ["bs"],
            wrong: ["brbs", "aqbsaobr", "aqbsbrao"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-3-19",
        chapterId: "beginner-level2",
        order: 422,
        title: { zh: "死活 · 19/19", en: "Life&Death · 19/19" },
        instruction: { zh: "白先。阻止形成3点眼位，使白棋的棋块活棋。", en: "White to play. Prevent a 3-points eye space and make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnengnfobpgpbqgqbrgr", white: "doeofpcqeqfqdrer" },
            correct: ["dp"],
            wrong: ["cpdp", "codp"],
        },
    },
];

const bl2LifeDeath4Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-4-1",
        chapterId: "beginner-level2",
        order: 423,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocoapcpbqbrbs", white: "anbncndnenaoeqfqarcrdr" },
            correct: ["cq"],
            wrong: ["aqcq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-2",
        chapterId: "beginner-level2",
        order: 424,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbnbocobqcqarbr", white: "clambmcndndocpepdqcrerbs" },
            correct: ["ap"],
            wrong: ["bpap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-3",
        chapterId: "beginner-level2",
        order: 425,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpepaqbqcqeqcrdrbs", white: "fmdnbocofofpfqarergrds" },
            correct: ["cp"],
            wrong: ["cscp", "brcp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-4",
        chapterId: "beginner-level2",
        order: 426,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcrbs", white: "dmbobpcqdqdrfr" },
            correct: ["ar"],
            wrong: ["csar", "aqar", "apar", "dsar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-5",
        chapterId: "beginner-level2",
        order: 427,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bobpbqeqarbrerascsds", white: "bmbncocpepfpcqfqfrfs" },
            correct: ["cr"],
            wrong: ["aocr", "apcr", "ancr", "dqcr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-6",
        chapterId: "beginner-level2",
        order: 428,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bqcqardrcs", white: "boeobpcpdqeqeres" },
            correct: ["bscrds"],
            wrong: ["bscrbrds", "brds", "crbs", "dsbs", "apbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-7",
        chapterId: "beginner-level2",
        order: 429,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnbocodoapbqarbrcr", white: "ambmcmdneocpepcqeqdrer" },
            correct: ["bp", "dpdqbp"],
            wrong: ["anbp", "csbp", "dsbp", "bsbp", "dpdqanbp", "dpdqbsbp", "dpdqcsbp", "dpdqdsbp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-8",
        chapterId: "beginner-level2",
        order: 430,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnaocobpbqarasbs", white: "ambmcmdmdndodpcqbrcrer" },
            correct: ["aq"],
            wrong: ["anaq", "cpaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-9",
        chapterId: "beginner-level2",
        order: 431,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobpbqarbrcr", white: "bmbococpgpcqdrer" },
            correct: ["ap"],
            wrong: ["csap", "bsap", "dsap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-10",
        chapterId: "beginner-level2",
        order: 432,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbobpbqcqcrbs", white: "bmdmbnaococpdqdrcsds" },
            correct: ["ar"],
            wrong: ["apar", "aqar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-11",
        chapterId: "beginner-level2",
        order: 433,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobobpbqarbrdrcsds", white: "bmbncncocpcqdqfqcrer" },
            correct: ["bs"],
            wrong: ["esbsasfs", "ases"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-12",
        chapterId: "beginner-level2",
        order: 434,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "黑先。做出两只眼，使黑棋的棋块活棋。", en: "Black to play. Make two eyes and make the black group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodocpaqbqcqdq", white: "anbncndnenfobpfpfqarbrcrdrer" },
            correct: ["ep"],
            wrong: ["eoep", "eqep", "apep"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-13",
        chapterId: "beginner-level2",
        order: 435,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqarcrdrbsesfs", white: "boapcpaqcqdqeqergr" },
            correct: ["ds"],
            wrong: ["bpds", "frds", "gsds", "csds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-14",
        chapterId: "beginner-level2",
        order: 436,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbncncobpbq", white: "alblclcmdndodpaqdqbrcr" },
            correct: ["ao"],
            wrong: ["apaocparaqap", "apaocparapaq", "apaoarcp", "cpao", "cqao"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-15",
        chapterId: "beginner-level2",
        order: 437,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobobparbqbrcs", white: "bncncocpcqcrer" },
            correct: ["bs"],
            wrong: ["dsbs", "asbs", "anbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-16",
        chapterId: "beginner-level2",
        order: 438,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdpepbqcqarcrbs", white: "bncoeofoapbpdqfqdrgrcsds" },
            correct: ["aq"],
            wrong: ["fpaq", "doaq", "eqaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-17",
        chapterId: "beginner-level2",
        order: 439,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "amanbobpbqcqarcrcs", white: "blbncnaococpepdqdrbs" },
            correct: ["apaqao"],
            wrong: ["apaqapao", "brap", "aqap", "asap", "alap", "bmap", "dsap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-18",
        chapterId: "beginner-level2",
        order: 440,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeobpcpepaqcqdqbrbs", white: "cmdnenfnaobocoapfpeqfqdr" },
            correct: ["cr", "arascr"],
            wrong: ["focr", "cscr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-19",
        chapterId: "beginner-level2",
        order: 441,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncnbodobpcpdpaqbrbs", white: "bmcmdmdneoepbqcqdqeqcrcs" },
            correct: ["apaoar"],
            wrong: ["apaoasar", "apaoamar", "aoar", "amar", "arap", "asar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-20",
        chapterId: "beginner-level2",
        order: 442,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcncobpdpbqcqdqeqcrbs", white: "cldlbmbnenbodoapepfpfqdrerfr" },
            correct: ["ar"],
            wrong: ["dnar", "dmar", "aqar", "dsar", "brar", "aoar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-21",
        chapterId: "beginner-level2",
        order: 443,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfpcqeqgqcrdrfrgrgs", white: "codoeofobpgphpbqhqbrhrcsdseshs" },
            correct: ["er"],
            wrong: ["cper", "fser", "bser"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-22",
        chapterId: "beginner-level2",
        order: 444,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndodpepcqeqarbrdrcs", white: "cmdmemcncoeofobpfpbqfqerfrdses" },
            correct: ["cp"],
            wrong: ["aqcp", "encp", "bscp", "ascp"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-23",
        chapterId: "beginner-level2",
        order: 445,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfqarbrcrercsfs", white: "cpdpepfpbqgqfrgrhrds" },
            correct: ["esdres"],
            wrong: ["esdrgses", "esdrdses", "cqes", "gses"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-4-24",
        chapterId: "beginner-level2",
        order: 446,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "白先。杀死黑棋的棋块。", en: "White to play. Kill the black group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blclambnaocobpdpbqcqdq", white: "bkckdlcmemcneoapepaqeqarbrcrdr" },
            correct: ["bm"],
            wrong: ["dobm", "akbm"],
        },
    },
];

const bl2LifeDeath5Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-5-1",
        chapterId: "beginner-level2",
        order: 447,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbmcndneneocpepcqcrbs", white: "anbncodoapbpbqarbr" },
            correct: ["bo"],
            wrong: ["dpbo", "ambo"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-2",
        chapterId: "beginner-level2",
        order: 448,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmandneneoepeqbrcrdr", white: "bncncodoapbpdpcqdq" },
            correct: ["ao"],
            wrong: ["bqao", "aqao", "boao"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-3",
        chapterId: "beginner-level2",
        order: 449,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmeneocpdpepcqbrcr", white: "anbncnaocodobpbqarbs" },
            correct: ["aq"],
            wrong: ["csaq", "apaq", "amaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-4",
        chapterId: "beginner-level2",
        order: 450,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpbqeqfqfres", white: "cqdqarbrdrerbs" },
            correct: ["ds"],
            wrong: ["cscr", "crcs", "aqds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-5",
        chapterId: "beginner-level2",
        order: 451,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdmfmdngngodpepfpcqcrerbs", white: "anbncnaodoeofobpcpaqbqbr" },
            correct: ["co"],
            wrong: ["asco", "arco", "boco", "amco", "enco", "fnco"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-6",
        chapterId: "beginner-level2",
        order: 452,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cofodpfpbqcqgqargrfsgs", white: "dqeqfqbrcrfrdses" },
            correct: ["bs"],
            wrong: ["drbs", "csbs", "epbs", "asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-7",
        chapterId: "beginner-level2",
        order: 453,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndoeobpcpcqeqfqgqgr", white: "dpaqbqdqcrerfrcses" },
            correct: ["drbras"],
            wrong: ["drbrepas", "brarbsdr", "brardrbs", "epdr", "bsdr", "apbr", "arbr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-8",
        chapterId: "beginner-level2",
        order: 454,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dogofpbqcqdqgqhqiqarirbshs", white: "eqfqbrcrdrgrhresfs" },
            correct: ["cs", "erfrcs", "frgscs"],
            wrong: ["gsis", "erfrepcs", "frgsiscs", "epcs", "iscs", "dscs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-9",
        chapterId: "beginner-level2",
        order: 455,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blclcmcoeobpcpdqeqarerds", white: "ambmbnboapaqbqcqcrdrbs" },
            correct: ["ao"],
            wrong: ["anao", "alao", "cnao", "brao", "asao", "csesdsao", "csesaods"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-10",
        chapterId: "beginner-level2",
        order: 456,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndnenfncogocpgpbqfqgqbrgrbsgs", white: "doeofodpfpcqdqeqdrfrfs" },
            correct: ["ds"],
            wrong: ["esercsds", "eserdscsdscr", "eserdscscrds", "eres", "csds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-11",
        chapterId: "beginner-level2",
        order: 457,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blcmdmemanbnfnfofpdqeqfqbrcr", white: "cndnboeocpdpepbqcq" },
            correct: ["apaoaq", "apaqao"],
            wrong: ["aoap", "aqap", "bpap", "coap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-12",
        chapterId: "beginner-level2",
        order: 458,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpbqeqfqgqgrgs", white: "cqdqarbrcrerfrcs" },
            correct: ["es"],
            wrong: ["dses", "aqfs", "fses", "drds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-13",
        chapterId: "beginner-level2",
        order: 459,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocoeodpfpfqdrer", white: "aobpcpaqdqeqarbrcr" },
            correct: ["cq"],
            wrong: ["cscq", "bscq", "bqan", "dscq", "ancq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-14",
        chapterId: "beginner-level2",
        order: 460,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmcndoeobpepeqarbrcrdrer", white: "anbnbocodpbqcqdq" },
            correct: ["ap"],
            wrong: ["aqap", "cpap"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-15",
        chapterId: "beginner-level2",
        order: 461,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbnbpcpdqeqeres", white: "anaoapbqcqbrdrbs" },
            correct: ["ds"],
            wrong: ["csds", "aqds", "ards", "crds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-16",
        chapterId: "beginner-level2",
        order: 462,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpaqdqeqergrbs", white: "bqcqarbrdrds" },
            correct: ["cs"],
            wrong: ["cres", "esfs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-17",
        chapterId: "beginner-level2",
        order: 463,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmdmemfmengngoepgpcqdqeqgqbrfrbs", white: "anbncndnfnboeofobpcpdpfpaqar" },
            correct: ["doapbq"],
            wrong: ["doapaobq", "bqdo", "apdo"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-18",
        chapterId: "beginner-level2",
        order: 464,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncncoapcpcqcrcs", white: "aobobpbqbr" },
            correct: ["bs"],
            wrong: ["aqbs", "arbs", "asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-19",
        chapterId: "beginner-level2",
        order: 465,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmdmanenfngngogpcqdqeqfqgqarcrcs", white: "bncndnboeofoapbpcpdpfpbqbr" },
            correct: ["bsdoep"],
            wrong: ["bsdocoep", "dobs", "epbs", "asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-20",
        chapterId: "beginner-level2",
        order: 466,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpaqdqeqergrcs", white: "bqcqarbrdrds" },
            correct: ["bs"],
            wrong: ["crbs", "esbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-21",
        chapterId: "beginner-level2",
        order: 467,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndnencofogpeqfqhqarcrdrer", white: "bodocpepaqbqcqdqbrbs" },
            correct: ["ao"],
            wrong: ["eoao", "bpao", "csao", "apao"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-22",
        chapterId: "beginner-level2",
        order: 468,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobococpepdqbrdrds", white: "apbpbqcqcrcs" },
            correct: ["ar"],
            wrong: ["bsar", "asar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-23",
        chapterId: "beginner-level2",
        order: 469,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmandnenaofodpfpcqdqeqgqdr", white: "bncnbodocpepaqbqarcr" },
            correct: ["bs"],
            wrong: ["bpbs", "apbs", "csbs", "dsbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-5-24",
        chapterId: "beginner-level2",
        order: 470,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcpaqdqeqfr", white: "bqcqbrdrds" },
            correct: ["ar"],
            wrong: ["csar", "bsar", "asar"],
        },
    },
];

const bl2LifeDeath6Levels: Level[] = [
    {
        id: "beginner-level2-bl2-life-death-6-1",
        chapterId: "beginner-level2",
        order: 471,
        title: { zh: "死活 · 1/24", en: "Life&Death · 1/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepfpbqgqhqbrhrhs", white: "cqdqeqcrfrgrcsgs" },
            correct: ["es"],
            wrong: ["eres", "fqes", "bses", "dses"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-2",
        chapterId: "beginner-level2",
        order: 472,
        title: { zh: "死活 · 2/24", en: "Life&Death · 2/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeobpfpcqdqfqhqergr", white: "epbqeqarcrdrfrdsfs" },
            correct: ["bs"],
            wrong: ["gsbs", "dpbs", "apbs", "brbs", "asbs", "csbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-3",
        chapterId: "beginner-level2",
        order: 473,
        title: { zh: "死活 · 3/24", en: "Life&Death · 3/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cobpcqdqeqfqarfr", white: "apbqbrcrdrerbs" },
            correct: ["esdsaqasaq", "aqasaq"],
            wrong: ["aoaq", "fsaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-4",
        chapterId: "beginner-level2",
        order: 474,
        title: { zh: "死活 · 4/24", en: "Life&Death · 4/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldmemfmfnbocofoapcpfpfqergrds", white: "eneobpdpbqcqeqcrdrbs" },
            correct: ["ar"],
            wrong: ["aqar", "epar", "doar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-5",
        chapterId: "beginner-level2",
        order: 475,
        title: { zh: "死活 · 5/24", en: "Life&Death · 5/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codoeocpfpgpbqgqbrgr", white: "dpepcqeqfqcrfrfs" },
            correct: ["dr"],
            wrong: ["csdr", "dsdrcses", "dsdrescs", "esds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-6",
        chapterId: "beginner-level2",
        order: 476,
        title: { zh: "死活 · 6/24", en: "Life&Death · 6/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "anbncndnaododpfpdqfqgqarcrdrgr", white: "bocoapcpaqcqbrerfrbscsds" },
            correct: ["bq"],
            wrong: ["bpbq", "esas", "fsas", "eqas"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-7",
        chapterId: "beginner-level2",
        order: 477,
        title: { zh: "死活 · 7/24", en: "Life&Death · 7/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpepfpcqgqhqbrhr", white: "dqeqfqcrgrdsgs" },
            correct: ["er"],
            wrong: ["frer", "fser", "eserbsfscsdr", "eserfsfr", "bserfscs", "bsercsfs", "bseresfscsdr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-8",
        chapterId: "beginner-level2",
        order: 478,
        title: { zh: "死活 · 8/24", en: "Life&Death · 8/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndoeofogobpcpgpaqfqgqarfrbs", white: "dpepfpbqcqeqbrdrer" },
            correct: ["cs"],
            wrong: ["escs", "dsescscr", "ascs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-9",
        chapterId: "beginner-level2",
        order: 479,
        title: { zh: "死活 · 9/24", en: "Life&Death · 9/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocododpdqdr", white: "bpcpcqcrbs" },
            correct: ["ar"],
            wrong: ["apar", "bqar", "brar", "asar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-10",
        chapterId: "beginner-level2",
        order: 480,
        title: { zh: "死活 · 10/24", en: "Life&Death · 10/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpcpdpeqeres", white: "brcrdrbsds" },
            correct: ["araqbq"],
            wrong: ["araqapbq", "aqar", "bqar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-11",
        chapterId: "beginner-level2",
        order: 481,
        title: { zh: "死活 · 11/24", en: "Life&Death · 11/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "apbpcpaqdqeqerases", white: "bqcqarbrdrds" },
            correct: ["cs"],
            wrong: ["bscs", "crcs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-12",
        chapterId: "beginner-level2",
        order: 482,
        title: { zh: "死活 · 12/24", en: "Life&Death · 12/24" },
        instruction: { zh: "黑先。吃掉白棋的棋块。", en: "Black to play. Capture the white group." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnaobpcpdqeqfqarbrfr", white: "apaqbqcqcrdrerbs" },
            correct: ["esasds"],
            wrong: ["esascsds", "esasbrds", "csds", "dses"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-13",
        chapterId: "beginner-level2",
        order: 483,
        title: { zh: "死活 · 13/24", en: "Life&Death · 13/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blcldlelamfmgmhmenhnfohodpfpcqdqeqfqarbr", white: "bmdmembncnfngncodoeobpcpepaqbq" },
            correct: ["ao"],
            wrong: ["dnao", "anao", "cmao"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-14",
        chapterId: "beginner-level2",
        order: 484,
        title: { zh: "死活 · 14/24", en: "Life&Death · 14/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpdqeqarbrer", white: "aqbqcqcrdrds" },
            correct: ["bs"],
            wrong: ["asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-15",
        chapterId: "beginner-level2",
        order: 485,
        title: { zh: "死活 · 15/24", en: "Life&Death · 15/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndnenaofogodpgpeqfqhqarcrercsds", white: "bocodobpepfpaqbqcqdqbrdr" },
            correct: ["bseseo"],
            wrong: ["eobs", "aseo"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-16",
        chapterId: "beginner-level2",
        order: 486,
        title: { zh: "死活 · 16/24", en: "Life&Death · 16/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doapbpcpdqeqarer", white: "aqbqcqcrdrbs" },
            correct: ["ds"],
            wrong: ["esds", "asds", "brds"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-17",
        chapterId: "beginner-level2",
        order: 487,
        title: { zh: "死活 · 17/24", en: "Life&Death · 17/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmbocoapcpdpdqfqarbrer", white: "bpaqbqcqcrdrbs" },
            correct: ["ds"],
            wrong: ["esds", "asds", "aods"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-18",
        chapterId: "beginner-level2",
        order: 488,
        title: { zh: "死活 · 18/24", en: "Life&Death · 18/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpepeqarcrerds", white: "aqbqcqdqdrbs" },
            correct: ["br"],
            wrong: ["csbr", "ascs", "apbr"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-19",
        chapterId: "beginner-level2",
        order: 489,
        title: { zh: "死活 · 19/24", en: "Life&Death · 19/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bobqcqdqeqfqfrfs", white: "brcrdreres" },
            correct: ["ar"],
            wrong: ["aqar", "csar", "bsar"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-20",
        chapterId: "beginner-level2",
        order: 490,
        title: { zh: "死活 · 20/24", en: "Life&Death · 20/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocododpdqardrcsds", white: "bpcpcqbrcrbs" },
            correct: ["aq"],
            wrong: ["apaq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-21",
        chapterId: "beginner-level2",
        order: 491,
        title: { zh: "死活 · 21/24", en: "Life&Death · 21/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgphpaqbqcqdqeqhqarhrbs", white: "fqgqbrcrdrergr" },
            correct: ["fs"],
            wrong: ["esgs", "csgs", "gsfsescs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-22",
        chapterId: "beginner-level2",
        order: 492,
        title: { zh: "死活 · 22/24", en: "Life&Death · 22/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "alblclcmcncocpbqcqcr", white: "ambmbnbobpaqarbr" },
            correct: ["bs"],
            wrong: ["apbs", "aobs", "csbs"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-23",
        chapterId: "beginner-level2",
        order: 493,
        title: { zh: "死活 · 23/24", en: "Life&Death · 23/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocododpcqdqdrds", white: "bpcpbrcrascs" },
            correct: ["bq"],
            wrong: ["aqbq", "apbq"],
        },
    },
    {
        id: "beginner-level2-bl2-life-death-6-24",
        chapterId: "beginner-level2",
        order: 494,
        title: { zh: "死活 · 24/24", en: "Life&Death · 24/24" },
        instruction: { zh: "白先。使白棋的棋块活棋。", en: "White to play. Make the white group alive." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "amcmbncododpaqdqdrds", white: "anbobpcpcqbrcrbs" },
            correct: ["ar"],
            wrong: ["aoar", "apar", "bqar"],
        },
    },
];

const bl2Ko1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-ko-1-1",
        chapterId: "beginner-level2",
        order: 495,
        title: { zh: "劫 · 1/6", en: "Ko · 1/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcododpeqdr", white: "cpbqdqfqcrer" },
            marks: { 1: "er" },
            correct: ["cq"],
            wrong: ["frep", "esep"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-1-2",
        chapterId: "beginner-level2",
        order: 496,
        title: { zh: "劫 · 2/6", en: "Ko · 2/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmboapcpdpeqfq", white: "bpaqcqdqbr" },
            marks: { 1: "aq" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-1-3",
        chapterId: "beginner-level2",
        order: 497,
        title: { zh: "劫 · 3/6", en: "Ko · 3/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dldnapbpcpdpaqbrcr", white: "eoepgpbqcqdqfqardrbs" },
            marks: { 1: "bs" },
            correct: ["as"],
            wrong: ["csds", "dscs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-1-4",
        chapterId: "beginner-level2",
        order: 498,
        title: { zh: "劫 · 4/6", en: "Ko · 4/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbpcpcqbrdr", white: "bqdqeqgqcrbsds" },
            marks: { 1: "bs" },
            correct: ["cs"],
            wrong: ["aqer", "asar", "arer"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-1-5",
        chapterId: "beginner-level2",
        order: 499,
        title: { zh: "劫 · 5/6", en: "Ko · 5/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmcodocpbqbrcr", white: "bpdphpcqeqfqardrbscs" },
            marks: { 1: "cq" },
            correct: ["dq"],
            wrong: ["dsaq", "apaq", "boaq", "aqap"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-1-6",
        chapterId: "beginner-level2",
        order: 500,
        title: { zh: "劫 · 6/6", en: "Ko · 6/6" },
        instruction: { zh: "黑先。作为对白棋第1手棋的回应，开始劫争。", en: "Black to play. Start a ko fight as a reply to white 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmbpdpbqcqbrdrcsds", white: "bocoeoapcpdqeqarerbses" },
            marks: { 1: "bs" },
            correct: ["as"],
            wrong: ["aqcr", "aocr"],
        },
    },
];

const bl2Ko2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-ko-2-1",
        chapterId: "beginner-level2",
        order: 501,
        title: { zh: "劫 · 1/13", en: "Ko · 1/13" },
        instruction: { zh: "黑棋通过第1手棋威胁要吃掉白棋的棋块。如果白棋在A处落子连接棋子，黑棋在B处落子，白棋的棋块就死了。但白棋也可以通过下在B来开始劫争。接着，黑棋在A处提子开始劫争，白棋必须在棋盘其他地方下劫材。白先。尝试用劫争来营救白棋的棋块。", en: "Black threatens with move 1 to capture the white group. If White plays at A to connect the stones, Black plays at B and the white group is dead. But White can also start a ko by playing at B. Next, Black starts the ko-fight by capturing at A and White must play a ko-threat somewhere else on the board. White to play. Try to rescue the white group with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncncocpcqdreqcs", white: "arbobpbqcr" },
            marks: { 1: "cs", A: "br", B: "bs" },
            correct: ["bs"],
            wrong: ["brbs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-2",
        chapterId: "beginner-level2",
        order: 502,
        title: { zh: "劫 · 2/13", en: "Ko · 2/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stone with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmdodpcqdr", white: "epdqfqcr" },
            marks: { triangle: "cr" },
            correct: ["er"],
            wrong: ["cpeq", "dser"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-3",
        chapterId: "beginner-level2",
        order: 503,
        title: { zh: "劫 · 3/13", en: "Ko · 3/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enbocoapcpepeqer", white: "bpcqdqbrdr" },
            marks: { triangle: "drbrdqcqbp" },
            correct: ["aq"],
            wrong: ["bqaq", "arcs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-4",
        chapterId: "beginner-level2",
        order: 504,
        title: { zh: "劫 · 4/13", en: "Ko · 4/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnbpcpcqbrdrer", white: "bqdqeqgqcrds" },
            marks: { triangle: "dscr" },
            correct: ["bs"],
            wrong: ["arcs", "frcs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-5",
        chapterId: "beginner-level2",
        order: 505,
        title: { zh: "劫 · 5/13", en: "Ko · 5/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnaocododpdqcrdr", white: "bocpbqcqbrbs" },
            marks: { triangle: "bsbrcqbqcpbo" },
            correct: ["ap"],
            wrong: ["bpap", "anbp"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-6",
        chapterId: "beginner-level2",
        order: 506,
        title: { zh: "劫 · 6/13", en: "Ko · 6/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blclamcmdneneoepbqcqdq", white: "bmcnbodobpcpdp" },
            marks: { triangle: "dpcpbpdobocnbm" },
            correct: ["an"],
            wrong: ["bnan", "aobn"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-7",
        chapterId: "beginner-level2",
        order: 507,
        title: { zh: "劫 · 7/13", en: "Ko · 7/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eofogoephpdqhqdrerhrgs", white: "dodpfpgpcqeqgqcrfrgr" },
            marks: { triangle: "grfrgqeqgpfp" },
            correct: ["es", "ds"],
            wrong: ["fsfq", "csfs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-8",
        chapterId: "beginner-level2",
        order: 508,
        title: { zh: "劫 · 8/13", en: "Ko · 8/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "boapcpdpepeqgq", white: "bpcqdqbr" },
            marks: { triangle: "brdqcqbp" },
            correct: ["aq"],
            wrong: ["bqdr", "ardr"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-9",
        chapterId: "beginner-level2",
        order: 509,
        title: { zh: "劫 · 9/13", en: "Ko · 9/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bncndneoeqfqarcrdrbs", white: "bocobpdpcqdqbr" },
            marks: { triangle: "brdqcqdpbpcobo" },
            correct: ["aq"],
            wrong: ["bqao", "apbq"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-10",
        chapterId: "beginner-level2",
        order: 510,
        title: { zh: "劫 · 10/13", en: "Ko · 10/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcncocpcqdrcs", white: "bnbobpbqarcr" },
            marks: { triangle: "crarbqbpbobn" },
            correct: ["bs"],
            wrong: ["brbs", "anbr"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-11",
        chapterId: "beginner-level2",
        order: 511,
        title: { zh: "劫 · 11/13", en: "Ko · 11/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bndndodpeqfqcrdrfrbs", white: "bpcpaqcqdqbrer" },
            marks: { triangle: "brdqcqaqcpbp" },
            correct: ["as", "csdsasescs", "boaoas", "boaocsdsas", "aoboas", "aobocsdsas"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-12",
        chapterId: "beginner-level2",
        order: 512,
        title: { zh: "劫 · 12/13", en: "Ko · 12/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmcocpepeqerbsdses", white: "bpbqcqdqdrcs" },
            marks: { triangle: "csdrdqcqbqbp" },
            correct: ["br"],
            wrong: ["ascr", "crboarap", "crboasar", "bocrbnbm"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-2-13",
        chapterId: "beginner-level2",
        order: 513,
        title: { zh: "劫 · 13/13", en: "Ko · 13/13" },
        instruction: { zh: "白先。尝试用劫争营救标记的棋子。", en: "White to play. Try to rescue the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hpaqbqcqdqeqfqhqfrhrgshs", white: "bpcpdpepfpgpgqbrcrdrergrds" },
            marks: { triangle: "dserdrcrbr" },
            correct: ["fsarap", "fsarasbsap", "arbsfs"],
            wrong: ["fsaresbs"],
        },
    },
];

const bl2Ko3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-ko-3-1",
        chapterId: "beginner-level2",
        order: 514,
        title: { zh: "劫 · 1/12", en: "Ko · 1/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stone with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmbnbpcpaqcqbr", white: "anbocodoeq" },
            marks: { triangle: "an" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-2",
        chapterId: "beginner-level2",
        order: 515,
        title: { zh: "劫 · 2/12", en: "Ko · 2/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stone with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bococpepbqgqbr", white: "anbncndnaoaq" },
            marks: { triangle: "aq" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-3",
        chapterId: "beginner-level2",
        order: 516,
        title: { zh: "劫 · 3/12", en: "Ko · 3/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "codpaqbqcqdreres", white: "dqeqfqarbrcrfrbs" },
            marks: { triangle: "arbrcrbs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-4",
        chapterId: "beginner-level2",
        order: 517,
        title: { zh: "劫 · 4/12", en: "Ko · 4/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpepgpeqardrerbscs", white: "cmcodoeocpbqbrcr" },
            marks: { triangle: "bqbrcr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-5",
        chapterId: "beginner-level2",
        order: 518,
        title: { zh: "劫 · 5/12", en: "Ko · 5/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpepfqgqbrdrergras", white: "cncpcqcrfrdsesfs" },
            marks: { triangle: "frdsesfs" },
            correct: ["cs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-6",
        chapterId: "beginner-level2",
        order: 519,
        title: { zh: "劫 · 6/12", en: "Ko · 6/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epbqcqdqfqgqardr", white: "dmdnapbpcpdpaqbrcr" },
            marks: { triangle: "brcr" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-7",
        chapterId: "beginner-level2",
        order: 520,
        title: { zh: "劫 · 7/12", en: "Ko · 7/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bocododpdqcrer", white: "bpcpcqbrcs" },
            marks: { triangle: "bpcpcqbrcs" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-8",
        chapterId: "beginner-level2",
        order: 521,
        title: { zh: "劫 · 8/12", en: "Ko · 8/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stone with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncnaocobpepeqbrcrdr", white: "fldmdnfndogodpbqcqdqar" },
            marks: { triangle: "ar" },
            correct: ["aq"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-9",
        chapterId: "beginner-level2",
        order: 522,
        title: { zh: "劫 · 9/12", en: "Ko · 9/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpdpcqdrcs", white: "dncocpbqarbs" },
            marks: { triangle: "bqarbs" },
            correct: ["br"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-10",
        chapterId: "beginner-level2",
        order: 523,
        title: { zh: "劫 · 10/12", en: "Ko · 10/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndobpcpcqarcr", white: "dpbqdqfqgqbrdrcs" },
            marks: { triangle: "bqbr" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-11",
        chapterId: "beginner-level2",
        order: 524,
        title: { zh: "劫 · 11/12", en: "Ko · 11/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpepeqcrerbs", white: "fpdqfqdrfresfs" },
            marks: { triangle: "dqdr" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level2-bl2-ko-3-12",
        chapterId: "beginner-level2",
        order: 525,
        title: { zh: "劫 · 12/12", en: "Ko · 12/12" },
        instruction: { zh: "黑先。尝试用劫争吃掉标记的棋子。", en: "Black to play. Try to capture the marked stones with a ko." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blbmbndnbobqcqdqarbs", white: "amanaobpcpdpepgpeq" },
            marks: { triangle: "amanao" },
            correct: ["ap"],
        },
    },
];

const bl2Haengma1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-haengma-1-1",
        chapterId: "beginner-level2",
        order: 526,
        title: { zh: "行棋步法 · 1/17", en: "Haengma · 1/17" },
        instruction: { zh: "'Haengma'（行马）是来自韩国的一个重要围棋术语。行马指棋子之间的关系，即一组棋子的发展方式。韩语'haengma'意为'马行走的方式'。一个有用的行马着法是在贴靠（'tsuke'）之后扳（'hane'），在本例中是在白棋第1手之后于A处落子。这是一种强有力的反击。黑先。选择对贴靠第1手的最佳回应。", en: "Haengma is an important go-term from Korea. Haengma indicates the relationship between the stones, the way a group of stones is developing. The Korean word haengma means 'the way, in which the horse moves'. A useful haengma move is to bend ('hane') after an attachment ('tsuke'), in this example by playing at A after White's move 1. This is a strong counter-attack. Black to play. Choose the best reply to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdn", white: "cqeq" },
            marks: { 1: "cq", A: "bq" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-2",
        chapterId: "beginner-level2",
        order: 527,
        title: { zh: "行棋步法 · 2/17", en: "Haengma · 2/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cp", white: "dp" },
            marks: { 1: "cp", A: "bp", B: "cq", C: "dq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-3",
        chapterId: "beginner-level2",
        order: 528,
        title: { zh: "行棋步法 · 3/17", en: "Haengma · 3/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "do", white: "dpdq" },
            marks: { 1: "do", A: "dn", B: "co", C: "cp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-4",
        chapterId: "beginner-level2",
        order: 529,
        title: { zh: "行棋步法 · 4/17", en: "Haengma · 4/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ep", white: "dpdq" },
            marks: { 1: "ep", A: "eo", B: "fp", C: "eq" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-5",
        chapterId: "beginner-level2",
        order: 530,
        title: { zh: "行棋步法 · 5/17", en: "Haengma · 5/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dq", white: "cndp" },
            marks: { 1: "dq", A: "cp", B: "ep", C: "cq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-6",
        chapterId: "beginner-level2",
        order: 531,
        title: { zh: "行棋步法 · 6/17", en: "Haengma · 6/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "co", white: "cpdq" },
            marks: { 1: "co", A: "do", B: "bp", C: "dp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-7",
        chapterId: "beginner-level2",
        order: 532,
        title: { zh: "行棋步法 · 7/17", en: "Haengma · 7/17" },
        instruction: { zh: "白先。选择对贴靠第1手A、B或C的最佳回应。", en: "White to play. Choose the best reply to attachment 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cp", white: "dpdr" },
            marks: { 1: "cp", A: "cq", B: "dq", C: "cr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-8",
        chapterId: "beginner-level2",
        order: 533,
        title: { zh: "行棋步法 · 8/17", en: "Haengma · 8/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpfp", white: "dncp" },
            marks: { 1: "cp" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-9",
        chapterId: "beginner-level2",
        order: 534,
        title: { zh: "行棋步法 · 9/17", en: "Haengma · 9/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ep", white: "eocp" },
            marks: { 1: "eo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-10",
        chapterId: "beginner-level2",
        order: 535,
        title: { zh: "行棋步法 · 10/17", en: "Haengma · 10/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fq", white: "dpfp" },
            marks: { 1: "fp" },
            correct: ["gp"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-11",
        chapterId: "beginner-level2",
        order: 536,
        title: { zh: "行棋步法 · 11/17", en: "Haengma · 11/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncp", white: "epcq" },
            marks: { 1: "cq" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-12",
        chapterId: "beginner-level2",
        order: 537,
        title: { zh: "行棋步法 · 12/17", en: "Haengma · 12/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dq", white: "docq" },
            marks: { 1: "cq" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-13",
        chapterId: "beginner-level2",
        order: 538,
        title: { zh: "行棋步法 · 13/17", en: "Haengma · 13/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dphq", white: "hpfq" },
            marks: { 1: "hp" },
            correct: ["ip"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-14",
        chapterId: "beginner-level2",
        order: 539,
        title: { zh: "行棋步法 · 14/17", en: "Haengma · 14/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ep", white: "cpeq" },
            marks: { 1: "eq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-15",
        chapterId: "beginner-level2",
        order: 540,
        title: { zh: "行棋步法 · 15/17", en: "Haengma · 15/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndpiq", white: "dqfq" },
            marks: { 1: "dq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-16",
        chapterId: "beginner-level2",
        order: 541,
        title: { zh: "行棋步法 · 16/17", en: "Haengma · 16/17" },
        instruction: { zh: "黑先。对贴靠第1手下出好的回应（扳）。", en: "Black to play. Play a good reply (bend) to attachment 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdq", white: "cndndoeq" },
            marks: { 1: "eq" },
            correct: ["er"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-1-17",
        chapterId: "beginner-level2",
        order: 542,
        title: { zh: "行棋步法 · 17/17", en: "Haengma · 17/17" },
        instruction: { zh: "除了贴靠攻击，你也可能遭到肩侵攻击。肩侵是下在你被攻击棋子斜方向的一手棋。通常，最好的防守是从被攻击的棋子处延伸。在本例中，黑棋用第1手棋进行肩侵。白棋应该通过将棋子延伸到A处来防守。结果是黑棋的第1手棋紧挨着白棋两颗棋子组成的强大阵型。白先。对黑棋第1手下出好的防守。", en: "Instead of an attaching move, you can also be attacked with a shoulder-hit. A shoulder-hit is a move diagonally next to your attacked stone. Often, the best defense is to stretch from your attacked stone. In this example Black plays a shoulder-hit with stone 1. White should defend by stretching his stone at A. The result is that Black's stone 1 leans against a strong formation of two white stones. White to play. Play a good defense against Black 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "doeq", white: "cp" },
            marks: { 1: "do", A: "co" },
            correct: ["co"],
        },
    },
];

const bl2Haengma2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-haengma-2-1",
        chapterId: "beginner-level2",
        order: 543,
        title: { zh: "行棋步法 · 1/10", en: "Haengma · 1/10" },
        instruction: { zh: "在弯曲后，通常最佳着法是延伸（nobi）。不要向边缘延伸（A点），而要向己方棋子延伸（B点）。白先。对黑1的弯曲，下出好的应手（延伸）。", en: "After a bending move, it is often best to stretch (nobi) . Do not stretch towards the edge (at point A), but towards your own stone (at point B). White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndpcq", white: "dqfp" },
            marks: { 1: "cq", A: "dr", B: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-2",
        chapterId: "beginner-level2",
        order: 544,
        title: { zh: "行棋步法 · 2/10", en: "Haengma · 2/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gpfq", white: "dpfp" },
            marks: { 1: "gp" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-3",
        chapterId: "beginner-level2",
        order: 545,
        title: { zh: "行棋步法 · 3/10", en: "Haengma · 3/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqcr", white: "docq" },
            marks: { 1: "cr" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-4",
        chapterId: "beginner-level2",
        order: 546,
        title: { zh: "行棋步法 · 4/10", en: "Haengma · 4/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "foep", white: "eocp" },
            marks: { 1: "fo" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-5",
        chapterId: "beginner-level2",
        order: 547,
        title: { zh: "行棋步法 · 5/10", en: "Haengma · 5/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epfq", white: "cpeq" },
            marks: { 1: "fq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-6",
        chapterId: "beginner-level2",
        order: 548,
        title: { zh: "行棋步法 · 6/10", en: "Haengma · 6/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dncpbq", white: "epcq" },
            marks: { 1: "bq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-7",
        chapterId: "beginner-level2",
        order: 549,
        title: { zh: "行棋步法 · 7/10", en: "Haengma · 7/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqer", white: "doeq" },
            marks: { 1: "er" },
            correct: ["ep"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-8",
        chapterId: "beginner-level2",
        order: 550,
        title: { zh: "行棋步法 · 8/10", en: "Haengma · 8/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcq", white: "dq" },
            marks: { 1: "cq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-9",
        chapterId: "beginner-level2",
        order: 551,
        title: { zh: "行棋步法 · 9/10", en: "Haengma · 9/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "endocp", white: "eoeq" },
            marks: { 1: "en" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-2-10",
        chapterId: "beginner-level2",
        order: 552,
        title: { zh: "行棋步法 · 10/10", en: "Haengma · 10/10" },
        instruction: { zh: "白先。对黑1的弯曲，下出好的应手（延伸）。", en: "White to play. Play a good reply (stretch) to bend 1." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndpcq", white: "fpdq" },
            marks: { 1: "cq" },
            correct: ["eq"],
        },
    },
];

const bl2Haengma3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-haengma-3-1",
        chapterId: "beginner-level2",
        order: 553,
        title: { zh: "行棋步法 · 1/10", en: "Haengma · 1/10" },
        instruction: { zh: "有句著名的格言：“下在两子之头”。在此例中，黑1是两颗黑棋的头。白棋的最佳应手是弯曲并打在黑棋头上。白先。下在棋子的头部。", en: "A well-known proverb is: 'Play at the head of two stones.' In this example black 1 is the head of two black stones. The best answer for White is to bend and hit black on his head. White to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdq", white: "cpdp" },
            marks: { 1: "dq", A: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-2",
        chapterId: "beginner-level2",
        order: 554,
        title: { zh: "行棋步法 · 2/10", en: "Haengma · 2/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdq", white: "epeq" },
            correct: ["eo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-3",
        chapterId: "beginner-level2",
        order: 555,
        title: { zh: "行棋步法 · 3/10", en: "Haengma · 3/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdp", white: "cqdq" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-4",
        chapterId: "beginner-level2",
        order: 556,
        title: { zh: "行棋步法 · 4/10", en: "Haengma · 4/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdqcr", white: "cpcq" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-5",
        chapterId: "beginner-level2",
        order: 557,
        title: { zh: "行棋步法 · 5/10", en: "Haengma · 5/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodpcqdq", white: "cocpbq" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-6",
        chapterId: "beginner-level2",
        order: 558,
        title: { zh: "行棋步法 · 6/10", en: "Haengma · 6/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpep", white: "cqdqeq" },
            correct: ["fq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-7",
        chapterId: "beginner-level2",
        order: 559,
        title: { zh: "行棋步法 · 7/10", en: "Haengma · 7/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cndodp", white: "dncocp" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-8",
        chapterId: "beginner-level2",
        order: 560,
        title: { zh: "行棋步法 · 8/10", en: "Haengma · 8/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdq", white: "dodpeq" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-9",
        chapterId: "beginner-level2",
        order: 561,
        title: { zh: "行棋步法 · 9/10", en: "Haengma · 9/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dneofocpdp", white: "epfpcqdq" },
            correct: ["gp"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-3-10",
        chapterId: "beginner-level2",
        order: 562,
        title: { zh: "行棋步法 · 10/10", en: "Haengma · 10/10" },
        instruction: { zh: "黑先。下在棋子的头部。", en: "Black to play. Play at the head of the stones." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bncodobp", white: "cpdpbqcr" },
            correct: ["ep"],
        },
    },
];

const bl2Haengma4Levels: Level[] = [
    {
        id: "beginner-level2-bl2-haengma-4-1",
        chapterId: "beginner-level2",
        order: 563,
        title: { zh: "行棋步法 · 1/9", en: "Haengma · 1/9" },
        instruction: { zh: "另一句著名格言是：“十字切断后延伸”。通常，对十字切断的断子打吃并不好。最佳着法往往是从被切断的两子之一延伸。在此例中，黑1下出十字切断。白棋应在A点延伸。白先。在这个十字切断后延伸。", en: "Another well-known proverb is: 'Stretch after a cross-cut'. Usually it is not good to give atari to a cutting stone of a cross-cut. Often it is best to stretch from one of the two cut-off stones. In this example Black plays a cross-cut with move 1. White should stretch at A. White to play. Stretch after this cross-cut." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpfpdqeq", white: "epfq" },
            marks: { 1: "fp", A: "gq" },
            correct: ["gq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-2",
        chapterId: "beginner-level2",
        order: 564,
        title: { zh: "行棋步法 · 2/9", en: "Haengma · 2/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdq", white: "dpcq" },
            marks: { A: "co", B: "bq", C: "dr" },
            correct: ["bq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-3",
        chapterId: "beginner-level2",
        order: 565,
        title: { zh: "行棋步法 · 3/9", en: "Haengma · 3/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgq", white: "gpfq" },
            marks: { A: "fo", B: "eq", C: "gr" },
            correct: ["eq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-4",
        chapterId: "beginner-level2",
        order: 566,
        title: { zh: "行棋步法 · 4/9", en: "Haengma · 4/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cpdq", white: "cmdpcq" },
            marks: { A: "co", B: "do", C: "eq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-5",
        chapterId: "beginner-level2",
        order: 567,
        title: { zh: "行棋步法 · 5/9", en: "Haengma · 5/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpfpcq", white: "cpdq" },
            marks: { A: "do", B: "ep", C: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-6",
        chapterId: "beginner-level2",
        order: 568,
        title: { zh: "行棋步法 · 6/9", en: "Haengma · 6/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cqdqgqerfr", white: "cpdpbqeqfqbrgr" },
            marks: { A: "gp", B: "hq", C: "hr" },
            correct: ["hr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-7",
        chapterId: "beginner-level2",
        order: 569,
        title: { zh: "行棋步法 · 7/9", en: "Haengma · 7/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncpdq", white: "dpcq" },
            marks: { A: "co", B: "eq", C: "cr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-8",
        chapterId: "beginner-level2",
        order: 570,
        title: { zh: "行棋步法 · 8/9", en: "Haengma · 8/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fogoephp", white: "eohofpgp" },
            marks: { A: "fn", B: "do", C: "eq" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-4-9",
        chapterId: "beginner-level2",
        order: 571,
        title: { zh: "行棋步法 · 9/9", en: "Haengma · 9/9" },
        instruction: { zh: "白先。在这个十字切断后，选择最佳后续（延伸）：A、B或C？", en: "White to play. Choose the best continuation (stretch) after this cross-cut, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eocpdpgp", white: "doepeq" },
            marks: { A: "dn", B: "en", C: "fo" },
            correct: ["dn"],
        },
    },
];

const bl2Haengma5Levels: Level[] = [
    {
        id: "beginner-level2-bl2-haengma-5-1",
        chapterId: "beginner-level2",
        order: 572,
        title: { zh: "行棋步法 · 1/24", en: "Haengma · 1/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "do", white: "dpdq" },
            marks: { 1: "do", A: "dn", B: "co", C: "cp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-2",
        chapterId: "beginner-level2",
        order: 573,
        title: { zh: "行棋步法 · 2/24", en: "Haengma · 2/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dp", white: "cpeq" },
            marks: { 1: "dp", A: "do", B: "cq", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-3",
        chapterId: "beginner-level2",
        order: 574,
        title: { zh: "行棋步法 · 3/24", en: "Haengma · 3/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "co", white: "cpdq" },
            marks: { 1: "co", A: "do", B: "bp", C: "dp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-4",
        chapterId: "beginner-level2",
        order: 575,
        title: { zh: "行棋步法 · 4/24", en: "Haengma · 4/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dldq", white: "do" },
            marks: { 1: "dl", A: "co", B: "eo", C: "fo" },
            correct: ["fo"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-5",
        chapterId: "beginner-level2",
        order: 576,
        title: { zh: "行棋步法 · 5/24", en: "Haengma · 5/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codq", white: "do" },
            marks: { 1: "co", B: "dm", A: "cn", C: "eo" },
            correct: ["cn"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-6",
        chapterId: "beginner-level2",
        order: 577,
        title: { zh: "行棋步法 · 6/24", en: "Haengma · 6/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cofq", white: "dndp" },
            marks: { 1: "co", A: "dl", B: "cn", C: "do" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-7",
        chapterId: "beginner-level2",
        order: 578,
        title: { zh: "行棋步法 · 7/24", en: "Haengma · 7/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "docq", white: "dq" },
            marks: { 1: "cq", A: "ep", B: "cr", C: "dr" },
            correct: ["cr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-8",
        chapterId: "beginner-level2",
        order: 579,
        title: { zh: "行棋步法 · 8/24", en: "Haengma · 8/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cofq", white: "cndp" },
            marks: { 1: "co", A: "cm", B: "bo", C: "do" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-9",
        chapterId: "beginner-level2",
        order: 580,
        title: { zh: "行棋步法 · 9/24", en: "Haengma · 9/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndp", white: "cn" },
            marks: { 1: "dn", A: "dm", B: "co", C: "do" },
            correct: ["dm"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-10",
        chapterId: "beginner-level2",
        order: 581,
        title: { zh: "行棋步法 · 10/24", en: "Haengma · 10/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncp", white: "dpfp" },
            marks: { 1: "cp", A: "co", B: "do", C: "cq" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-11",
        chapterId: "beginner-level2",
        order: 582,
        title: { zh: "行棋步法 · 11/24", en: "Haengma · 11/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dofq", white: "cndp" },
            marks: { 1: "do", A: "co", B: "eo", C: "cp" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-12",
        chapterId: "beginner-level2",
        order: 583,
        title: { zh: "行棋步法 · 12/24", en: "Haengma · 12/24" },
        instruction: { zh: "白先。针对黑1，选择最佳防守：A、B或C？", en: "White to play. Choose the best defense against Black's move 1, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodqfq", white: "cncodp" },
            marks: { 1: "dq", A: "cq", B: "eq", C: "dr" },
            correct: ["cq"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-13",
        chapterId: "beginner-level2",
        order: 584,
        title: { zh: "行棋步法 · 13/24", en: "Haengma · 13/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dodq", white: "cpep" },
            marks: { A: "co", B: "dp", C: "cq", triangle: "ep" },
            correct: ["dp"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-14",
        chapterId: "beginner-level2",
        order: 585,
        title: { zh: "行棋步法 · 14/24", en: "Haengma · 14/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncpdqeq", white: "doepfpfq" },
            marks: { A: "dn", B: "co", C: "dp", triangle: "do" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-15",
        chapterId: "beginner-level2",
        order: 586,
        title: { zh: "行棋步法 · 15/24", en: "Haengma · 15/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpcq", white: "dqeq" },
            marks: { A: "cp", B: "fq", C: "dr", triangle: "eq" },
            correct: ["cp"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-16",
        chapterId: "beginner-level2",
        order: 587,
        title: { zh: "行棋步法 · 16/24", en: "Haengma · 16/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcnco", white: "cldnencpdp" },
            marks: { A: "dl", B: "cm", C: "em", triangle: "cl" },
            correct: ["cm"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-17",
        chapterId: "beginner-level2",
        order: 588,
        title: { zh: "行棋步法 · 17/24", en: "Haengma · 17/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dncoeodp", white: "cpepdq" },
            marks: { A: "do", B: "bp", C: "cq", triangle: "ep" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-18",
        chapterId: "beginner-level2",
        order: 589,
        title: { zh: "行棋步法 · 18/24", en: "Haengma · 18/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdndo", white: "dmcnco" },
            marks: { A: "cl", B: "dl", C: "em", triangle: "dm" },
            correct: ["cl"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-19",
        chapterId: "beginner-level2",
        order: 590,
        title: { zh: "行棋步法 · 19/24", en: "Haengma · 19/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcndo", white: "encocpdq" },
            marks: { A: "dl", B: "fm", C: "dn", triangle: "en" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-20",
        chapterId: "beginner-level2",
        order: 591,
        title: { zh: "行棋步法 · 20/24", en: "Haengma · 20/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cocpdq", white: "dodpeq" },
            marks: { A: "cq", B: "dr", C: "er", triangle: "eq" },
            correct: ["dr"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-21",
        chapterId: "beginner-level2",
        order: 592,
        title: { zh: "行棋步法 · 21/24", en: "Haengma · 21/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dldpdq", white: "cncpcq" },
            marks: { A: "co", B: "do", C: "cr", triangle: "cp" },
            correct: ["do"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-22",
        chapterId: "beginner-level2",
        order: 593,
        title: { zh: "行棋步法 · 22/24", en: "Haengma · 22/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcnbododpfpeq", white: "encobpcpaqdqbrcrdr" },
            marks: { A: "bm", B: "cm", C: "dn", triangle: "en" },
            correct: ["dn"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-23",
        chapterId: "beginner-level2",
        order: 594,
        title: { zh: "行棋步法 · 23/24", en: "Haengma · 23/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmcn", white: "dnendp" },
            marks: { A: "cm", B: "em", C: "co", triangle: "en" },
            correct: ["co"],
        },
    },
    {
        id: "beginner-level2-bl2-haengma-5-24",
        chapterId: "beginner-level2",
        order: 595,
        title: { zh: "行棋步法 · 24/24", en: "Haengma · 24/24" },
        instruction: { zh: "黑先。针对白棋标记的着法，选择最佳防守：A、B或C？", en: "Black to play. Choose the best defense against white's marked play, A, B or C?" },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpdqcr", white: "cpcq" },
            marks: { A: "co", B: "bq", C: "dr", triangle: "cp" },
            correct: ["co"],
        },
    },
];

const bl2Shape1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-shape-1-1",
        chapterId: "beginner-level2",
        order: 596,
        title: { zh: "棋形 · 1/17", en: "Shape · 1/17" },
        instruction: { zh: "棋形是围棋中的一个重要概念。棋形指的是棋盘上一组棋子的形态。这种形态决定了这些棋子在对局中能被有效利用的程度。棋形有好形和愚形之分。这个棋形是一个空三角，是愚形。这三颗棋子没有包围任何东西。其中一颗是多余的。黑棋的棋块是好形还是愚形？", en: "Shape is an important concept in Go. With shape we mean a formation of a group of stones on the board. This formation decides how well these stones can be used effectively in the game. There is good shape and bad shape. This shape is an empty triangle and is a bad shape. The three stones do not surround anything. One of the three stones is superfluous. Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dndoeo", white: "" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋形是围棋中的一个重要概念。棋形指的是棋盘上一组棋子的形态。这种形态决定了这些棋子在对局中能被有效利用的程度。棋形有好形和愚形之分。这个棋形是一个空三角，是愚形。这三颗棋子没有包围任何东西。其中一颗是多余的。黑棋的棋块是好形还是愚形？", en: "Shape is an important concept in Go. With shape we mean a formation of a group of stones on the board. This formation decides how well these stones can be used effectively in the game. There is good shape and bad shape. This shape is an empty triangle and is a bad shape. The three stones do not surround anything. One of the three stones is superfluous. Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dndoeo", white: "" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-2",
        chapterId: "beginner-level2",
        order: 597,
        title: { zh: "棋形 · 2/17", en: "Shape · 2/17" },
        instruction: { zh: "这个棋形是团形，是愚形。过多的棋子紧密地挤在一起。你可以移除其中的一些，而棋块仍然保持同样的强度或作用。你在棋盘上有多余的棋子，因此你下了一些多余的棋。黑棋的棋块是好形还是愚形？", en: "This shape is a lump and is a bad shape. Far too many stones lay close to each other. You can take away a number of them, while the group stays as strong or useful. You have a number of superfluous stones on the board, so you have played a number of superfluous moves. Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dodpeoepeqfp", white: "" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这个棋形是团形，是愚形。过多的棋子紧密地挤在一起。你可以移除其中的一些，而棋块仍然保持同样的强度或作用。你在棋盘上有多余的棋子，因此你下了一些多余的棋。黑棋的棋块是好形还是愚形？", en: "This shape is a lump and is a bad shape. Far too many stones lay close to each other. You can take away a number of them, while the group stays as strong or useful. You have a number of superfluous stones on the board, so you have played a number of superfluous moves. Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dodpeoepeqfp", white: "" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-3",
        chapterId: "beginner-level2",
        order: 598,
        title: { zh: "棋形 · 3/17", en: "Shape · 3/17" },
        instruction: { zh: "这个棋形是虎口，是好形。虎口是由三颗棋子形成的形状，它包围并保护棋盘上的一个点。虎口是用于覆盖切断点或准备做眼的好形。黑棋的棋块是好形还是愚形？", en: "This shape is a tiger-mouth and is a good shape. The tiger-mouth is a shape of three stones, which surround and protect a point on the board. The tiger-mouth is a good shape to cover a cutting point or to prepare an eye. Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eofpgo", white: "" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这个棋形是虎口，是好形。虎口是由三颗棋子形成的形状，它包围并保护棋盘上的一个点。虎口是用于覆盖切断点或准备做眼的好形。黑棋的棋块是好形还是愚形？", en: "This shape is a tiger-mouth and is a good shape. The tiger-mouth is a shape of three stones, which surround and protect a point on the board. The tiger-mouth is a good shape to cover a cutting point or to prepare an eye. Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofpgo", white: "" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-4",
        chapterId: "beginner-level2",
        order: 599,
        title: { zh: "棋形 · 4/17", en: "Shape · 4/17" },
        instruction: { zh: "这个棋形是拔花，是好形。拔花是由四颗棋子形成的形状，在提掉一颗棋子后出现。拔花具有做眼的潜力，难以被吃，并且在进攻中很强大。有句谚语是：'拔花三十目'。黑棋的棋块是好形还是愚形？", en: "This shape is a ponnuki and is a good shape. The ponnuki is a shape of four stones, which emerges after a single stone is captured. The ponnuki gives possibilities for an eye, is difficult to capture and is strong in an attack. The proverb is: 'A ponnuki is worth 30 points'. Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eofnfpgo", white: "" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这个棋形是拔花，是好形。拔花是由四颗棋子形成的形状，在提掉一颗棋子后出现。拔花具有做眼的潜力，难以被吃，并且在进攻中很强大。有句谚语是：'拔花三十目'。黑棋的棋块是好形还是愚形？", en: "This shape is a ponnuki and is a good shape. The ponnuki is a shape of four stones, which emerges after a single stone is captured. The ponnuki gives possibilities for an eye, is difficult to capture and is strong in an attack. The proverb is: 'A ponnuki is worth 30 points'. Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofnfpgo", white: "" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-5",
        chapterId: "beginner-level2",
        order: 600,
        title: { zh: "棋形 · 5/17", en: "Shape · 5/17" },
        instruction: { zh: "这个棋形是乌龟形，是好形。乌龟形与拔花类似，但它是更好的形状。这种形状在提掉两颗棋子后出现。有句谚语是：'乌龟六十目'。黑棋的棋块是好形还是愚形？", en: "This shape is a turtle and is a good shape. The turtle is comparable to a ponnuki, but it is an even better shape. This shape emerges when two stones are captured. The proverb is: 'A turtle is worth 60 points'. Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "doenepfnfpgo", white: "" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "这个棋形是乌龟形，是好形。乌龟形与拔花类似，但它是更好的形状。这种形状在提掉两颗棋子后出现。有句谚语是：'乌龟六十目'。黑棋的棋块是好形还是愚形？", en: "This shape is a turtle and is a good shape. The turtle is comparable to a ponnuki, but it is an even better shape. This shape emerges when two stones are captured. The proverb is: 'A turtle is worth 60 points'. Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doenepfnfpgo", white: "" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-6",
        chapterId: "beginner-level2",
        order: 601,
        title: { zh: "棋形 · 6/17", en: "Shape · 6/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpdq", white: "codoeo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpdq", white: "codoeo" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-7",
        chapterId: "beginner-level2",
        order: 602,
        title: { zh: "棋形 · 7/17", en: "Shape · 7/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpep", white: "codoeo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpep", white: "codoeo" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-8",
        chapterId: "beginner-level2",
        order: 603,
        title: { zh: "棋形 · 8/17", en: "Shape · 8/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dpcqdqeq", white: "codoeo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dpcqdqeq", white: "codoeo" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-9",
        chapterId: "beginner-level2",
        order: 604,
        title: { zh: "棋形 · 9/17", en: "Shape · 9/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpepcqdqeq", white: "dncodoeodp" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpepcqdqeq", white: "dncodoeodp" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-10",
        chapterId: "beginner-level2",
        order: 605,
        title: { zh: "棋形 · 10/17", en: "Shape · 10/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "endoeofodpep", white: "dncocpfpcqdqeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "endoeofodpep", white: "dncocpfpcqdqeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-11",
        chapterId: "beginner-level2",
        order: 606,
        title: { zh: "棋形 · 11/17", en: "Shape · 11/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "docpdpcqdq", white: "cndncoeo" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "docpdpcqdq", white: "cndncoeo" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-12",
        chapterId: "beginner-level2",
        order: 607,
        title: { zh: "棋形 · 12/17", en: "Shape · 12/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "encoeodpdq", white: "foepfpeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "encoeodpdq", white: "foepfpeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-13",
        chapterId: "beginner-level2",
        order: 608,
        title: { zh: "棋形 · 13/17", en: "Shape · 13/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmdncocp", white: "dofodpdq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmdncocp", white: "dofodpdq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-14",
        chapterId: "beginner-level2",
        order: 609,
        title: { zh: "棋形 · 14/17", en: "Shape · 14/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cncodocp", white: "bpdpepfpcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cncodocp", white: "bpdpepfpcq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-15",
        chapterId: "beginner-level2",
        order: 610,
        title: { zh: "棋形 · 15/17", en: "Shape · 15/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bncpcqdq", white: "dodpepeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bncpcqdq", white: "dodpepeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-16",
        chapterId: "beginner-level2",
        order: 611,
        title: { zh: "棋形 · 16/17", en: "Shape · 16/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "doeodpdq", white: "dncocpcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "bad shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "doeodpdq", white: "dncocpcq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-1-17",
        chapterId: "beginner-level2",
        order: 612,
        title: { zh: "棋形 · 17/17", en: "Shape · 17/17" },
        instruction: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dqfqcrer", white: "dncpdpcq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的棋块是好形还是愚形？", en: "Does the black group have good or bad shape?" },
            options: [{ value: "good shape", label: { zh: "好形", en: "good shape" } }, { value: "bad shape", label: { zh: "愚形", en: "bad shape" } }],
            correctValue: "good shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dqfqcrer", white: "dncpdpcq" },
            },
        },
    },
];

const bl2Shape2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-shape-2-1",
        chapterId: "beginner-level2",
        order: 613,
        title: { zh: "棋形 · 1/14", en: "Shape · 1/14" },
        instruction: { zh: "如果一个棋块没有弱点并且能够在战斗中有效使用，就被称为强形。在这个例子中，白棋有一道强墙。相比之下，黑棋看起来相当弱。白棋的棋块是强形还是弱形？", en: "A group of stones is called strong if the group has no weak points and can be used effectively in a fight. In this example White has a strong wall. In comparison Black looks quite weak. Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dodp", white: "eneoepeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "如果一个棋块没有弱点并且能够在战斗中有效使用，就被称为强形。在这个例子中，白棋有一道强墙。相比之下，黑棋看起来相当弱。白棋的棋块是强形还是弱形？", en: "A group of stones is called strong if the group has no weak points and can be used effectively in a fight. In this example White has a strong wall. In comparison Black looks quite weak. Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dodp", white: "eneoepeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-2",
        chapterId: "beginner-level2",
        order: 614,
        title: { zh: "棋形 · 2/14", en: "Shape · 2/14" },
        instruction: { zh: "如果一个棋块容易被攻击，并且可能被吃掉或切断，那么它就是弱形。弱形棋块没有好的眼形。在这个例子中，白墙有两个切断点。白棋的棋块是强形还是弱形？", en: "A group is weak if it can easily be attacked and can be captured or cut off. A weak group does not have good eye-shape. In this example the white wall has two cutting points. Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmcncocpcqcrdp", white: "dndodqdrep" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "如果一个棋块容易被攻击，并且可能被吃掉或切断，那么它就是弱形。弱形棋块没有好的眼形。在这个例子中，白墙有两个切断点。白棋的棋块是强形还是弱形？", en: "A group is weak if it can easily be attacked and can be captured or cut off. A weak group does not have good eye-shape. In this example the white wall has two cutting points. Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmcncocpcqcrdp", white: "dndodqdrep" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-3",
        chapterId: "beginner-level2",
        order: 615,
        title: { zh: "棋形 · 3/14", en: "Shape · 3/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eofpcqdq", white: "cpdpepeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eofpcqdq", white: "cpdpepeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-4",
        chapterId: "beginner-level2",
        order: 616,
        title: { zh: "棋形 · 4/14", en: "Shape · 4/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eogocq", white: "codpeqgq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eogocq", white: "codpeqgq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-5",
        chapterId: "beginner-level2",
        order: 617,
        title: { zh: "棋形 · 5/14", en: "Shape · 5/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cncobpdpepbqbr", white: "doeofocpcqdqfq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cncobpdpepbqbr", white: "doeofocpcqdqfq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-6",
        chapterId: "beginner-level2",
        order: 618,
        title: { zh: "棋形 · 6/14", en: "Shape · 6/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dmcncocpdpcq", white: "cmdndoepdq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dmcncocpdpcq", white: "cmdndoepdq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-7",
        chapterId: "beginner-level2",
        order: 619,
        title: { zh: "棋形 · 7/14", en: "Shape · 7/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "codpepfq", white: "cpfpcqdqeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codpepfq", white: "cpfpcqdqeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-8",
        chapterId: "beginner-level2",
        order: 620,
        title: { zh: "棋形 · 8/14", en: "Shape · 8/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "codoeocqdqeq", white: "fobpcpfpbqfq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "codoeocqdqeq", white: "fobpcpfpbqfq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-9",
        chapterId: "beginner-level2",
        order: 621,
        title: { zh: "棋形 · 9/14", en: "Shape · 9/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cmdnbocodpepfpgpcqcr", white: "endoeofobpcpdqeqfq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cmdnbocodpepfpgpcqcr", white: "endoeofobpcpdqeqfq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-10",
        chapterId: "beginner-level2",
        order: 622,
        title: { zh: "棋形 · 10/14", en: "Shape · 10/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "cpdpepeqer", white: "eofpcqdqfq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "cpdpepeqer", white: "eofpcqdqfq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-11",
        chapterId: "beginner-level2",
        order: 623,
        title: { zh: "棋形 · 11/14", en: "Shape · 11/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "fpgpgqcrdr", white: "epcqdqfqer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "fpgpgqcrdr", white: "epcqdqfqer" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-12",
        chapterId: "beginner-level2",
        order: 624,
        title: { zh: "棋形 · 12/14", en: "Shape · 12/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "bqcqdqfqgqdr", white: "bpcpdpfpeqer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bqcqdqfqgqdr", white: "bpcpdpfpeqer" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-13",
        chapterId: "beginner-level2",
        order: 625,
        title: { zh: "棋形 · 13/14", en: "Shape · 13/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "eneobpcpdpdqbrdr", white: "bocodoepeqer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "weak shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "eneobpcpdpdqbrdr", white: "bocodoepeqer" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-shape-2-14",
        chapterId: "beginner-level2",
        order: 626,
        title: { zh: "棋形 · 14/14", en: "Shape · 14/14" },
        instruction: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_state: { black: "dofodpcqcr", white: "cncocpdqfqdr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的棋块是强形还是弱形？", en: "Does the white group have a strong or weak shape?" },
            options: [{ value: "strong shape", label: { zh: "强形", en: "strong shape" } }, { value: "weak shape", label: { zh: "弱形", en: "weak shape" } }],
            correctValue: "strong shape",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dofodpcqcr", white: "cncocpdqfqdr" },
            },
        },
    },
];

const bl2CapturingRace1Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capturing-race-1-1",
        chapterId: "beginner-level2",
        order: 627,
        title: { zh: "对杀 · 1/13", en: "Capturing Race · 1/13" },
        instruction: { zh: "数气时，需注意不能总是直接紧气。如果紧气时让自己被打吃，棋子就会被吃。为避免此情况，应先下一手临近着法或先连接棋子。在此例中，白棋不能立即在C点下子，否则会被打吃。白棋必须先在D点下一着临近棋，再紧C点。这需要额外一手。因此，吃掉标记的黑棋串需要三手棋，所以黑棋实际有三口气。同样，黑棋不能立即在B点紧标记的白棋串的气，必须先在A点连接。因此，标记的白棋串也有三口气。白先。下出临近着法，赢得对杀。", en: "When counting liberties, you should be aware that you can't always fill the liberties directly. If you put yourself in atari in filling a liberty, your stone will be captured. In order to avoid this, you should first play an approach move, or first connect your stones. In this example White can not play at C immediately, because he puts his stone in atari. White must first approach point C with an approach move at D. This will cost an extra move. That is why it takes three moves to capture the marked black chain. So, effectively Black has three liberties. Similarly, Black can't immediately fill a liberty of the marked white chain at B. Black must first connect his stones at A. So, the marked white chain also has effectively three liberties. White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "arbpbqcncpdqdrdser", white: "brbscqcrdodpeqfqfrhr" },
            marks: { triangle: "brbscqcrdqdrdser", A: "aq", B: "as", C: "es", D: "fs" },
            correct: ["fs"],
            wrong: ["esfs", "csas"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-2",
        chapterId: "beginner-level2",
        order: 628,
        title: { zh: "对杀 · 2/13", en: "Capturing Race · 2/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnepaqbqcqdqarerfrgrbsfs", white: "goeqfqgqiqbrcrdrhrds" },
            correct: ["hs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-3",
        chapterId: "beginner-level2",
        order: 629,
        title: { zh: "对杀 · 3/13", en: "Capturing Race · 3/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cldndoapbpcpdqeqcrerdses", white: "fmdpepgpbqcqfqbrfrfs" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-4",
        chapterId: "beginner-level2",
        order: 630,
        title: { zh: "对杀 · 4/13", en: "Capturing Race · 4/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blbncngncodoeoepcqdqbrcrbs", white: "boapbpcpdpfpgpbqeqardrfr" },
            correct: ["ds"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-5",
        chapterId: "beginner-level2",
        order: 631,
        title: { zh: "对杀 · 5/13", en: "Capturing Race · 5/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hodpepfpdqhqbrcrfrbsfs", white: "cmdmbobqcqeqardrer" },
            correct: ["aq"],
            wrong: ["dsfq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-6",
        chapterId: "beginner-level2",
        order: 632,
        title: { zh: "对杀 · 6/13", en: "Capturing Race · 6/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fpgphpcqdqeqiqbrdrfriresfs", white: "enbofocpdpepbqfqgqarcrgrcsgs" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-7",
        chapterId: "beginner-level2",
        order: 633,
        title: { zh: "对杀 · 7/13", en: "Capturing Race · 7/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepbqcqfqarcrfrhrcs", white: "bmcodobpcpdqdrbsds" },
            correct: ["ap"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-8",
        chapterId: "beginner-level2",
        order: 634,
        title: { zh: "对杀 · 8/13", en: "Capturing Race · 8/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdpepgpbqcqarbrfrbs", white: "cmbocoapcpdqcrdrcs" },
            correct: ["ao"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-9",
        chapterId: "beginner-level2",
        order: 635,
        title: { zh: "对杀 · 9/13", en: "Capturing Race · 9/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "gnfphpcqdqeqgqbrcrgrbsgs", white: "dmbpcpdpepbqfqardrerfr" },
            correct: ["aq"],
            wrong: ["dsfs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-10",
        chapterId: "beginner-level2",
        order: 636,
        title: { zh: "对杀 · 10/13", en: "Capturing Race · 10/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlcmcnbodoeobpdpbqdqgqdrerfrdsfs", white: "fmdnencofocpephpaqcqfqarbrcrgrhrircsgs" },
            correct: ["fp"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-11",
        chapterId: "beginner-level2",
        order: 637,
        title: { zh: "对杀 · 11/13", en: "Capturing Race · 11/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmdoeocpepgpcqfqcrgrbscsfs", white: "cmdnbocobpdpbqdqeqbrerfrds" },
            correct: ["ar"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-12",
        chapterId: "beginner-level2",
        order: 638,
        title: { zh: "对杀 · 12/13", en: "Capturing Race · 12/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnbocobpcqdqcrerfrcsds", white: "gncpdpepgpbqeqfqbrgrbsfs" },
            correct: ["gs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-1-13",
        chapterId: "beginner-level2",
        order: 639,
        title: { zh: "对杀 · 13/13", en: "Capturing Race · 13/13" },
        instruction: { zh: "白先。下出临近着法，赢得对杀。", en: "White to play. Play an approach move and win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dleneobpcpdpbqeqfqbrdrergres", white: "epfphpcqdqgqcrhrbscsfs" },
            correct: ["gs"],
            wrong: ["hsar"],
        },
    },
];

const bl2CapturingRace2Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capturing-race-2-1",
        chapterId: "beginner-level2",
        order: 640,
        title: { zh: "对杀 · 1/15", en: "Capturing Race · 1/15" },
        instruction: { zh: "如果你的棋块有眼，而对手没有，你在对杀中就有优势。在此例中，白棋有眼而黑棋无眼。黑1后，黑棋有三口气，白棋只有两口，但黑棋仍将输掉对杀。在有眼对无眼的对杀中，无眼方必须先填掉所有公共气，之后才能往眼里下子。因此，有眼方占优。白先。赢得对杀。", en: "If your group has an eye and the group of your opponent has none, you have an advantage in a capturing race. In this example White has an eye and Black none. Black has played 1 and Black's group has three liberties, while White has only two, but Black still will lose the fight. In a capturing race between a one-eye and no-eye group, the side without eyes must first fill in all common liberties. Only after that he can play inside the eye. So, the player who has an eye has an advantage. White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bqbrcncocpdqeqfqfrgrgsbs", white: "cqcrcsdreresdpepfpgphqhr" },
            marks: { 1: "bs", triangle: "cqcrcsdreresdqeqfqfrgrgs" },
            correct: ["hsfsgq", "gqfshs"],
            wrong: ["fsds"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-2",
        chapterId: "beginner-level2",
        order: 641,
        title: { zh: "对杀 · 2/15", en: "Capturing Race · 2/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobobpcpdqfqdrgrbscs", white: "clanbndncodpepcqarbrcr" },
            correct: ["aq"],
            wrong: ["dsaq", "bqaq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-3",
        chapterId: "beginner-level2",
        order: 642,
        title: { zh: "对杀 · 3/15", en: "Capturing Race · 3/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bmcmdndocpbqcqbrasbs", white: "aobocoeodpfpdqcrdrds" },
            correct: ["aq"],
            wrong: ["apbp"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-4",
        chapterId: "beginner-level2",
        order: 643,
        title: { zh: "对杀 · 4/15", en: "Capturing Race · 4/15" },
        instruction: { zh: "如果你自己有眼，必须阻止对手也做出眼。在此例中，白棋应下在A点的要点。无论黑棋如何尝试，气都不够，白棋赢得对杀。白先。赢得对杀。", en: "If you have an eye yourself, you must prevent your opponent from making an eye as well. In this example White should play at the vital point A. Whatever Black tries, he is short on liberties and White wins the capturing race. White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbobpcocqcrdodqdleneqerfn", white: "aqasbqbrcpdpepfqfrgpip" },
            marks: { A: "ds" },
            correct: ["dsescs"],
            wrong: ["dsesfscs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-5",
        chapterId: "beginner-level2",
        order: 644,
        title: { zh: "对杀 · 5/15", en: "Capturing Race · 5/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpephpcqfqgqcrhrcs", white: "apbpcpdqeqarbrdrfrgrds" },
            correct: ["esergs"],
            wrong: ["eserfsgs", "gsbq", "gsbs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-6",
        chapterId: "beginner-level2",
        order: 645,
        title: { zh: "对杀 · 6/15", en: "Capturing Race · 6/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blbncncocpdpepeqbrcrdrds", white: "bobpbqcqdqfqhqarerfres" },
            correct: ["bsaoaq"],
            wrong: ["bsaoanaq", "aobs", "aqbs", "asbs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-7",
        chapterId: "beginner-level2",
        order: 646,
        title: { zh: "对杀 · 7/15", en: "Capturing Race · 7/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmcmemaocododpbqcqarcrasbs", white: "anbnbobpcpepdqeqhqdrcsds" },
            correct: ["apaqap"],
            wrong: ["aqap", "cnap"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-8",
        chapterId: "beginner-level2",
        order: 647,
        title: { zh: "对杀 · 8/15", en: "Capturing Race · 8/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "blclelamdmdnfogocpdpepbqbrcrdrbsds", white: "bmcmcnaobocobpfpipaqcqdqeqfqhqareres" },
            correct: ["an"],
            wrong: ["alap", "doan"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-9",
        chapterId: "beginner-level2",
        order: 648,
        title: { zh: "对杀 · 9/15", en: "Capturing Race · 9/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bkdkalclcmcncocpaqbqbrbs", white: "blbmbnaobobpdpcqdqgqarcrcs" },
            correct: ["am"],
            wrong: ["asam"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-10",
        chapterId: "beginner-level2",
        order: 649,
        title: { zh: "对杀 · 10/15", en: "Capturing Race · 10/15" },
        instruction: { zh: "如果你有眼，可以通过制造公共气来让对手更难应对。对手必须先填掉所有这些公共气。白棋在A点下子可以做出眼，同时制造两口公共气。黑棋必须先填掉这些气，从而来不及赢得对杀。白先。赢得对杀。", en: "If you have an eye, you can make it extra difficult for your opponent by making common liberties. Your opponent has to fill in all those common liberties first. White can make an eye by playing at A and at the same time he creates two common liberties. Black must fill in those liberties and is too late to win the capturing race. White to play. Win the capturing race." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcqdqdrdsfp", white: "asbnbqcocpcrcsen" },
            marks: { A: "br" },
            correct: ["braqbo", "braqao"],
            wrong: ["aqbr", "araq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-11",
        chapterId: "beginner-level2",
        order: 650,
        title: { zh: "对杀 · 11/15", en: "Capturing Race · 11/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bkdkclcmcncobpbqbrbs", white: "bmanbnbodoapcpdpcqgqcrcs" },
            correct: ["ar"],
            wrong: ["aqar", "blaq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-12",
        chapterId: "beginner-level2",
        order: 651,
        title: { zh: "对杀 · 12/15", en: "Capturing Race · 12/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpepbqcqeqarergr", white: "clcodoapbpcpaqdqdrds" },
            correct: ["bs"],
            wrong: ["esbr", "brbsescs", "brbscscr"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-13",
        chapterId: "beginner-level2",
        order: 652,
        title: { zh: "对杀 · 13/15", en: "Capturing Race · 13/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dmbnbodoeoepaqdqcrdrerbscses", white: "goapbpcpdpcqeqfqbrfrfs" },
            correct: ["arbqaoasar", "arbqcoasar"],
            wrong: ["aoarcobq", "coaraobq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-14",
        chapterId: "beginner-level2",
        order: 653,
        title: { zh: "对杀 · 14/15", en: "Capturing Race · 14/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "alblclamcmbncocpfpcqhqbrcr", white: "akbkckekdldmcndnbobpaqbq" },
            correct: ["ao"],
            wrong: ["arao"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-2-15",
        chapterId: "beginner-level2",
        order: 654,
        title: { zh: "对杀 · 15/15", en: "Capturing Race · 15/15" },
        instruction: { zh: "黑先。以有眼对无眼，赢得对杀。", en: "Black to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "ambmdmcndodpcqbrcrdrbsds", white: "bnboapbpcpgpbqdqeqareres" },
            correct: ["an"],
            wrong: ["coan"],
        },
    },
];

const bl2CapturingRace3Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capturing-race-3-1",
        chapterId: "beginner-level2",
        order: 655,
        title: { zh: "对杀 · 1/12", en: "Capturing Race · 1/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcodoapbpcpdqdrercs", white: "dpephpaqbqcqeqfqarfr" },
            correct: ["bscres"],
            wrong: ["esbs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-2",
        chapterId: "beginner-level2",
        order: 656,
        title: { zh: "对杀 · 2/12", en: "Capturing Race · 2/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobococpepbqdqeqhqdrds", white: "bmcmdnfndobpdpaqcqcrbscs" },
            correct: ["ar"],
            wrong: ["brap"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-3",
        chapterId: "beginner-level2",
        order: 657,
        title: { zh: "对杀 · 3/12", en: "Capturing Race · 3/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlbndncoapbpcqdqdrerfrds", white: "eocpdpgpaqbqeqfqarcrgrasbs" },
            correct: ["fs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-4",
        chapterId: "beginner-level2",
        order: 658,
        title: { zh: "对杀 · 4/12", en: "Capturing Race · 4/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmcmcnaobocobpfpaqcqdqeqfqhqareres", white: "blclelamdmdnfncpdpepbqbrcrdrbsds" },
            correct: ["an"],
            wrong: ["doan"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-5",
        chapterId: "beginner-level2",
        order: 659,
        title: { zh: "对杀 · 5/12", en: "Capturing Race · 5/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlbncnapbpcpdqeqfqarcrerds", white: "dofodpgpaqbqcqgqbrfrgrbsfs" },
            correct: ["es"],
            wrong: ["epes", "fpes", "ases"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-6",
        chapterId: "beginner-level2",
        order: 660,
        title: { zh: "对杀 · 6/12", en: "Capturing Race · 6/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fphpcqdqeqgqcrgrcsgs", white: "bocpdpepbqfqbrerfrfs" },
            correct: ["ds"],
            wrong: ["bsds"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-7",
        chapterId: "beginner-level2",
        order: 661,
        title: { zh: "对杀 · 7/12", en: "Capturing Race · 7/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlenaobocodoapepaqeqcrdres", white: "gobpcpdpbqdqgqarbrerfr" },
            correct: ["bs"],
            wrong: ["csbsasds", "dsbsfscs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-8",
        chapterId: "beginner-level2",
        order: 662,
        title: { zh: "对杀 · 8/12", en: "Capturing Race · 8/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dlfmaobocodoeoepdqcrdrerasbsds", white: "goapbpcpdpgpcqeqfqbrgr" },
            correct: ["aqarcsbsar"],
            wrong: ["aqarcsbsfrar", "arbq", "frar"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-9",
        chapterId: "beginner-level2",
        order: 663,
        title: { zh: "对杀 · 9/12", en: "Capturing Race · 9/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpaqdqeqfqarfrfs", white: "engodpepgpcqhqbrcrdrhrds" },
            correct: ["bs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-10",
        chapterId: "beginner-level2",
        order: 664,
        title: { zh: "对杀 · 10/12", en: "Capturing Race · 10/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmdmcncododpcqbrcrbsds", white: "anbnboeoapbpcpepdqdrergr" },
            correct: ["ar"],
            wrong: ["esar", "bqar", "aqar"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-11",
        chapterId: "beginner-level2",
        order: 665,
        title: { zh: "对杀 · 11/12", en: "Capturing Race · 11/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncnbobpaqcqdqhqdrfrds", white: "blcmdmdncocpepbqbrcrcs" },
            correct: ["apaoas"],
            wrong: ["apaoaras", "asap", "arap"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-3-12",
        chapterId: "beginner-level2",
        order: 666,
        title: { zh: "对杀 · 12/12", en: "Capturing Race · 12/12" },
        instruction: { zh: "白先。以有眼对无眼，赢得对杀。", en: "White to play. Win the capturing race with one eye against no eye." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbodoeoapbpcpephpbqeqarerases", white: "clbmemancndncodpcqdqbrdrds" },
            correct: ["csbsaqarbs"],
            wrong: ["csbsaqarambs", "csbsaqarasbs", "bscr", "ambs"],
        },
    },
];

const bl2CapturingRace4Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capturing-race-4-1",
        chapterId: "beginner-level2",
        order: 667,
        title: { zh: "对杀 · 1/12", en: "Capturing Race · 1/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "anbncndneofogodpeqarbrcrdr", white: "blcleldmenfnaobocodobpaqbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "anbncndneofogodpeqarbrcrdr", white: "blcleldmenfnaobocodobpaqbq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-2",
        chapterId: "beginner-level2",
        order: 668,
        title: { zh: "对杀 · 2/12", en: "Capturing Race · 2/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bocpdpdqarbrcrbs", white: "aqbqcqgqdrer" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "Black wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bocpdpdqarbrcrbs", white: "aqbqcqgqdrer" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-3",
        chapterId: "beginner-level2",
        order: 669,
        title: { zh: "对杀 · 3/12", en: "Capturing Race · 3/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobobpcpdqdrfrcs", white: "clbmcndodpaqbqcqbrasbs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobobpcpdqdrfrcs", white: "clbmcndodpaqbqcqbrasbs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-4",
        chapterId: "beginner-level2",
        order: 670,
        title: { zh: "对杀 · 4/12", en: "Capturing Race · 4/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmcmemdndpepaqbqcqfqhq", white: "anbncnboapbpcpdqdr" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ambmcmemdndpepaqbqcqfqhq", white: "anbncnboapbpcpdqdr" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-5",
        chapterId: "beginner-level2",
        order: 671,
        title: { zh: "对杀 · 5/12", en: "Capturing Race · 5/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnaobobpcpdqhqcrdrfr", white: "bkbmcmfmdndodpaqbqcqbrasbs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bnaobobpcpdqhqcrdrfr", white: "bkbmcmfmdndodpaqbqcqbrasbs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-6",
        chapterId: "beginner-level2",
        order: 672,
        title: { zh: "对杀 · 6/12", en: "Capturing Race · 6/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "aobocodoepfpgpdqbrcrerhr", white: "dkbmcmemdneofoapbpcpdpbq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "Black wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "aobocodoepfpgpdqbrcrerhr", white: "dkbmcmemdneofoapbpcpdpbq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-7",
        chapterId: "beginner-level2",
        order: 673,
        title: { zh: "对杀 · 7/12", en: "Capturing Race · 7/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmdmbndnaobocodobpcpdqgqhqcrdrfr", white: "blcldlelamcmfmfnhodpepfpgpaqbqcqbrbs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "Black wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmdmbndnaobocodobpcpdqgqhqcrdrfr", white: "blcldlelamcmfmfnhodpepfpgpaqbqcqbrbs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-8",
        chapterId: "beginner-level2",
        order: 674,
        title: { zh: "对杀 · 8/12", en: "Capturing Race · 8/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bnbodofobpcpepaqbqeqdrer", white: "blbmcmemcncodpcqdqarbrcrbs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bnbodofobpcpepaqbqeqdrer", white: "blbmcmemcncodpcqdqarbrcrbs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-9",
        chapterId: "beginner-level2",
        order: 675,
        title: { zh: "对杀 · 9/12", en: "Capturing Race · 9/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bmdmbndnaobocodobpcpdqgqhqiqdrfr", white: "bldlelflamcmenfnhodpepfpgpaqbqcqbrbs" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "bmdmbndnaobocodobpcpdqgqhqiqdrfr", white: "bldlelflamcmenfnhodpepfpgpaqbqcqbrbs" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-10",
        chapterId: "beginner-level2",
        order: 676,
        title: { zh: "对杀 · 10/12", en: "Capturing Race · 10/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dkblclbmcncocpbqhqbrcrdrerfr", white: "elcmdmbnaoboeogobpcqdqeq" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "dkblclbmcncocpbqhqbrcrdrerfr", white: "elcmdmbnaoboeogobpcqdqeq" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-11",
        chapterId: "beginner-level2",
        order: 677,
        title: { zh: "对杀 · 11/12", en: "Capturing Race · 11/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ekbmcmdmgmeneoapbpcpdpcqbrcrasbs", white: "aobocodoepgpdqeqiqdrds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "White wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ekbmcmdmgmeneoapbpcpdpcqbrcrasbs", white: "aobocodoepgpdqeqiqdrds" },
            },
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-4-12",
        chapterId: "beginner-level2",
        order: 678,
        title: { zh: "对杀 · 12/12", en: "Capturing Race · 12/12" },
        instruction: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
        kind: "multipleChoice",
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ckclbmancngncodoeofogpdqeqfqarbrcrdrgrbs", white: "bnboapcpdpepfpaqbqcqgqhqerfrhrds" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能在对杀中获胜吗？", en: "White to play. Can white win the capturing race?" },
            options: [{ value: "White wins", label: { zh: "白棋获胜", en: "White wins" } }, { value: "Black wins", label: { zh: "黑棋获胜", en: "Black wins" } }],
            correctValue: "Black wins",
            board: {
                width: 19,
                height: 19,
                initial_state: { black: "ckclbmancngncodoeofogpdqeqfqarbrcrdrgrbs", white: "bnboapcpdpepfpaqbqcqgqhqerfrhrds" },
            },
        },
    },
];

const bl2CapturingRace5Levels: Level[] = [
    {
        id: "beginner-level2-bl2-capturing-race-5-1",
        chapterId: "beginner-level2",
        order: 679,
        title: { zh: "对杀 · 1/7", en: "Capturing Race · 1/7" },
        instruction: { zh: "如果对手已有眼，可以尝试使其成为假眼。通过在A点扑入，白棋将黑棋的眼变成假眼。现在白棋可以赢得对杀。白先。通过扑入赢得对杀。", en: "If your opponent already has an eye, you can try to make it a false eye. By throwing in at A, White makes the black eye false. Now White can win the capturing race. White to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "apbpcocpcrdldodqdseqesfqfr", white: "aqarbqbscqcsdpepfpgqgrhp" },
            marks: { A: "dr" },
            correct: ["drergsbrdrcrfs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-2",
        chapterId: "beginner-level2",
        order: 680,
        title: { zh: "对杀 · 2/7", en: "Capturing Race · 2/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "clbocodoeodpeqbrerbscses", white: "bpepfpbqdqfqarcrdrfrhr" },
            correct: ["cqcpdscqap", "cqcpdscqaqapao"],
            wrong: ["cqcpapfs", "dscq", "cpfs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-3",
        chapterId: "beginner-level2",
        order: 681,
        title: { zh: "对杀 · 3/7", en: "Capturing Race · 3/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "aobocodofoapepeqdr", white: "bpcpdpaqdqgqarbrerfr" },
            correct: ["bqcqcrbqbs"],
            wrong: ["bqcqcrbqasbs", "cqbq", "crbq"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-4",
        chapterId: "beginner-level2",
        order: 682,
        title: { zh: "对杀 · 4/7", en: "Capturing Race · 4/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cnbpcpcqdqcrer", white: "bqeqfqgqbrdrcsds" },
            correct: ["bsasesbsaq", "bsasesbsaraqap"],
            wrong: ["bsasaqfr", "esbs", "asfr"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-5",
        chapterId: "beginner-level2",
        order: 683,
        title: { zh: "对杀 · 5/7", en: "Capturing Race · 5/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hodqeqhqcrdrfrgr", white: "cocpfpcqfqbrercsdses" },
            correct: ["bsasfsbsbq"],
            wrong: ["fsbs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-6",
        chapterId: "beginner-level2",
        order: 684,
        title: { zh: "对杀 · 6/7", en: "Capturing Race · 6/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cpdpbqdqeqfqarbrfrhr", white: "cnbobpcqcrdrerbses" },
            correct: ["csdsfs"],
            wrong: ["fscs", "dscs"],
        },
    },
    {
        id: "beginner-level2-bl2-capturing-race-5-7",
        chapterId: "beginner-level2",
        order: 685,
        title: { zh: "对杀 · 7/7", en: "Capturing Race · 7/7" },
        instruction: { zh: "黑先。通过扑入赢得对杀。", en: "Black to play. Win the capturing race by throwing in." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bnbpcpdpcqeqerdses", white: "fnepfpaqbqdqfqcrdrhrbs" },
            correct: ["brarcsbrap"],
            wrong: ["brarapfr", "csbr", "apbr"],
        },
    },
];

export const LEVELS: Level[] = [
    ...bl2SekiLevels,
    ...bl2AtariLevels,
    ...bl2ChaseDownLevels,
    ...bl2SnapbackLevels,
    ...bl2NetLevels,
    ...bl2Capture1Levels,
    ...bl2Capture2Levels,
    ...bl2ThrowIn1Levels,
    ...bl2ThrowIn2Levels,
    ...bl2Capture3Levels,
    ...bl2ConnectLevels,
    ...bl2Cut1Levels,
    ...bl2Cut2Levels,
    ...bl2OpeningLevels,
    ...bl2Corner1Levels,
    ...bl2Corner2Levels,
    ...bl2Defense1Levels,
    ...bl2Defense2Levels,
    ...bl2Defense3Levels,
    ...bl2MiaiLevels,
    ...bl2Eye1Levels,
    ...bl2Eye2Levels,
    ...bl2Eye3Levels,
    ...bl2Endgame1Levels,
    ...bl2Endgame2Levels,
    ...bl2Endgame3Levels,
    ...bl2Endgame4Levels,
    ...bl2Endgame5Levels,
    ...bl2LifeDeath1Levels,
    ...bl2LifeDeath2Levels,
    ...bl2LifeDeath3Levels,
    ...bl2LifeDeath4Levels,
    ...bl2LifeDeath5Levels,
    ...bl2LifeDeath6Levels,
    ...bl2Ko1Levels,
    ...bl2Ko2Levels,
    ...bl2Ko3Levels,
    ...bl2Haengma1Levels,
    ...bl2Haengma2Levels,
    ...bl2Haengma3Levels,
    ...bl2Haengma4Levels,
    ...bl2Haengma5Levels,
    ...bl2Shape1Levels,
    ...bl2Shape2Levels,
    ...bl2CapturingRace1Levels,
    ...bl2CapturingRace2Levels,
    ...bl2CapturingRace3Levels,
    ...bl2CapturingRace4Levels,
    ...bl2CapturingRace5Levels,
];
